const _ = {
  BR_ACCESS_TOKEN_INVALID: "Tài khoản đăng nhập không hợp lệ",
  BR_ACCOUNT_BANNED: "Tài khoản đã bị cấm",
  BR_ACCOUNT_NOT_EXIST: "Tài khoản không tồn tại",
  BR_ACCOUNT_NOT_FOUND: "Tài khoản không tồn tại",
  BR_ACCUMULATED_DATA_LENGTH_LIMIT: "Lỗi: tên bảng dữ liệu không được vượt quá 30 ký tự",
  BR_ACTIVATION_CODE_NOT_EXIST: "Mã kích hoạt không tồn tại",
  BR_ACTIVATION_CODE_USED: "Mã kích hoạt đã được sử dụng",
  BR_ACTIVATION_INVALIDE_FORMAT: "Định dạng Mã kích hoạt không hợp lệ",
  BR_ACTIVATION_INVALIDE_LENGHTH: "Độ dài Mã kích hoạt không hợp lệ",
  BR_BINDINGING_FAILURE: "Liên kết thất bại. Vui lòng thử lại.",
  BR_CONTAINS_DIRTY_WORDS: "Chuỗi văn bản chứa từ ngữ nhạy cảm",
  BR_CONTAINS_SPECIAL_CHARS: "Ký tự không đúng yêu cầu",
  BR_DISABLE_LOGIN: "Không được phép đăng nhập",
  BR_DRECTORY_NOT_PREPARED: "Truy cập nhật ký thất bại",
  BR_DUPLICATE_LEADERBOARD_NAME: "Tên trên bảng xếp hạng đã tồn tại, vui lòng sử dụng tên khác",
  BR_DUPLICATE_NICKNAME: "Trùng tên",
  BR_DUPLICATE_SHEET_NAME: "Tên bảng đã tồn tại, vui lòng sử dụng tên khác",
  BR_EXTENSION_DULICATED_NAME: "Trùng plug-in",
  BR_EXTENSION_NOT_FOUND: "Không tìm thấy plug-in",
  BR_FF_COST_OVERFLOW: "Đã đạt trị giá tối đa",
  BR_FF_EXPORT_INVALID_ENTITY: "Xuất dữ liệu vật thể trường cảnh thất bại",
  BR_FF_EXPORT_NO_SCENE: "Không tìm thấy trường cảnh chính",
  BR_FF_EXPORT_NO_WORKFLOW: "Không tìm thấy thiết lập toàn cục",
  BR_FF_LEADERBOARD_COUNT_LIMIT: "Giới hạn bảng xếp hạng",
  BR_FF_SHEET_COUNT_LIMIT: "Đã quá giới hạn bảng dữ liệu ",
  BR_FF_TELEPORTER_UNPAIRED: "Vật thể dịch chuyển không phù hợp",
  BR_FF_WEB_PROXY_HTTP_FAILED: "Máy chủ phản hồi thất bại",
  BR_FF_WORKSHOP_INVALID_EXPORT_SETTINGS_LENGTH: "Kích thước tệp xuất của bản đồ này vượt quá 2.5 MB. Vui lòng chỉnh sửa và thử lại.",
  BR_FF_WORKSHOP_INVALID_MAP_COVER_LENGTH: "Kích thước tệp nền của bản đồ này vượt quá 10 MB. Vui lòng chỉnh sửa và thử lại.",
  BR_FF_WORKSHOP_INVALID_MAX_MEMBER_NUM: "Số lượng người chơi tối đa của bản đồ vượt quá 30. Vui lòng chỉnh sửa và thử lại.",
  BR_FF_WORKSHOP_INVALID_OPEN_ATTRIBUTES_EXT_LENGTH: "Kích thước tệp tham số của bản đồ này vượt quá 2 MB. Vui lòng chỉnh sửa và thử lại.",
  BR_FF_WORKSHOP_INVALID_PROJECT_SETTINGS_LENGTH: "Kích thước tệp dự án của bản đồ này vượt quá 2 MB. Vui lòng chỉnh sửa và thử lại.",
  BR_FILE_EXISTED: "Tệp đã tồn tại",
  BR_FILE_IMPORT_ERROR: "Nhập file thất bại",
  BR_FILE_NOT_FOUND: "Không tìm thấy tệp",
  BR_FILE_OUT_OF_ASSET_FOLDER: "Không thể lưu tệp bên ngoài nhật ký Tài Nguyên",
  BR_FILE_OUT_OF_PROJECT_FOLDER: "Không thể lưu tệp bên ngoài nhật ký dự án",
  BR_GAME_ACCOUNT_ALREADY_BOUND: "Đã liên kết tài khoản trò chơi",
  BR_GAME_ACCOUNT_NOT_BOUND: "Chưa liên kết tài khoản trò chơi",
  BR_GAME_ACCOUNT_NOT_FOUND: "Tài khoản trò chơi không tồn tại",
  BR_INVALID_ARGUMENTS: "Tham số không hợp lệ",
  BR_INVALID_FILE: "Tệp lỗi",
  BR_IPC_CLOSED: "Máy chủ ICP đã đóng",
  BR_IPC_CONNECTED: "Đã kết nối Máy chủ ICP",
  BR_IPC_CREATE_CLIENT_FAILED: "Máy chủ ICP không thể tạo máy khách",
  BR_IPC_IN_PROGRESS: "Đang kết nối Máy chủ ICP",
  BR_IPC_SAME_ADDR_NOT_ALLOWED: "Trùng vị trí máy chủ ICP",
  BR_LEADERBOARD_NAME_LENGTH_LIMIT: "Lỗi, tên trong bảng không được vượt quá 30 ký tự",
  BR_NICKNAME_ILLEGAL: "Biệt danh không hợp lệ. Vui lòng thay đổi.",
  BR_NICKNAME_OCCUPIED: "Biệt danh đã có người sử dụng. Vui lòng thay đổi.",
  BR_NOT_IMPLEMENTED: "Phương thức chưa được hoàn thành",
  BR_NOT_IN_FOLDER: "Tệp không có trong dự án",
  BR_OK: "Không có lỗi",
  BR_PROJECT_CORRUPTED: "Tệp tin đã bị lỗi",
  BR_PROJECT_EXISTED: "Dự án đã tồn tại",
  BR_PROJECT_FOLDER_NOT_EMPTY: "Nhật ký dự án không trống",
  BR_PROJECT_INTERNAL_ONLY: "Chỉ sử dụng nội bộ.",
  BR_PROJECT_NOT_FOUND: "Tài khoản không tồn tại",
  BR_PROJECT_NOT_OPENED: "Chưa mở dự án",
  BR_SETTINGS_SIZE_INVALID: "Độ dài tệp cài đặt không hợp lệ",
  BR_SHAREDATA_KEY_NOT_EXIST: "Chỉ mục dữ liệu được chia sẻ không tồn tại",
  BR_SHEET_NAME_LENGTH_LIMIT: "Lỗi: tên lưu trữ trong bảng không được vượt quá 30 ký tự",
  BR_STR_ENCODE_INVALID: "Tài khoản đăng nhập không hợp lệ",
  BR_STR_LENGTH_INVALID: "Lỗi độ dài",
  BR_USER_CANCEL: "Bị hủy bởi người dùng",
  ECA_DES: "Tùy chỉnh bật/tắt UI ",
  ECA_DES_1: "Thêm lượng vũ khí, vật phẩm, giáp bất kỳ cho người chơi",
  ECA_NAME: "Bật/tắt UI",
  ECA_NAME_1: "Thêm vật thể",
  FE_00_LOOT_SIGHT_TYPE: "Độ phóng đại điểm nhặt đồ",
  FE_00_LOOT_WEAPON_TYPE: "Loại vũ khí điểm nhặt đồ",
  FE_00_MOVEOBJECT_MOTION_TYPE: "Chế độ của vật thể di chuyển",
  FE_00_M_WS_AITYPE: "Thực thể AI",
  FE_00_ONCLICK: "Khi nút được bấm",
  FE_00_RESETABLE_ENTITY: "Thực thể có thể làm mới",
  FE_00_T_WS_MUSICTYPE_DRUM_TITLE: "Loại khóa Trống",
  FE_00_T_WS_MUSICTYPE_L1_TITLE: "Khóa A đàn Synthesizer",
  FE_00_T_WS_MUSICTYPE_L2_TITLE: "Khóa B đàn Synthesizer",
  FE_00_T_WS_MUSICTYPE_L3_TITLE: "Khóa C đàn Synthesizer",
  FE_00_T_WS_MUSICTYPE_PIANO_TITLE: "Loại khóa âm nhạc",
  FE_0_B_BORDER_COLOR: "Màu viền",
  FE_0_B_BORDER_TEXTURE: "Lớp phủ viền",
  FE_0_B_BUILD_FAILED_CONTENT: "Tạo dự án thất bại",
  FE_0_B_BUILD_SUCCESS_CONTENT: "Xây dựng thành công",
  FE_0_B_BUTTON_PUBLISH: "Xuất bản",
  FE_0_B_CUSTOMPROP_COLOR_SELECTED: "Màu",
  FE_0_B_CUSTOMPROP_NOTADDED: "Chưa có thuộc tính được thêm vào",
  FE_0_B_CUSTOMPROP_OPTION: "Tùy chọn",
  FE_0_B_CUSTOMPROP_TYPE_SELECTED: "Chọn một loại",
  FE_0_B_ECA_MORE: "Thêm...",
  FE_0_B_ECA_TIP_SAVE_SELECT: "Trường cảnh này chưa được lưu Không thể chọn vật thể.",
  FE_0_B_ECA_TIP_SELECT: "Vật thể này không thể được chọn",
  FE_0_B_ENSURE_CLOSE_PUBLISH: "Xác nhận rời khỏi quá trình xuất bản?",
  FE_0_B_ITEM_HIDE: "Trốn Tìm",
  FE_0_B_PGC_IN: "Chỉ dành cho nhà thiết kế",
  FE_0_B_PGC_INTERNAL: "Nội bộ PGC",
  FE_0_B_POINT_ADD: "Thêm điểm ngắt",
  FE_0_B_POINT_CLEAR: "Xóa mọi điểm ngắt",
  FE_0_B_POINT_DELETE: "Xóa điểm ngắt",
  FE_0_B_POINT_DISABLE: "Tắt điểm ngắt",
  FE_0_B_POINT_DISABLEALL: "Tắt mọi điểm ngắt",
  FE_0_B_POINT_ENABLE: "Bật điểm ngắt",
  FE_0_B_POINT_ENABLEALL: "Bật mọi điểm ngắt",
  FE_0_B_ROUND_DOING: "Giai đoạn đang diễn ra",
  FE_0_B_ROUND_END: "Kết thúc giai đoạn",
  FE_0_B_ROUND_START: "Bắt đầu giai đoạn",
  FE_0_B_SURFACE_COLOR: "Màu bề mặt",
  FE_0_B_SURFACE_TEXTURE: "Lớp phủ bề mặt",
  FE_0_B_TIP_CUSTOMPROP_COPIED: "Sao chép vào clipboard",
  FE_0_B_TOOL_BUILD: "Máy khách",
  FE_0_B_UI_ANCHOR_MAX: "Neo tối đa",
  FE_0_B_UI_ANCHOR_MIN: "Neo tối thiểu",
  FE_0_B_UI_BACKGROUNDCOLOR: "Màu nền",
  FE_0_B_UI_BOTTOM: "Dưới",
  FE_0_B_UI_CENTER: "Giữa",
  FE_0_B_UI_CUSTOM: "Tùy chỉnh",
  FE_0_B_UI_HEIGHT: "Độ cao",
  FE_0_B_UI_LETF: "Trái",
  FE_0_B_UI_MIDDLE: "Giữa",
  FE_0_B_UI_PIVOT: "Trục",
  FE_0_B_UI_RATIO: "Tỉ lệ",
  FE_0_B_UI_RIGHT: "Phải",
  FE_0_B_UI_STRETCH: "Giãn",
  FE_0_B_UI_TOP: "Trên",
  FE_0_B_UI_TRANSFORM: "Biến đổi UI",
  FE_0_B_UI_WIDTH: "Độ rộng",
  FE_0_B_UI_X: "Tọa độ X",
  FE_0_B_UI_Y: "Tọa độ Y",
  FE_0_B_WORK_EDIT_VARIABLE: "Tùy chỉnh biến",
  FE_0_F_ACTIVATION_ACCOUNT: "Thoát kích hoạt",
  FE_0_F_ACTIVATION_ENTERCODE: "Vui lòng nhập Mã kích hoạt",
  FE_0_F_ACTIVATION_TITLE: "Kích hoạt tài khoản của bạn",
  FE_0_F_ACTIVATION_WARNING: "Xác nhận thoát quá trình kích hoạt?",
  FE_0_F_ATTENTION: "Lưu ý",
  FE_0_F_BINDING_BUTTON1: "Liên kết",
  FE_0_F_BINDING_BUTTON2: "Liên kết ngay",
  FE_0_F_BINDING_BUTTON3: "Hủy liên kết",
  FE_0_F_BINDING_CHANGE: "Liên kết tài khoản khác",
  FE_0_F_BINDING_CONFIRMINFO: "Chúng tôi đã phát hiện tài khoản Free Fire của bạn. Hãy kiểm tra xem đây có phải tài khoản bạn muốn liên kết hay không.",
  FE_0_F_BINDING_NICKNAME: "Tên tài khoản: {0}",
  FE_0_F_BINDING_NOTICE: "Để sử dụng Craftland Studio và truy cập vào các dự án Free Fire, bạn trước tiên phải liên kết với tài khoản Free Fire của mình.",
  FE_0_F_BINDING_NULL: "Chưa có tài khoản được thêm",
  FE_0_F_BINDING_NULL_NOTICE: "Chưa có tài khoản được thêm",
  FE_0_F_BINDING_SUCCESS: "Liên kết thành công!",
  FE_0_F_BINDING_TIPS: "Đang liên kết...",
  FE_0_F_BINDING_TITLE: "Chọn phương pháp đăng nhập",
  FE_0_F_BINDING_UNBIND: "Tài khoản không còn liên kết.",
  FE_0_F_BINDING_UNBIND_TIPS: "Đang hủy liên kết...",
  FE_0_F_BINDING_WARNING: "Bạn phải liên kết tài khoản Free Fire của mình để sử dụng Craftland Studio. Trước hết vui lòng liên kết tài khoản của bạn.",
  FE_0_F_BUTTON_CANCEL: "Hủy",
  FE_0_F_BUTTON_CONFIRM: "Xác nhận",
  FE_0_F_ECA_SCRIPT: "Tập lệnh ECA",
  FE_0_F_INSTALL_INSERVICE: 'Craftland Studio đang chạy. Nhấn "xác nhận" để đóng',
  FE_0_F_INSTALL_INSTALLING: "Đang cài đặt. Vui lòng chờ...",
  FE_0_F_INSTALL_SETUPLOADING: "Vui lòng chờ đợi chương trình khởi chạy...",
  FE_0_F_INSTALL_TITLE: "Cài đặt Craftland Studio",
  FE_0_F_INSTALL_VERIFING: "Xác thực cài đặt: {0}",
  FE_0_F_ITEM_BARRIER: "Rào chắn",
  FE_0_F_ITEM_BASIC_STRUCTURE: "Công trình cơ bản",
  FE_0_F_ITEM_BUILDING: "Kiến trúc",
  FE_0_F_ITEM_CAR: "Xe/Phương tiện",
  FE_0_F_ITEM_COMMON: "Dùng nhiều nhất",
  FE_0_F_ITEM_COMMON_NOTI: "Chưa có vật thể được dùng nhiều. Nhấp phải chuột để thêm.",
  FE_0_F_ITEM_CONTAINER: "Vật thể chứa",
  FE_0_F_ITEM_DECORATION: "Trang trí",
  FE_0_F_ITEM_FENCE: "Tường và Hàng rào",
  FE_0_F_ITEM_FURNITURE: "Nội thất",
  FE_0_F_ITEM_GAMEPLAY: "Vật thể trò chơi",
  FE_0_F_ITEM_HISTORY: "Dùng gần đây",
  FE_0_F_ITEM_HISTORY_DELETENOTI: "Xác nhận xóa danh sách Dùng gần đây?",
  FE_0_F_ITEM_HISTORY_NOTI: "Chưa có vật thể được dùng gần đây. Nhấp phải chuột để thêm.",
  FE_0_F_ITEM_HUGEHOUSE: "Nhà lớn",
  FE_0_F_ITEM_INTERACTIVE: "Tương tác",
  FE_0_F_ITEM_LOOT_AMMO: "Đạn",
  FE_0_F_ITEM_LOOT_AR: "Súng trường",
  FE_0_F_ITEM_LOOT_ARMOR: "Giáp & Balo",
  FE_0_F_ITEM_LOOT_BAG: "Balo",
  FE_0_F_ITEM_LOOT_FRESH: "Tái tạo đơn vị",
  FE_0_F_ITEM_LOOT_GROUP: "Nhóm vật phẩm {0}",
  FE_0_F_ITEM_LOOT_GROUPFRESH: "Tái tạo nhóm",
  FE_0_F_ITEM_LOOT_HELMET: "Mũ",
  FE_0_F_ITEM_LOOT_HG: "Súng lục",
  FE_0_F_ITEM_LOOT_MAGEZINE: "Băng đạn",
  FE_0_F_ITEM_LOOT_MELEE: "Cận chiến",
  FE_0_F_ITEM_LOOT_MUZZLE: "Nòng",
  FE_0_F_ITEM_LOOT_NOTRANDOM: "Đảm bảo",
  FE_0_F_ITEM_LOOT_PARTS: "Phụ kiện",
  FE_0_F_ITEM_LOOT_SG: "Shotgun",
  FE_0_F_ITEM_LOOT_SMG: "Tiểu liên",
  FE_0_F_ITEM_LOOT_SNG: "Súng ngắm",
  FE_0_F_ITEM_LOOT_VEST: "Áo giáp",
  FE_0_F_ITEM_LOOT_WEAPON: "Vũ Khí",
  FE_0_F_ITEM_MIDHOUSE: "Nhà kích cỡ vừa",
  FE_0_F_ITEM_MODENEED: "Buộc có trong chế độ",
  FE_0_F_ITEM_MUSICKEY: "Vật thể âm nhạc",
  FE_0_F_ITEM_OTHERS: "Khác",
  FE_0_F_ITEM_PAD_NUM: "Tổng: {0}",
  FE_0_F_ITEM_PIPE: "Đường ống",
  FE_0_F_ITEM_PLANT: "Thực vật",
  FE_0_F_ITEM_PORTAL_PROPERTY: "Liên kết cổng dịch chuyển",
  FE_0_F_ITEM_SPAWN_PROPERTY: "Người chơi tối đa mỗi cổng",
  FE_0_F_ITEM_STREETSCAPE: "Trang trí",
  FE_0_F_ITEM_STRUCTURE: "Vật thể công trình",
  FE_0_F_ITEM_TRIGGER: "Vật kích hoạt",
  FE_0_F_ITEM_TYRE_PROPERTY: "Phạm vi nảy bật",
  FE_0_F_LANGUAGE_CNTRA: "Tiếng Trung Phồn Thể",
  FE_0_F_LANGUAGE_EN: "Tiếng Anh",
  FE_0_F_LAUNCH_ACCOUNTCHECK: "Xác thực thông tin tài khoản",
  FE_0_F_LAUNCH_SETTING: "Thiết lập ban đầu",
  FE_0_F_LAUNCH_UPDATE: "Cập nhật phiên bản",
  FE_0_F_LAUNCH_VERSIONCHECK: "Kiểm tra phiên bản",
  FE_0_F_LOGIN: "Đăng nhập",
  FE_0_F_LOGIN_CANCEL: "Đăng nhập thất bại. Người chơi đã hủy đăng nhập.",
  FE_0_F_LOGIN_PRIVACY_POLICY: "Chính sách riêng tư",
  FE_0_F_LOGIN_SERVICE: "Điều khoản dịch vụ",
  FE_0_F_LOGIN_TITLE: "Vui lòng chọn phương thức đăng nhập",
  FE_0_F_LOGOUT_WRANING: "Xác nhận đăng xuất?",
  FE_0_F_NAME: "Tên",
  FE_0_F_NAME_PROPERTY: "Thuộc tính",
  FE_0_F_NICKNAME_TIPS1: "Thay đổi biệt danh thành công",
  FE_0_F_NOT_ADDED: "Chưa được thêm",
  FE_0_F_NO_CONTENT_ADDED: "Chưa có nội dung được thêm",
  FE_0_F_PROGRESS: "Tiến trình {0}%",
  FE_0_F_PROJECT_ABOUT: "Thông tin",
  FE_0_F_PROJECT_ALL: "Tất cả",
  FE_0_F_PROJECT_AMEND_DATE: "Ngày chỉnh sửa",
  FE_0_F_PROJECT_BIND: "Liên kết tài khoản",
  FE_0_F_PROJECT_CLOSE: "Xác nhận thoát?",
  FE_0_F_PROJECT_DECREMENT: "Hạ xuống",
  FE_0_F_PROJECT_DELETE_LOCAL: "Đồng thời xóa tệp cục bộ",
  FE_0_F_PROJECT_DELETE_TITLE: "Xóa dự án",
  FE_0_F_PROJECT_DELETE_WARNING: "Xác nhận xóa dự án {0}?",
  FE_0_F_PROJECT_ECA: "ECA",
  FE_0_F_PROJECT_FAVORITE: "Yêu thích",
  FE_0_F_PROJECT_FITEM: "fItem",
  FE_0_F_PROJECT_FOLDER: "Thư mục",
  FE_0_F_PROJECT_FSCENEPREFAB: "fScenePrefab",
  FE_0_F_PROJECT_IMPORT: "Nhập liệu",
  FE_0_F_PROJECT_INCREMENT: "Nâng lên",
  FE_0_F_PROJECT_IN_SEARCH: "Tìm kiếm",
  FE_0_F_PROJECT_LANSET: "Ngôn ngữ",
  FE_0_F_PROJECT_LARGE: "Lớn",
  FE_0_F_PROJECT_LASTOPEN: "Truy cập lần cuối: ",
  FE_0_F_PROJECT_LIST: "Danh sách",
  FE_0_F_PROJECT_LOADING: "Đang tải dự án",
  FE_0_F_PROJECT_LOCAL: "Mở Tệp cục bộ",
  FE_0_F_PROJECT_LOGOUT: "Đăng xuất",
  FE_0_F_PROJECT_MANAGE: "Tạo trò chơi",
  FE_0_F_PROJECT_MEDIUM: "Trung bình",
  FE_0_F_PROJECT_MODE: "Chế độ chơi",
  FE_0_F_PROJECT_MYPRO: "Dự án của tôi",
  FE_0_F_PROJECT_NAME: "Tên dự án",
  FE_0_F_PROJECT_NEW: "Dự án mới",
  FE_0_F_PROJECT_NEW_ECA: "ECA mới",
  FE_0_F_PROJECT_NEW_FOLDER: "Thư mục mới",
  FE_0_F_PROJECT_NEW_UI: "UI mới",
  FE_0_F_PROJECT_NEW_WARNING: "Tên dự án không được bỏ trống.",
  FE_0_F_PROJECT_NULL_NOTICE: "Tên dự án không được bỏ trống.",
  FE_0_F_PROJECT_PATH: "Đường dẫn",
  FE_0_F_PROJECT_PIC: "Hình ảnh",
  FE_0_F_PROJECT_PREFAB: "Thành phần ghép sẵn",
  FE_0_F_PROJECT_RENAME_NOTICE: "Tên không được chứa các ký hiệu đặc biệt như *, /, \\.",
  FE_0_F_PROJECT_RENAME_WARNING: "Tên đang chứa từ ngữ nhạy cảm",
  FE_0_F_PROJECT_SCENE: "Trường cảnh",
  FE_0_F_PROJECT_SCRIPT: "Tập lệnh",
  FE_0_F_PROJECT_SIZE: "Kích thước",
  FE_0_F_PROJECT_SMALL: "Nhỏ",
  FE_0_F_PROJECT_SORT_BY: "Sắp xếp theo",
  FE_0_F_PROJECT_TEXT: "Văn bản",
  FE_0_F_PROJECT_TEXTURE: "Lớp phủ",
  FE_0_F_PROJECT_TREE_VIEW: "Hiển thị biểu đồ cây",
  FE_0_F_PROJECT_UI: "Tệp UI",
  FE_0_F_PROJECT_UPDATE: "Kiểm tra cập nhật",
  FE_0_F_RUNTIME_ADDBOT: "Thêm Bot",
  FE_0_F_RUNTIME_CLIENT: "Máy khách",
  FE_0_F_RUNTIME_COMMAND: "Câu lệnh",
  FE_0_F_RUNTIME_CONSOLE_COMMAND: "Đang thực thi {0} lệnh",
  FE_0_F_RUNTIME_END_BACK: "Trở về trình thiết kế",
  FE_0_F_RUNTIME_END_NOTICE: "Tiến trình trò chơi hiện tại đang bất thường",
  FE_0_F_RUNTIME_END_RESTART: "Khởi động lại",
  FE_0_F_RUNTIME_END_TITLE: "Thoát tiến trình",
  FE_0_F_RUNTIME_GODMODE: "Bất tử",
  FE_0_F_RUNTIME_KEYBOARD: "Bàn phím",
  FE_0_F_RUNTIME_LOADING: "Trò chơi đang tải",
  FE_0_F_RUNTIME_PAUSE: "Tạm dừng",
  FE_0_F_RUNTIME_RECORD: "Nhật ký",
  FE_0_F_RUNTIME_RECOVER: "Hồi phục HP",
  FE_0_F_RUNTIME_RUN: "Chạy",
  FE_0_F_RUNTIME_STOP: "Dừng",
  FE_0_F_RUNTIME_SUICIDE: "Tự sát",
  FE_0_F_RUNTIME_TELEPORT: "Dịch chuyển đến Điểm Khởi Đầu",
  FE_0_F_SCENE: "Trường cảnh {0}",
  FE_0_F_SCENE_AUTOFILL: "Tự động điền vào",
  FE_0_F_SCENE_EDITOR_ISO: "Iso",
  FE_0_F_SCENE_EDITOR_PERSP: "Persp",
  FE_0_F_SCENE_ITEM_COMMON: "Đưa vào Dùng nhiều nhất",
  FE_0_F_SCENE_ITEM_COMMON_REMOVE: "Loại bỏ khỏi Dùng nhiều nhất",
  FE_0_F_SCENE_ITEM_NEW: "Tạo trên trường cảnh",
  FE_0_F_SCENE_LOADING: "Đang tải trường cảnh",
  FE_0_F_SCENE_NEW: "Trường cảnh mới",
  FE_0_F_SCENE_SAVE: "Lưu trường cảnh",
  FE_0_F_SCENE_SAVE_ALL: "Lưu tất cả trường cảnh",
  FE_0_F_SCENE_TYPE: "Loại bản đồ",
  FE_0_F_SEARCH_NOTI: "Nhập từ khóa để tìm kiếm",
  FE_0_F_SEARCH_NULL: "Không tìm thấy kết quả",
  FE_0_F_TRANSFORM: "Chuyển đổi",
  FE_0_F_TRANSFORM_POSITION: "Vị trí",
  FE_0_F_TRANSFORM_ROTATION: "Xoay",
  FE_0_F_TRANSFORM_SCALE: "Kích cỡ",
  FE_0_F_UNDO_DELETE: "Tiếp tục sẽ xóa {0} thư mục. Xác nhận xóa?",
  FE_0_F_UNINSTALL_CONFIRM: "Xác nhận gỡ cài đặt Craftland Studio?",
  FE_0_F_UNINSTALL_TITLE: "Gỡ cài đặt Craftland Studio",
  FE_0_F_UPDATE: "Cập nhật",
  FE_0_F_UPDATE_FAILURE: "Cập nhật thất bại",
  FE_0_F_UPDATE_RETRY: "Thử lại",
  FE_0_F_VIEW: "Xem",
  FE_0_HW_BUTTON_CANCEL: "Hủy",
  FE_0_HW_BUTTON_COPY: "Sao chép",
  FE_0_HW_BUTTON_NO: "Không",
  FE_0_HW_BUTTON_OK: "Xác nhận",
  FE_0_HW_BUTTON_SAVE: "Lưu",
  FE_0_HW_BUTTON_UNSAVE: "Không lưu",
  FE_0_HW_BUTTON_YES: "Có",
  FE_0_HW_CAMERA_DISTANCE: "Khoảng cách",
  FE_0_HW_CAMERA_FOV: "Phạm vi tầm nhìn",
  FE_0_HW_CAMERA_HORIZONTALANGLE: "Góc ngang",
  FE_0_HW_CAMERA_MODE: "Chế độ camera",
  FE_0_HW_CAMERA_MODE_1: "FF Cổ Điển (Bắn súng)",
  FE_0_HW_CAMERA_MODE_2: "Góc nhìn thứ 3",
  FE_0_HW_CAMERA_MODE_3: "Góc nhìn thứ 1 (Bắn súng)",
  FE_0_HW_CAMERA_MODE_4: "Góc cao",
  FE_0_HW_CAMERA_OFFSET: "Khoảng lệch",
  FE_0_HW_CAMERA_TITLE: "Thiết lập camera",
  FE_0_HW_CAMERA_VERTICALANGLE: "Góc dọc",
  FE_0_HW_CANNOT_PREVIEW: "Không hỗ trợ xem trước",
  FE_0_HW_CATEGORY_COMMON: "Phổ biến",
  FE_0_HW_CATEGORY_DATA: "Dữ liệu",
  FE_0_HW_CATEGORY_ENTITY: "Thực thể",
  FE_0_HW_CATEGORY_EVENT: "Sự kiện",
  FE_0_HW_CATEGORY_EXTERNALFUNCTION: "Vd. Hàm",
  FE_0_HW_CATEGORY_FUNCTION: "Hàm",
  FE_0_HW_CATEGORY_GAME: "Trò chơi",
  FE_0_HW_CATEGORY_LOGIC: "Logic",
  FE_0_HW_CATEGORY_SEARCH: "Tìm kiếm",
  FE_0_HW_CATEGORY_VARIBLE: "Biến",
  FE_0_HW_CTRL_BUTTON: "Nút bấm",
  FE_0_HW_CTRL_GRAPH: "Hình ảnh",
  FE_0_HW_CTRL_INPUT: "Hộp thoại",
  FE_0_HW_CTRL_LAYOUT: "Bố cục",
  FE_0_HW_CTRL_PANEL: "Bảng điều khiển",
  FE_0_HW_CTRL_TEXT: "Văn bản",
  FE_0_HW_CUSTOMPROP_HINT: "Mẹo: Tất cả thay đổi sẽ được áp dụng lên thành phần cùng loại",
  FE_0_HW_CUSTOMPROP_NAME: "Tên thuộc tính",
  FE_0_HW_CUSTOMPROP_NAMEHINT: "Nhập tên",
  FE_0_HW_CUSTOMPROP_SUBTITLE: "Thiết lập thuộc tính của {0}",
  FE_0_HW_CUSTOMPROP_TITLE: "Thuộc tính tùy chọn",
  FE_0_HW_CUSTOMPROP_TYPE: "Loại",
  FE_0_HW_CUSTOMPROP_TYPEHINT: "Nhập giá trị ban đầu của thuộc tính",
  FE_0_HW_CUSTOMPROP_VALUE: "Giá trị ban đầu",
  FE_0_HW_DATA_ALL_COMMENT: "Tất cả",
  FE_0_HW_EDITOR_FLOW: "Trò chơi",
  FE_0_HW_EDITOR_LOGIC: "Logic",
  FE_0_HW_EDITOR_SCENE: "Trường cảnh",
  FE_0_HW_EDITOR_UI: "Thiết kế UI",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_END: "Kết thúc",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_FLOW: "Thiết lập quy trình",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PHASE: "Giai đoạn",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PLAYER: "Thiết lập người chơi",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_PREPARE: "Chuẩn bị",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_ROUND: "Vòng đấu",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_START: "Bắt đầu",
  FE_0_HW_GAME_EDITOR_DEFAULTNAME_TEAM: "Thiết lập đội",
  FE_0_HW_GAME_EDITOR_FLOWSETTING: "Thiết lập quy trình",
  FE_0_HW_GAME_EDITOR_FLOW_END: "Kết thúc",
  FE_0_HW_GAME_EDITOR_FLOW_PHASE: "Giai đoạn",
  FE_0_HW_GAME_EDITOR_FLOW_PREPARE: "Chuẩn bị",
  FE_0_HW_GAME_EDITOR_FLOW_ROUND: "Vòng đấu",
  FE_0_HW_GAME_EDITOR_FLOW_START: "Bắt đầu",
  FE_0_HW_GAME_EDITOR_INSPECT_ACTIVESKILL: "Kỹ năng chủ động",
  FE_0_HW_GAME_EDITOR_INSPECT_DAMAGEINFLICTED: "Hệ số sát thương",
  FE_0_HW_GAME_EDITOR_INSPECT_DAMAGETAKEN: "Hệ số nhận sát thương",
  FE_0_HW_GAME_EDITOR_INSPECT_DEFAULTEPPERCENT: "Tỉ lệ EP ban đầu",
  FE_0_HW_GAME_EDITOR_INSPECT_ECA: "Thiết kế Logic",
  FE_0_HW_GAME_EDITOR_INSPECT_EPQUICKRESTORE: "Chuyển hóa EP nhanh",
  FE_0_HW_GAME_EDITOR_INSPECT_ID: "ID",
  FE_0_HW_GAME_EDITOR_INSPECT_JUMPHEIGHT: "Độ nhảy cao",
  FE_0_HW_GAME_EDITOR_INSPECT_MAXEP: "EP tối đa",
  FE_0_HW_GAME_EDITOR_INSPECT_MAXHP: "HP tối đa",
  FE_0_HW_GAME_EDITOR_INSPECT_MOVESPEED: "Tốc độ di chuyển",
  FE_0_HW_GAME_EDITOR_INSPECT_NAME: "Tên",
  FE_0_HW_GAME_EDITOR_INSPECT_PASSIVESKILL: "Kỹ năng bị động",
  FE_0_HW_GAME_EDITOR_INSPECT_PLAYERNUMPERTEAM: "Số người chơi mỗi đội ",
  FE_0_HW_GAME_EDITOR_INSPECT_ROUNDCOUNT: "Số vòng đấu",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET10: "Kỹ năng Chrono",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET11: "Kỹ năng Skyler",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET12: "Kỹ năng Xayne",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET13: "Kỹ năng Dimitri",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET4: "Kỹ năng Tôn Ngộ Không",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET5: "Kỹ năng A124",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET6: "Kỹ năng Alok",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET7: "Kỹ năng Steffie",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET8: "Kỹ năng Clu",
  FE_0_HW_GAME_EDITOR_INSPECT_SKILLSET9: "Kỹ năng K",
  FE_0_HW_GAME_EDITOR_INSPECT_TEAMNUM: "Số đội",
  FE_0_HW_GAME_EDITOR_INSPECT_TIME: "Thời gian",
  FE_0_HW_GAME_EDITOR_INSPECT_TITLE_BASIC: "Thiết lập cơ bản",
  FE_0_HW_GAME_EDITOR_INSPECT_TITLE_SKILL: "Thiết lập kỹ năng",
  FE_0_HW_GAME_EDITOR_INSPECT_UNLIMITEDAMMO: "Giới hạn đạn",
  FE_0_HW_GAME_EDITOR_PLAYERSETTING: "Thiết lập người chơi",
  FE_0_HW_GAME_EDITOR_TEAMSETTING: "Thiết lập đội",
  FE_0_HW_GENERAL_TEMPLATE: "Mẫu",
  FE_0_HW_GRAPH_ANYTYPE: "Mọi loại",
  FE_0_HW_GRAPH_AS_TYPE: "Chuyển thành",
  FE_0_HW_GRAPH_BREAK: "Ngắt",
  FE_0_HW_GRAPH_CALLRETURN: "Trở lại",
  FE_0_HW_GRAPH_CONTINUE: "Tiếp tục",
  FE_0_HW_GRAPH_CREATELIST: "Định nghĩa mảng",
  FE_0_HW_GRAPH_ELSE: "Else",
  FE_0_HW_GRAPH_ELSEIF: "Else If",
  FE_0_HW_GRAPH_EXTERNALCALL: "Gọi giá trị ngoài",
  FE_0_HW_GRAPH_EXTERNAL_GET: "Lấy biến ngoài",
  FE_0_HW_GRAPH_EXTERNAL_GET_2: "Từ",
  FE_0_HW_GRAPH_EXTERNAL_SET: "Thiết lập biến ngoài",
  FE_0_HW_GRAPH_EXTERNAL_SET_3: "Với",
  FE_0_HW_GRAPH_FLOAT: "Float",
  FE_0_HW_GRAPH_FOREACH: "Với mỗi",
  FE_0_HW_GRAPH_FOREACH_2: "Trong",
  FE_0_HW_GRAPH_FOR_INDEX: "Dấu chỉ vòng lập for",
  FE_0_HW_GRAPH_FOR_INDEX_1: "Từ",
  FE_0_HW_GRAPH_FOR_INDEX_2: "Đến",
  FE_0_HW_GRAPH_FOR_INDEX_3: "Bước",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_ACT: "Hành động",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_RETURN: "Trả về",
  FE_0_HW_GRAPH_FUNCTION_DEFINE_VAL: "Hàm",
  FE_0_HW_GRAPH_FUNCTION_MUTATOR_PARA: "Tham số",
  FE_0_HW_GRAPH_GET_CUSTOM_INSP: "Lấy thuộc tính thực thể",
  FE_0_HW_GRAPH_GLOBAL_GET: "Nhận biến toàn cục",
  FE_0_HW_GRAPH_GLOBAL_SET: "Thiết lập biến toàn cục",
  FE_0_HW_GRAPH_GLOBAL_SET_1: "Với",
  FE_0_HW_GRAPH_IF: "If",
  FE_0_HW_GRAPH_INDEX: "Dấu chỉ",
  FE_0_HW_GRAPH_INT: "Int",
  FE_0_HW_GRAPH_LISTAPPEND: "Thêm vào danh sách",
  FE_0_HW_GRAPH_LISTAPPEND_1: "Với giá trị",
  FE_0_HW_GRAPH_LISTGET: "Lấy",
  FE_0_HW_GRAPH_LISTINSERT: "Chèn vào danh sách",
  FE_0_HW_GRAPH_LISTINSERT_1: "Với giá trị",
  FE_0_HW_GRAPH_LISTINSERT_2: "Ở",
  FE_0_HW_GRAPH_LISTSET: "Thiết lập",
  FE_0_HW_GRAPH_LISTTYPELABEL: "Danh sách",
  FE_0_HW_GRAPH_NONE: "Chưa được chọn",
  FE_0_HW_GRAPH_NULL: "Null",
  FE_0_HW_GRAPH_NUMBER: "Số",
  FE_0_HW_GRAPH_OP_AND: "Và",
  FE_0_HW_GRAPH_OP_OR: "Hoặc",
  FE_0_HW_GRAPH_PARALLELCALL: "Thực thi",
  FE_0_HW_GRAPH_PICK_ENTITY: "Chọn một vật thể trên trường cảnh",
  FE_0_HW_GRAPH_PICK_WIDGET: "Chọn một điều khiển UI",
  FE_0_HW_GRAPH_PROPERTY_GET: "Lấy",
  FE_0_HW_GRAPH_PROPERTY_GET_1: "Từ",
  FE_0_HW_GRAPH_PROPERTY_SET: "Gán",
  FE_0_HW_GRAPH_PROPERTY_SET_2: "Với",
  FE_0_HW_GRAPH_RETURN_SENTENSE: "Trả về",
  FE_0_HW_GRAPH_SERIALCALL: "Đợi",
  FE_0_HW_GRAPH_SET_CUSTOM_INSP: "Thiết lập thuộc tính thực thể",
  FE_0_HW_GRAPH_TEXT: "Văn bản",
  FE_0_HW_GRAPH_UNKOWN_TYPE: "Loại dữ liệu không xác định",
  FE_0_HW_INSPECT_ADD_COMPONENT: "Thêm thành phần",
  FE_0_HW_INSPECT_COPY_PROP: "Sao chép giá trị thuộc tính",
  FE_0_HW_INSPECT_CUSTOMPROP: "Thêm Thuộc tính tùy chọn",
  FE_0_HW_INSPECT_CUSTOM_INSP: "Tùy chỉnh nhóm thuộc tính",
  FE_0_HW_INSPECT_ECA_FILE: "Chặn tệp",
  FE_0_HW_INSPECT_NAME: "Tên",
  FE_0_HW_INSPECT_ONCLICK: "Sự kiện bấm",
  FE_0_HW_INSPECT_PASTE_PROP: "Dán giá trị thuộc tính",
  FE_0_HW_INSPECT_POSITION: "Vị trí",
  FE_0_HW_INSPECT_RESET_PROP: "Làm mới",
  FE_0_HW_INSPECT_ROTATION: "Xoay",
  FE_0_HW_INSPECT_SCALE: "Kéo tỉ lệ kích cỡ",
  FE_0_HW_INSPECT_TITLE_ANCHOR: "Neo",
  FE_0_HW_INSPECT_TITLE_BUTTON: "Nút bấm",
  FE_0_HW_INSPECT_TITLE_BUTTON_ONCLICKS: "Callback Sự Kiện",
  FE_0_HW_INSPECT_TITLE_IMAGE: "Hình ảnh",
  FE_0_HW_INSPECT_TITLE_INPUT: "Hộp thoại",
  FE_0_HW_INSPECT_TITLE_LAYOUT: "Bố cục",
  FE_0_HW_INSPECT_TITLE_TEXT: "Văn bản",
  FE_0_HW_INSPECT_TITLE_TRANSFORM: "Chuyển đổi",
  FE_0_HW_INSPECT_TYPE: "Loại",
  FE_0_HW_INSPECT_VALUE: "Giá trị ban đầu",
  FE_0_HW_LABEL_FILE_NAME: "Tên tệp tin",
  FE_0_HW_LABEL_GRAPH_TEMPLATE_DESC: "Mô tả",
  FE_0_HW_LABEL_GRAPH_TEMPLATE_NAME: "Tên mẫu",
  FE_0_HW_LABEL_GRAPH_VARIABLE_NAME: "Tên biến",
  FE_0_HW_LABEL_GRAPH_VARIABLE_TYPE: "Loại dữ liệu của biến",
  FE_0_HW_LABEL_NO_ECA: "Chưa được thêm vào",
  FE_0_HW_LABEL_TRASHCAN: "Thùng rác",
  FE_0_HW_LAYOUT_CONSOLE: "Bảng điều khiển",
  FE_0_HW_LAYOUT_CONTROL: "Điều khiển",
  FE_0_HW_LAYOUT_GAME: "Trò chơi",
  FE_0_HW_LAYOUT_HIERARCHY: "Cây phân cấp",
  FE_0_HW_LAYOUT_INSPECTOR: "Kiểm tra phần tử",
  FE_0_HW_LAYOUT_MODEL: "Vật thể",
  FE_0_HW_LAYOUT_OVERVIEW: "Tổng quan",
  FE_0_HW_LAYOUT_PROJECT: "Dự án",
  FE_0_HW_LAYOUT_TEMPLATE: "Mẫu",
  FE_0_HW_MENU_ABOUT: "Thông tin",
  FE_0_HW_MENU_ACCOUNT: "Tài khoản",
  FE_0_HW_MENU_ADDCHILD: "Thêm Giai đoạn con",
  FE_0_HW_MENU_ADDPHASE: "Thêm Giai đoạn",
  FE_0_HW_MENU_ADDROUND: "Thêm Vòng đấu",
  FE_0_HW_MENU_ALIGN_ECA: "Sắp xếp Khối",
  FE_0_HW_MENU_API: "API",
  FE_0_HW_MENU_ASSET: "Tài nguyên",
  FE_0_HW_MENU_ASSETSTORE: "Cửa hàng Tài nguyên",
  FE_0_HW_MENU_CANVAS_BG: "Nền",
  FE_0_HW_MENU_CANVAS_DARK: "Tối",
  FE_0_HW_MENU_CANVAS_LIGHT: "Sáng",
  FE_0_HW_MENU_CLEAR_BLOCK: "Xóa Khối",
  FE_0_HW_MENU_COLLAPSE_ECA: "Thu gọn Khối",
  FE_0_HW_MENU_COMMENT_ECA: "Bình luận",
  FE_0_HW_MENU_CONTACT: "Thông tin liên hệ",
  FE_0_HW_MENU_COPY: "Sao chép",
  FE_0_HW_MENU_CREATE: "Mới",
  FE_0_HW_MENU_CUT: "Cắt",
  FE_0_HW_MENU_DEBUG: "Công cụ nhà phát triển",
  FE_0_HW_MENU_DEFAULT: "Mặc định",
  FE_0_HW_MENU_DEFAULT_ZOOM: "Làm mới thu phóng",
  FE_0_HW_MENU_DELETE: "Xóa",
  FE_0_HW_MENU_DELETELAYOUT: "Xóa bố cục",
  FE_0_HW_MENU_DUPLICATE: "Nhân bản",
  FE_0_HW_MENU_EDIT: "Chỉnh sửa",
  FE_0_HW_MENU_EDITOR: "Trình chỉnh sửa",
  FE_0_HW_MENU_EXIT: "Thoát",
  FE_0_HW_MENU_FILE: "Tệp tin",
  FE_0_HW_MENU_FIT_WINDOW: "Vừa vặn",
  FE_0_HW_MENU_GRID_LINE: "Lưới",
  FE_0_HW_MENU_HELP: "Trợ giúp",
  FE_0_HW_MENU_LANGUAGE: "Ngôn ngữ",
  FE_0_HW_MENU_LANG_EN: "Tiếng Anh",
  FE_0_HW_MENU_LANG_SC: "Tiến Trung Giản Thể",
  FE_0_HW_MENU_LANG_TC: "Tiếng Trung Phồn Thể",
  FE_0_HW_MENU_LAYOUT: "Bố cục",
  FE_0_HW_MENU_LOCK: "Khóa",
  FE_0_HW_MENU_MANUAL: "Thủ công",
  FE_0_HW_MENU_NEWPROJECT: "Dự án mới",
  FE_0_HW_MENU_OPEN: "Mở",
  FE_0_HW_MENU_OPENLOG: "Mở Nhật ký",
  FE_0_HW_MENU_OPENPROJECT: "Mở Dự án",
  FE_0_HW_MENU_PASTE: "Dán",
  FE_0_HW_MENU_PUBLISHPROJECT: "Xuất bản Dự án",
  FE_0_HW_MENU_REDO: "Tái thực hiện",
  FE_0_HW_MENU_RENAME: "Đổi tên",
  FE_0_HW_MENU_SAVELAYOUT: "Lưu bố cục",
  FE_0_HW_MENU_SAVEPROJECT: "Lưu Dự án",
  FE_0_HW_MENU_SAVE_BLOCK_AS_TEMP: "Thêm vào Mẫu",
  FE_0_HW_MENU_SAVE_WORKSPACE: "Lưu",
  FE_0_HW_MENU_SETING_COMMON: "Thiết lập Dùng nhiều nhất",
  FE_0_HW_MENU_SETTINGS: "Thiết lập",
  FE_0_HW_MENU_SKIN: "Chủ đề",
  FE_0_HW_MENU_SMART_LINE: "Đường kẻ hướng dẫn",
  FE_0_HW_MENU_UNCOLLAPSE_ECA: "Mở rộng Khối",
  FE_0_HW_MENU_UNDO: "Hoàn tác",
  FE_0_HW_MENU_UNLOCK: "Mở khóa",
  FE_0_HW_MENU_WIDE: "Dàn trang ngang",
  FE_0_HW_MENU_WINDOW: "Cửa sổ",
  FE_0_HW_MENU_ZOOMIN: "Phóng to",
  FE_0_HW_MENU_ZOOMOUT: "Thu nhỏ",
  FE_0_HW_POPUP_DELETE_FILE: "Xác nhận xóa tệp tin {0}?",
  FE_0_HW_POPUP_NOT_SAVE: "Những thông tin được điền sẽ không được lưu nếu bạn quay lại. Xác nhận vẫn quay lại?",
  FE_0_HW_POPUP_NO_ATTENTION: "Không nhắc lại nữa",
  FE_0_HW_POPUP_SAVE_FILE: "Bạn có một tệp chưa lưu. Lưu ngay?",
  FE_0_HW_POPUP_SENTENCE: "Sao chép mã bản đồ. Mời bạn bè cùng chơi!",
  FE_0_HW_POPUP_TITLE_COMMENT: "Bình luận",
  FE_0_HW_POPUP_TITLE_ITEM: "Chọn vật thể",
  FE_0_HW_POPUP_TITLE_MAP_SHARE: "Chia sẻ mã bản đồ",
  FE_0_HW_POPUP_TITLE_ON_PUB: "Xuất bản game",
  FE_0_HW_POPUP_TITLE_PROP: "Chọn vật phẩm",
  FE_0_HW_POPUP_TITLE_PUB_SUCCESS: "Xuất bản thành công",
  FE_0_HW_POPUP_TITLE_TIP: "Mẹo",
  FE_0_HW_PROJECT_COMMENT_ORDER: "Bình luận",
  FE_0_HW_PROJECT_DATA: "Trung tâm dữ liệu",
  FE_0_HW_PROJECT_DEFAULT_ORDER: "Sắp xếp mặc định",
  FE_0_HW_PROJECT_GAME_DATA: "Dữ liệu game",
  FE_0_HW_PROJECT_GAME_MODE: "Chế độ chơi",
  FE_0_HW_PROJECT_GAME_PUBLISH: "Ngày xuất bản",
  FE_0_HW_PROJECT_LIKE_ORDER: "Lượt thích",
  FE_0_HW_PROJECT_PERSONAL_PAGE: "Hồ sơ",
  FE_0_HW_PROJECT_SUB_ORDER: "Yêu thích",
  FE_0_HW_PUBLISH_CREATOR: "Nhà sáng tạo",
  FE_0_HW_PUBLISH_DESCRIPTION: "Mô tả",
  FE_0_HW_PUBLISH_GAME_NAME: "Tên",
  FE_0_HW_PUBLISH_MODE: "Chế độ chơi",
  FE_0_HW_PUBLISH_PLAYER: "Số người chơi",
  FE_0_HW_PUBLISH_SCREENSHOT: "Ảnh chụp",
  FE_0_HW_SEARCH_NO_RESOURCE: "Không tìm thấy tài nguyên",
  FE_0_HW_SEARCH_NO_TARGET: "Không tìm thấy mục tiêu",
  FE_0_HW_SEARCH_PLACEHOLDER: "Tìm kiếm",
  FE_0_HW_TEMPLATE_NAME_1: "Mẫu cơ bản",
  FE_0_HW_TEMPLATE_NAME_2: "Hạ gục",
  FE_0_HW_TEMPLATE_NAME_3: "Ghi điểm",
  FE_0_HW_TEMPLATE_NAME_4: "Vượt chướng ngại vật",
  FE_0_HW_TEMPLATE_NAME_5: "Sinh tồn",
  FE_0_HW_TEXT_ADD_GRAPH_TEMPLATE: "Thêm Mẫu Khối",
  FE_0_HW_TEXT_CUSTOM_GRAPH_TEMPLATE: "Mẫu tùy chỉnh",
  FE_0_HW_TEXT_DEL_GRAPH_TEMPLATE: "Xóa Mẫu Khối",
  FE_0_HW_TEXT_EDIT_GRAPH_TEMPLATE: "Chỉnh sửa Mẫu Khối",
  FE_0_HW_TEXT_OFFICIAL_GRAPH_TEMPLATE: "Mẫu chính thức",
  FE_0_HW_TIP_CHANGE_OWNERTYPE: "Xác nhận thay đổi loại thực thể hiện tại?",
  FE_0_HW_TIP_CHOOSE_SLOT: "Vui lòng chọn một chỗ trống cho trò chơi.",
  FE_0_HW_TIP_COPIED: "Đã sao chép",
  FE_0_HW_TIP_COPY_CODE: "Sao chép Mã trò chơi bên dưới để chia sẻ cùng bạn bè.",
  FE_0_HW_TIP_CUSTOMPROP_SAMENAME: "Có thuộc tính cùng loại đã có tên này",
  FE_0_HW_TIP_CUSTOM_INSP_SAME_NAME: "Có thuộc tính cùng loại đã sử dụng tên này",
  FE_0_HW_TIP_CUSTOM_INSP_STRING_LEN: "Tên không được vượt quá 20 ký tự",
  FE_0_HW_TIP_GRAPH_DELETE: "Xác nhận xóa Mẫu {0}?",
  FE_0_HW_TIP_GRAPH_INPUT_DESC: "Nhập diễn giải cho khối",
  FE_0_HW_TIP_GRAPH_INPUT_NAME: "Nhập tên mẫu",
  FE_0_HW_TIP_GRAPH_TEMPLATE_DESC_LEN: "Mô tả không thể vượt quá {0} ký tự",
  FE_0_HW_TIP_GRAPH_TEMPLATE_NAME_LEN: "Tên mẫu không thể vượt quá {0} ký tự",
  FE_0_HW_TIP_INPUT: "Vui lòng nhập",
  FE_0_HW_TIP_NAME_EMPTY: "Tên tệp không thể bỏ trống",
  FE_0_HW_TIP_NOEXTERNAL: "Khi bạn chưa định nghĩa bất kỳ hàm hay biến ngoài nào, sẽ không có nội dung được hiển thị tại đây.",
  FE_0_HW_TIP_NO_GAME_PUBLISH: "Chưa có dự án game được xuất bản",
  FE_0_HW_TIP_PREPARE_PUBLISH: "Chuẩn bị quá trình xuất bản...",
  FE_0_HW_TIP_PUBLISH_COVER: "Hành động này sẽ thay thế trò chơi đã xuất bản. Xác nhận tiếp tục?",
  FE_0_HW_TIP_PUBLISH_SUCCESS: "Trò chơi của bạn đã được xuất bản thành công!",
  FE_0_HW_TIP_SAVE_SUCCESS: "Lưu thành công",
  FE_0_HW_TIP_TO_CLEAR_TRASHCAN: "Xác nhận dọn thùng rác?",
  FE_0_HW_TIP_TO_SAVE: "Bản sao có thay đổi chưa được lưu. Lưu ngay?",
  FE_0_HW_TIP_UNLOCK_SLOT: "Vui lòng mở khóa ô trống này tại Free Fire Craftland.",
  FE_0_HW_TIP_VALUE_NOT_MATCH: "Giá trị ban đầu được nhập không đúng với kiểu dữ liệu yêu cầu",
  FE_0_HW_TIP_WAIT_PUBLISH: "Đang xuất bản... Vui lòng chờ chút.",
  FE_0_HW_TITLE_PREVIEW: "Xem trước",
  FE_0_HW_TITLE_SAVE_WORK: "Lưu bản sao",
  FE_0_HW_TITLE_SOURCE_MANAGE: "Xem trước Tài nguyên",
  FE_0_HW_TITLE_TIP: "Mẹo",
  FE_0_HW_TOOL_ADSORP_BOTTOM: "Bám dưới",
  FE_0_HW_TOOL_ADSORP_LEFT: "Bám trái",
  FE_0_HW_TOOL_ADSORP_RIGHT: "Bám phải",
  FE_0_HW_TOOL_ADSORP_TOP: "Bám trên",
  FE_0_HW_TOOL_ALIGN_BOTTOM: "Căn dưới",
  FE_0_HW_TOOL_ALIGN_LEFT: "Căn trái",
  FE_0_HW_TOOL_ALIGN_RIGHT: "Căn phải",
  FE_0_HW_TOOL_ALIGN_TOP: "Căn trên",
  FE_0_HW_TOOL_CENTER: "Canh giữa",
  FE_0_HW_TOOL_CENTER_HOR: "Canh giữa theo chiều ngang",
  FE_0_HW_TOOL_CENTER_VER: "Canh giữa theo chiều dọc",
  FE_0_HW_TOOL_CLIENT: "Máy khách (Client)",
  FE_0_HW_TOOL_DISTRI_HOR: "Phân phối ngang",
  FE_0_HW_TOOL_DISTRI_VER: "Phân phối dọc",
  FE_0_HW_TOOL_GLOBAL: "Toàn cục",
  FE_0_HW_TOOL_GRID: "Lưới",
  FE_0_HW_TOOL_GROUP: "Nhóm",
  FE_0_HW_TOOL_HAND: "Chọn",
  FE_0_HW_TOOL_LOCAL: "Cục bộ",
  FE_0_HW_TOOL_MOVE: "Di chuyển",
  FE_0_HW_TOOL_PIVOT: "Xoay",
  FE_0_HW_TOOL_REDO: "Tái thực hiện",
  FE_0_HW_TOOL_ROTATE: "Xoay",
  FE_0_HW_TOOL_SAVE: "Lưu",
  FE_0_HW_TOOL_SCALE: "Kích cỡ",
  FE_0_HW_TOOL_SURF: "Bề mặt",
  FE_0_HW_TOOL_TRANS: "Chuyển đổi",
  FE_0_HW_TOOL_UNDO: "Hoàn tác",
  FE_0_HW_TOOL_UNGROUP: "Hủy nhóm",
  FE_0_HW_TOOL_VERTEX: "Đỉnh",
  FE_0_HW_UI_EDITOR_INSPECT_ACTIVE: "Hữu hình",
  FE_0_HW_UI_EDITOR_INSPECT_BACKGROUND: "Nền",
  FE_0_HW_UI_EDITOR_INSPECT_CELLSIZE: "Kích thước ô",
  FE_0_HW_UI_EDITOR_INSPECT_COLOR: "Màu",
  FE_0_HW_UI_EDITOR_INSPECT_CONSTRAINT: "Mối ràng buộc",
  FE_0_HW_UI_EDITOR_INSPECT_CONS_COLUMN: "Giới hạn cột",
  FE_0_HW_UI_EDITOR_INSPECT_CONS_ROW: "Giới hạn hàng",
  FE_0_HW_UI_EDITOR_INSPECT_DISABLE: "Đã tắt",
  FE_0_HW_UI_EDITOR_INSPECT_DOWN: "Xuống",
  FE_0_HW_UI_EDITOR_INSPECT_FILL_DIRECTION: "Hướng lớp phủ",
  FE_0_HW_UI_EDITOR_INSPECT_FLEX: "Linh hoạt",
  FE_0_HW_UI_EDITOR_INSPECT_FONT: "Phông chữ",
  FE_0_HW_UI_EDITOR_INSPECT_FONTALIGN: "Căn lề văn bản",
  FE_0_HW_UI_EDITOR_INSPECT_FONTSIZE: "Kích thước",
  FE_0_HW_UI_EDITOR_INSPECT_FONTSTYLE: "Phông chữ",
  FE_0_HW_UI_EDITOR_INSPECT_GRID: "Bố cục lưới",
  FE_0_HW_UI_EDITOR_INSPECT_HIGHLIGHT: "Tiêu điểm",
  FE_0_HW_UI_EDITOR_INSPECT_HOR: "Ngang",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT: "Trái",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT_DOWN: "Trái Dưới",
  FE_0_HW_UI_EDITOR_INSPECT_LEFT_UP: "Trái Trên",
  FE_0_HW_UI_EDITOR_INSPECT_LINESPACE: "Khoảng cách dòng",
  FE_0_HW_UI_EDITOR_INSPECT_MAX: "Tối đa",
  FE_0_HW_UI_EDITOR_INSPECT_MAXLENGTH: "Độ dài tối đa",
  FE_0_HW_UI_EDITOR_INSPECT_MIN: "Tối thiểu",
  FE_0_HW_UI_EDITOR_INSPECT_MULTI_LINE: "Nhiều dòng",
  FE_0_HW_UI_EDITOR_INSPECT_NORMAL: "Mặc định",
  FE_0_HW_UI_EDITOR_INSPECT_OFFSET: "Khoảng lệch",
  FE_0_HW_UI_EDITOR_INSPECT_PIVOT: "Giữa",
  FE_0_HW_UI_EDITOR_INSPECT_PLACEHOLDER: "Giữ chỗ",
  FE_0_HW_UI_EDITOR_INSPECT_PRESS: "Đã nhấn",
  FE_0_HW_UI_EDITOR_INSPECT_REVERSE: "Nghịch đảo",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT: "Phải",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT_DOWN: "Phải dưới",
  FE_0_HW_UI_EDITOR_INSPECT_RIGHT_UP: "Phải trên",
  FE_0_HW_UI_EDITOR_INSPECT_SET_NATIVE: "Khôi phục kích thước mặc định",
  FE_0_HW_UI_EDITOR_INSPECT_SINGLE_LINE: "Dòng đơn",
  FE_0_HW_UI_EDITOR_INSPECT_SOURCE: "Nguồn",
  FE_0_HW_UI_EDITOR_INSPECT_SPACE: "Khoảng trống",
  FE_0_HW_UI_EDITOR_INSPECT_START_CORNER: "Hướng ban đầu",
  FE_0_HW_UI_EDITOR_INSPECT_TABLE: "Bố cục lớp phủ",
  FE_0_HW_UI_EDITOR_INSPECT_TEXTINPUT: "Văn bản nhập vào",
  FE_0_HW_UI_EDITOR_INSPECT_TYPE: "Loại",
  FE_0_HW_UI_EDITOR_INSPECT_UNACTIVE: "Vô hình",
  FE_0_HW_UI_EDITOR_INSPECT_UP: "Lên",
  FE_0_HW_UI_EDITOR_INSPECT_VER: "Dọc",
  FE_0_HW_UI_EDITOR_INSPECT_WORDWRAP: "Ngắt dòng",
  FE_0_HW_WARNING_FUNCTIONSIGNATURE_PARAMETERS: "Tham số và kiểu dữ liệu tham số được thiết lập ban đầu không giống với kiểu dữ liệu tham số của hàm. Hãy xác nhận thủ công rằng hàm được gọi là chính xác.",
  FE_0_HW_WARNING_FUNCTIONSIGNATURE_RETURNTYPE: "Kiểu dữ liệu trả về theo thiết lập ban đầu không giống với kiểu dữ liệu trả về của hàm. Hãy xác nhận thủ công rằng hàm được gọi là chính xác.",
  FE_0_HW_WARNING_LOCALVAR_NODEFINE: "Lỗi. Biến cục bộ chưa xác định.",
  FE_0_HW_WARNING_LOCALVAR_OOS: "Lỗi. Vượt quá phạm vi sử dụng biến cục bộ.",
  FE_0_HW_WARNING_NODEFINE: "Lỗi không xác định {0}",
  FE_0_HW_WARNING_PARAM_NODEFINE: "Lỗi biến không xác định {0}",
  FE_0_HW_WARNING_RETURNNOTINFUNCTION: "Bạn chỉ có thể sử dụng lệnh trả về bên trong hàm",
  FE_0_HW_WARNING_TYPEASSIGN: "Kiểu dữ liệu liên kết không đúng",
  FE_0_HW_WORK_CLEAN: "Dọn Thùng rác",
  FE_0_HW_WORK_CREATE_VARIABLE: "Tạo Biến",
  FE_0_M_SENCE_EDIT_NAMEERROR: "Tên chứa ký tự nhạy cảm Vui lòng điều chỉnh.",
  FE_0_Q_FALSE: "FALSE",
  FE_0_Q_SENCE_DEFAULT: "(Trường cảnh mặc định)",
  FE_0_Q_SENCE_ENUM: "Enum của trường cảnh",
  FE_0_Q_SENCE_SETDEFAULT: "Thiết lập là trường cảnh mặc định",
  FE_0_Q_TOKEN_EXPIRED: "Token đã hết hạn, vui lòng đăng nhập lại.",
  FE_0_Q_TRUE: "TRUE",
  FE_0_ZZ_CLEAR: "Xóa sạch",
  FE_0_ZZ_CREATE_EMPTY: "Tạo mẫu trống",
  FE_0_ZZ_ECA_NAME_NOT_EMPTY: "Tên biến không thể để trống",
  FE_0_ZZ_ECA_READ_ONLY: "Chỉ đọc",
  FE_0_ZZ_ECA_TO_DEFINE: "Đến phần Định nghĩa",
  FE_0_ZZ_ECA_VALUE_NOT_MATCH: "Giá trị ban đầu và kiểu dữ liệu ràng buộc không phù hợp",
  FE_0_ZZ_GRAPH_NOT_FOUND: "Không tìm thấy khối",
  FE_0_ZZ_PROJECT_FOLDER_EMPTY: "Nhật ký dự án nên để trống.",
  FE_0_ZZ_PROJECT_PIC_SIZE: "Kích thước biểu tượng",
  FE_0_ZZ_PROJECT_SERVER_OUT: "Hết thời gian kết nối.",
  FE_0_ZZ_PROJECT_TYPE: "Xem",
  FE_0_ZZ_SEARCH_NO_RESULT: "Không tìm thấy kết quả",
  FE_0_ZZ_SHOW_IN_EXPLORER: "Xem trong tài nguyên",
  FE_0_ZZ_SKYENV_AMBIENT: "Màu môi trường",
  FE_0_ZZ_SKYENV_CUSTOM: "Tùy chỉnh",
  FE_0_ZZ_SKYENV_DARK: "Bóng tối",
  FE_0_ZZ_SKYENV_DAY: "Ngày",
  FE_0_ZZ_SKYENV_EVE: "Hoàng hôn",
  FE_0_ZZ_SKYENV_FLARE: "Lóa ống kính",
  FE_0_ZZ_SKYENV_FOG: "Màu sương",
  FE_0_ZZ_SKYENV_LIGHT_COLOR: "Màu ánh sáng",
  FE_0_ZZ_SKYENV_LIGHT_INTENSITY: "Cường độ ánh sáng",
  FE_0_ZZ_SKYENV_NIGHT: "Đêm",
  FE_0_ZZ_SKYENV_NIGHT_MODE: "Chế độ Đêm",
  FE_0_ZZ_SKYENV_SHADOW: "Đổ bóng",
  FE_0_ZZ_SKYENV_SKY: "Nền trời",
  FE_0_ZZ_SKYENV_WETNESS: "Độ ẩm địa hình",
  FE_38_B_CAMERA_DEFAULT: "Sắp xếp mặc định",
  FE_38_B_CHECK: "Hiển thị",
  FE_38_B_CHECK_FAILED: "Không vượt qua kiểm tra",
  FE_38_B_COMPONENTS_CREATECOPY: "Tạo Bản sao",
  FE_38_B_COMPONENTS_CUSTOM: "Thành phần tùy chọn",
  FE_38_B_COMPONENTS_CUSTOM_CREATE: "Tạo Thành phần tùy chọn",
  FE_38_B_COMPONENTS_CUSTOM_DELETE: "Xóa Thành phần",
  FE_38_B_COMPONENTS_EDIT: "Thiết lập thuộc tính thành phần",
  FE_38_B_COMPONENTS_MANAGE: "Xóa Thành phần",
  FE_38_B_COMPONENTS_OFFICAL: "Thành phần chính thức",
  FE_38_B_COMPONENTS_PROPERTIES: "Thuộc tính",
  FE_38_B_COMPONENTS_PROPERTIES_DEFAULT: "Thuộc tính mặc định",
  FE_38_B_COMPONENTS_PROPERTIES_REQUIRE: "Thuộc tính yêu cầu",
  FE_38_B_COMPONENTS_RESET: "Làm mới thành phần",
  FE_38_B_COMPONENTS_TIP_DELETE: "Xóa thành phần này sẽ hủy mối quan hệ yêu cầu. Xác nhận xóa?",
  FE_38_B_COMPONENTS_TIP_REQUIRE: "Thành phần này được yêu cầu bởi các thành phần bên dưới",
  FE_38_B_DEBUGSETTING_ASSIGN_TEAM: "Sắp xếp đội",
  FE_38_B_DEBUGSETTING_AUTO: "Tự động",
  FE_38_B_DEBUGSETTING_AUTO_TEAM: "Tự động xếp đội",
  FE_38_B_DEBUGSETTING_DEBUG_MODE: "Chế độ Debug",
  FE_38_B_DEBUGSETTING_LANG: "Ngôn ngữ Mặc định",
  FE_38_B_DEBUGSETTING_NAME: "Thiết lập Debug",
  FE_38_B_DEBUGSETTING_REMOTE: "Sử dụng Máy chủ Từ xa",
  FE_38_B_DEBUGSETTING_REMOTE_ADDRESS: "Địa chỉ Máy chủ Từ xa",
  FE_38_B_DEBUGSETTING_SIDE_NUMBER: "Số lượng debug máy khách",
  FE_38_B_DEBUGSETTING_STRICT_MODE: "Chế độ Nghiêm ngặt",
  FE_38_B_DEBUGSETTING_TEAM: "Đội {0}",
  FE_38_B_DEBUGSETTING_TEAMUP: "Lập đội",
  FE_38_B_DEBUGSETTING_TOOL: "Công cụ Debug",
  FE_38_B_ECA_ADD_WATCH: "Thêm theo dõi biến",
  FE_38_B_ECA_CALL_FUNCTION: "Gọi Hàm",
  FE_38_B_ECA_CAMERA_ENTITY: "Làm mới thành phần",
  FE_38_B_ECA_CLEAR_WATCH: "Xoá sạch theo dõi biến",
  FE_38_B_ECA_CONDITIONAL_STATEMENT: "Câu lệnh điều kiện",
  FE_38_B_ECA_DEFINE_BEHAVIOR: "Định nghĩa hành vi",
  FE_38_B_ECA_DEFINE_FUNCTION: "Định nghĩa hàm",
  FE_38_B_ECA_DEL_WATCH: "Xóa theo dõi biến",
  FE_38_B_ECA_LIST: "Danh sách ECA",
  FE_38_B_ECA_PARALIST: "Danh sách Tham số",
  FE_38_B_ECA_SET_VARIABLE: "Thiết lập Biến",
  FE_38_B_ECA_SOUND_ENTITY: "Thành phần Thực thể Âm thanh",
  FE_38_B_ECA_TIPSHUD_ENTITY: "Thành phần HUD văn bản",
  FE_38_B_GAME_EDITOR_LOCALIZATIONSETTING: "Bản địa hóa",
  FE_38_B_LOCALIZATION_NEW_CSV: "Tạo file CSV",
  FE_38_B_LOCALIZATION_TIPS1: "Không có file bản địa hóa được liên kết.",
  FE_38_B_LOCALIZATION_TIPS2: "File CSV bản địa hóa phải có định dạng mã hóa là UTF8.",
  FE_38_B_LOCALIZATION_TIPS3: "Không thể tìm thấy {0} trong tệp được liên kết hiện tại.",
  FE_38_B_LOOT_RESET: "Làm mới mỗi Vòng đấu",
  FE_38_B_MENU_DELETE: "Xóa bố cục cửa sổ {0}.",
  FE_38_B_MENU_TIPS1: "Vui lòng nhập tên bố cục.",
  FE_38_B_MENU_TIPS2: "Vui lòng đổi tên.",
  FE_38_B_MENU_TIPS3: "Tên đã được sử dụng. Đổi tên khác không?",
  FE_38_B_MENU_TIPS4: "Token đã hết hạn. Vui lòng đăng nhập lại.",
  FE_38_B_MENU_TIPS5: "Nhấn để xem chi tiết tái định hướng",
  FE_38_B_MENU_WORDFILTER: "Bộ lọc Từ ngữ thô tục",
  FE_38_B_NEW_PROJECT: "Dự án mới",
  FE_38_B_POINT_TIPS_EXCEED: "Số lượng điểm ngắt đạt giới hạn (1000 điểm)",
  FE_38_B_PROJECTSETTING_COVER: "Ảnh đại diện",
  FE_38_B_REVIEW_01: "Tìm kiếm từ nhạy cảm ",
  FE_38_B_REVIEW_02: "Kiểm tra từ ngữ nhạy cảm Để tìm hiểu chi tiết, vui lòng truy cập vào bảng điều khiển của dự án.",
  FE_38_B_REVIEW_03: "Hoàn thành quét từ ngữ nhạy cảm. Phát hiện {0} chuỗi văn bản. {1} chuỗi văn bản chứa từ ngữ nhạy cảm. Vui lòng đọc thông tin lỗi",
  FE_38_B_SLOT_DEFAULT: "Ô trống mặc định",
  FE_38_B_SLOT_POPULAR: "Ô trống phổ biến",
  FE_38_B_SLOT_POPULAR_NONE: "Không có Ô trống phổ biến",
  FE_38_B_TIP_DELETE_FAILED: "Không thể xóa thành phần này ngay",
  FE_38_B_TIP_DIRTY_SAVE: "Vui lòng lưu lại các thành phần sau:",
  FE_38_B_TIP_OFFICAL_REQUIRE: "Không thể thay đổi các thành phần yêu cầu chính thức",
  FE_38_B_TIP_SAVE_FAILED: "Lưu lại thất bại.",
  FE_38_V_CONSOLE_TO_GRAPH: "Nhấn đúp để nhảy đến phần định nghĩa",
  FE_38_V_CONSOLE_TO_TARGET: "Nhấn đúp để đi đến vị trí mục tiêu",
  FE_38_V_ECA_COMPONENT_SELECT: "Chọn Thành phần",
  FE_38_V_MENU_WORK_AREA: "Bản lưu",
  FE_38_WZY_WS_CLEARPRO_ALL: "Xóa sạch tất cả yếu tố thuộc tính",
  FE_38_ZQ_INSPECTOR_STATIC: "Kết hợp vật thể tĩnh",
  FE_38_ZQ_INSPECTOR_STATICTIPS: "Tích vào đây để đánh dấu thực thể này là thực thể tĩnh trong trường cảnh.",
  FE_38_ZQ_LAUNCH_CHECKING: "Đang đánh giá",
  FE_38_ZQ_LAUNCH_FAILED: "Không vượt qua đánh giá Để tìm hiểu chi tiết, vui lòng truy cập vào bảng điều khiển của dự án.",
  FE_38_ZQ_LAUNCH_TIPS: 'Hãy chọn trạng thái đánh giá tại "Trung tâm dữ liệu". Nếu vượt qua quá trình đánh giá, trò chơi của bạn sẽ tự động được xuất bản.',
  FE_38_ZQ_PROJECTSETTING_COVER: "Chọn làm ảnh đại diện",
  FE_38_ZQ_PROJECTSETTING_DEFAULTLANG: "Ngôn ngữ Mặc định",
  FE_38_ZQ_PROJECTSETTING_DOUBLECHECK: "Xác nhận xóa các thay đổi này?",
  FE_38_ZQ_PROJECTSETTING_INFO: "Thông tin Cơ bản",
  FE_38_ZQ_PROJECTSETTING_LANG: "Danh sách Bản địa hóa",
  FE_38_ZQ_PROJECTSETTING_LANGTIPS: "Nếu không được thiết lập bản địa hóa, ngôn ngữ này sẽ được hiển thị mặc định.",
  FE_38_ZQ_PROJECTSETTING_LIMIT: "Kích cỡ ảnh vượt quá 200K. Không thể tải lên. Vui lòng chọn hình ảnh khác.",
  FE_38_ZQ_PROJECTSETTING_LOC: "Bản địa hóa",
  FE_38_ZQ_PROJECTSETTING_NAME: "Thiết lập Dự án",
  FE_38_ZQ_PROJECTSETTING_PICTIPS1: "Định dạng hình ảnh hỗ trợ: jpg, jpeg, png, và bmp.",
  FE_38_ZQ_PROJECTSETTING_PICTIPS2: "Độ phân giải đề xuất là 420*182 px. Kích thước phải dưới 200KB.",
  FE_38_ZQ_PROJECTSETTING_PICTIPS3: "Dự án của bạn sẽ được xuất bản cho công chúng sau khi vượt qua quá trình đánh giá của hệ thống.",
  FE_38_ZQ_PROJECTS_IMPORT: "Nhập liệu",
  FE_38_ZQ_PROJECTS_REFRESH: "Làm mới",
  FE_38_ZQ_PROJECTS_TIPS: "Bạn không thể hoàn tác việc xóa tài nguyên.",
  FE_38_ZZ_CAMERA_ADD: "Thêm Camera vào vị trí hiện tại",
  FE_38_ZZ_CAMERA_BLOCK_MODE: "Chế độ Chặn",
  FE_38_ZZ_CAMERA_CHOOSE: "Chọn chế độ Camera",
  FE_38_ZZ_CAMERA_CONTROL: "Điều khiển Camera sử dụng màn hình",
  FE_38_ZZ_CAMERA_CUSTOM: "Camera tùy chọn",
  FE_38_ZZ_CAMERA_FOCUS_OFFSET_DESC: "Độ lệch hướng là chênh lệch tọa độ giữa tâm vị trí người chơi và điểm hướng của camera.",
  FE_38_ZZ_CAMERA_FOV_DESC: "Trường quan sát là phạm vi có thể quan sát của camera.",
  FE_38_ZZ_CAMERA_INVISICAM: "Bán trong suốt",
  FE_38_ZZ_CAMERA_OFFSET_DESC: "Độ lệch dựa vào tọa độ của camera và tâm vị trí người chơi.",
  FE_38_ZZ_CAMERA_ORTHOGRAPHIC: "Phép chiếu trực giao",
  FE_38_ZZ_CAMERA_PERSPECTIVE: "Góc nhìn",
  FE_38_ZZ_CAMERA_PREVIEW: "Xem trước",
  FE_38_ZZ_CAMERA_PROJECTION_MODE: "Chế độ phóng chiếu",
  FE_38_ZZ_CAMERA_SET: "Thiết lập camera trò chơi",
  FE_38_ZZ_CAMERA_STABLE: "Cố định",
  FE_38_ZZ_CAMERA_START: "Camera định trước",
  FE_38_ZZ_CAMERA_START_MODE: "Chế độ camera định trước",
  FE_38_ZZ_CAMERA_THIRD: "Góc nhìn thứ 3 (Đuổi theo nhân vật)",
  FE_38_ZZ_CAMERA_TRANSVERSE: "Di chuyển ngang",
  FE_38_ZZ_CAMERA_ZOOM: "Thu phóng",
  FE_38_ZZ_ECA_COMMON: "Sự kiện công cộng",
  FE_38_ZZ_ECA_COMPONENT_SET: "Thiết lập Kiểu thành phần",
  FE_38_ZZ_ECA_COMPONENT_TYPE: "Kiểu thành phần",
  FE_38_ZZ_ECA_PRIVATE: "Sự kiện riêng",
  FE_38_ZZ_ECA_USED: "Khối đã được sử dụng",
  FE_38_ZZ_EMPTY: "Trống",
  FE_39A_B_LOGIN_BACK: "Quay lại",
  FE_39A_B_LOGIN_JOIN: "Tham gia",
  FE_39A_B_LOGIN_LOADING: "Đang tải",
  FE_39A_B_LOGIN_SIGNIN: "Đăng nhập",
  FE_39A_B_LOGIN_SIGNINWITH: "Đăng nhập thông qua {0}",
  FE_39A_B_LOGIN_SIGNUP: "Đăng ký",
  FE_39A_B_LOGIN_SIGNUPWITH: "Đăng ký thông qua {0}",
  FE_39A_B_LOGIN_SUCCESS: "Thành công",
  FE_39A_B_LOGIN_TIPS1: "Đăng nhập Craftland Studio",
  FE_39A_B_LOGIN_TIPS10: "Liên kết với tài khoản Free Fire sẽ cho phép bạn xuất bản game và ghé qua những dự án Free Fire khác.",
  FE_39A_B_LOGIN_TIPS11: "Bạn chưa có tài khoản Free Fire sao?",
  FE_39A_B_LOGIN_TIPS12: "Bạn đã có tài khoản khoản Free Fire rồi?",
  FE_39A_B_LOGIN_TIPS2: "Bạn chưa có tài khoản Craftland Studio sao?",
  FE_39A_B_LOGIN_TIPS3: "Bạn đã có tài khoản Craftland Studio rồi?",
  FE_39A_B_LOGIN_TIPS4: "Trang này sẽ được làm mới sau khi đăng nhập thành công trên cửa sổ phụ.",
  FE_39A_B_LOGIN_TIPS5: "Khởi chạy Craftland Studio",
  FE_39A_B_LOGIN_TIPS6: "Để sử dụng Craftland Studio và truy cập vào các dự án Free Fire, vui lòng liên kết với tài khoản Free Fire của mình.",
  FE_39A_B_LOGIN_TIPS7: "Liên kết thất bại, vui lòng thử lại",
  FE_39A_B_LOGIN_TIPS8: "Thông báo",
  FE_39A_B_LOGIN_TIPS9: "Xác nhận liên kết với tài khoản Free Fire sau đây? Khi hoàn thành liên kết, bạn có thể nhận thông tin từ các dự án Free Fire.",
  FE_39A_V_NINE_SLICE: "Bố cục lưới 9 ô",
  FE_39A_ZQ_ATLAS_CLEARFAIL: "Xóa sạch thất bại",
  FE_39A_ZQ_ATLAS_CLEARSUC: "Xóa sạch",
  FE_39A_ZQ_ATLAS_MEMORY: "Bộ nhớ đệm hình ảnh UI",
  FE_39A_ZQ_FILE_FILEID: "ID tệp tin",
  FE_39A_ZQ_FILE_PATH: "Đường dẫn",
  FE_39A_ZQ_MESH_SUBMESHCOUNT: "Số lượng Submesh",
  FE_39A_ZQ_PERFORMANCE: "Hiệu năng",
  FE_39_B_ADD: "Thêm",
  FE_39_B_BAN_DRAG: "Đã chặn kéo thả",
  FE_39_B_CHOOSE_ENTITY: "Chọn thực thể để gửi",
  FE_39_B_CHOOSE_TYPE: "Chọn kiểu tham số",
  FE_39_B_COPY: "Sao chép",
  FE_39_B_CREATE_SIGNAL_PARAMETER: "Tạo tham số tín hiệu",
  FE_39_B_CUSTOM_EVENT: "Thành phần tùy chọn",
  FE_39_B_DATA_OPERATE: "Vận hành dữ liệu",
  FE_39_B_DELETE_SIGNAL_PARAMETER: "Xóa tham số tín hiệu{0}",
  FE_39_B_ENUM: "Trị số enum",
  FE_39_B_ENUM_DETAIL: "Chi tiết enum",
  FE_39_B_GUNSKIN_PROP: "Thuộc tính skin súng",
  FE_39_B_GUNSKIN_SKILL: "Kỹ năng skin súng",
  FE_39_B_LOCALIZATION_TIPS1: "Độ dài văn bản bản địa hóa không đúng yêu cầu",
  FE_39_B_SIGNAL_CONFIG: "Thiết lập tham số tín hiệu được tiền định",
  FE_39_B_SIGNAL_NAME: "Tên tín hiệu",
  FE_39_B_SIGNAL_PARAMETER: "Tham số tín hiệu được tiền định",
  FE_39_B_SIGNAL_RECEIVE: "Khi nhận tín hiệu {0}",
  FE_39_B_SIGNAL_SEND: "Gửi tín hiệu {0}",
  FE_39_B_SIGNAL_TIPS1: "Tín hiệu đã được sử dụng",
  FE_39_B_SIGNAL_TIPS2: "Sự kiện tín hiệu tùy chọn thất bại",
  FE_39_B_TAG_EDIT: "Chỉnh sửa thẻ",
  FE_39_B_TAG_TIPS1: "Xác nhận xóa thẻ này?",
  FE_39_B_TARGET_ENTITY: "Thực thể mục tiêu",
  FE_39_M_ACCOUNTID: "Tài khoản",
  FE_39_M_ADDTEMPLATE: "Thêm mẫu",
  FE_39_M_ASC: "Nâng lên",
  FE_39_M_BLOCKLY: "Xem trước khối",
  FE_39_M_CLEAR: "Xóa sạch dữ liệu",
  FE_39_M_CLEAR1: "Tất cả dữ liệu trên bảng này sẽ bị xóa sạch và không thể thu hồi lại. Xác nhận xóa?",
  FE_39_M_CLEAR2: "Tất cả dữ liệu sẽ bị xóa sạch và không thể thu hồi lại. Xác nhận xóa?",
  FE_39_M_CLEAR3: "Dữ liệu sẽ bị xóa và không thể thu hồi lại. Xác nhận xóa?",
  FE_39_M_COMPONENT: "Xem trước thành phần",
  FE_39_M_COMPONENTDESC: "Mô tả thành phần",
  FE_39_M_COMPONENTLIST: "Danh sách thành phần",
  FE_39_M_DATA: "Lưu trữ dữ liệu",
  FE_39_M_DATAMAX: "Giới hạn số lượng bảng dữ liệu đạt tối đa",
  FE_39_M_DATAMODEDESC: "Các thành phần và khối tương ứng sẽ có thể được sử dụng sau khi module được kích hoạt. Lưu ý rằng hàm lưu trữ có yêu cầu nghiêm ngặt về hiệu năng và có giới hạn tần suất, vui lòng kiểm soát logic phân phối dữ liệu.",
  FE_39_M_DATANAMEREPEAT: "Tên bảng dữ liệu đã tồn tại",
  FE_39_M_DATANAMESIZE: "Tên bảng dữ liệu có thể chứa tối đa 12 ký tự",
  FE_39_M_DATAOFF: "Hàm lưu trữ dữ liệu tắt",
  FE_39_M_DATASTORAGEOFF: "Module lưu trữ dữ liệu TẮT",
  FE_39_M_DATASTORAGEON: "Module lưu trữ dữ liệu BẬT",
  FE_39_M_DESC: "Hạ xuống",
  FE_39_M_FUNON: "Hàm BẬT",
  FE_39_M_INPUTNAME: "Nhập tên bảng dữ liệu",
  FE_39_M_MANAGE: "Quản lý lưu trữ",
  FE_39_M_OFF: "TẮT",
  FE_39_M_ORDIDATA: "Bảng dữ liệu thường",
  FE_39_M_RANKDATA: "Bảng dữ liệu xếp hạng",
  FE_39_M_RANKING: "Xếp hạng",
  FE_39_M_RANKSHEETTIPS: "Bạn có thể lập một bảng dữ liệu xếp hạng, dữ liệu sẽ được sắp xếp tự động",
  FE_39_M_SHEETTIPS: "Bạn có thể lập một bảng dữ liệu thường để lưu trữ dữ liệu bất kỳ",
  FE_39_M_STATUS: "Trạng thái",
  FE_39_M_TABLENULL: "Bảng dữ liệu hiện tại đang trống",
  FE_39_M_TABLESET: "Thiết lập bảng dữ liệu",
  FE_39_SP_ENUM01: "Chỉnh sửa Enum",
  FE_39_SP_ENUM02: "Chỉnh sửa Enum tùy chỉnh",
  FE_39_SP_ENUM03: "Quản lý Enum",
  FE_39_SP_ENUM04: "Enum tùy chỉnh",
  FE_39_SP_ENUM05: "Enum chính thức",
  FE_39_SP_ENUM06: "Kiểu dữ liệu",
  FE_39_SP_ENUM07: "Nội dung Enum",
  FE_39_SP_ENUM08: "Tạo một bản sao",
  FE_39_V_ALIGN_STYLE: "Kiểu căn lề",
  FE_39_V_BUTTON_DOUBLE_CLICK: "Nút nháy đúp",
  FE_39_V_BUTTON_DOUBLE_CLICK_DESC: "Thực thi khi nháy đúp vào thực thể",
  FE_39_V_BUTTON_PRESS: "Nhấn nút",
  FE_39_V_BUTTON_PRESS_DESC: "Thực thi khi nhấn vào thực thể",
  FE_39_V_BUTTON_RELEASE: "Thả nút",
  FE_39_V_BUTTON_RELEASE_DESC: "Thực thi khi thả nút khỏi vật thể",
  FE_39_V_INPUT_TEXT_ACTIVE: "Kích hoạt tài khoản của bạn",
  FE_39_V_INPUT_TEXT_DEFAULT: "Nội dung văn bản mặc định",
  FE_39_V_PATH_COPY: "Sao chép tên/dường dẫn điều khiển",
  FE_39_V_PROFILER_ASSESS: "Dung lượng trống ước tính trên thiết bị di động",
  FE_39_V_PROFILER_CURRENT: "Hiện tại",
  FE_39_V_PROFILER_DOWN: "Tải xuống",
  FE_39_V_PROFILER_DRAWCALL: "Lệnh gọi kết xuất",
  FE_39_V_PROFILER_LOG: "Nhật ký hiệu năng",
  FE_39_V_PROFILER_MEMORY: "Bộ nhớ",
  FE_39_V_PROFILER_NET: "Lưu lượng mạng",
  FE_39_V_PROFILER_OTHER: "Khác",
  FE_39_V_PROFILER_PEAK: "Đỉnh",
  FE_39_V_PROFILER_PRESSURE: "Áp lực xuất bản",
  FE_39_V_PROFILER_PRESSURE_ASSESS: "Áp lực hiệu năng ước tính trên di động",
  FE_39_V_PROFILER_PRESSURE_HIGH: "Cao",
  FE_39_V_PROFILER_PRESSURE_LOW: "Thấp",
  FE_39_V_PROFILER_PRESSURE_MEDIUM: "Trung bình",
  FE_39_V_PROFILER_RENDER: "Đang kết xuất",
  FE_39_V_PROFILER_TIME_LOAD: "Thời gian tải",
  FE_39_V_PROFILER_TIME_RUN: "Thời gian chạy",
  FE_39_V_PROFILER_TIPS: "Hồ sơ",
  FE_39_V_PROFILER_TRIS: "Tris",
  FE_39_V_PROFILER_UP: "Tải lên",
  FE_39_V_TERRAIN_BRUSH_RADIUS: "Bán kính cọ vẽ",
  FE_39_V_TERRAIN_BRUSH_SET: "Thiết lập cọ vẽ",
  FE_39_V_TERRAIN_BRUSH_SIZE: "Kích thước cọ vẽ",
  FE_39_V_TERRAIN_BRUSH_STRENGTH: "Độ mạnh",
  FE_39_V_TERRAIN_BUILD: "Tạo",
  FE_39_V_TERRAIN_BUILD_LIMIT: "Chỉ có thể tạo 1 địa hình",
  FE_39_V_TERRAIN_CHANGE: "Thay đổi",
  FE_39_V_TERRAIN_DELETE: "Xóa",
  FE_39_V_TERRAIN_DRAW: "Tô màu",
  FE_39_V_TERRAIN_FLAT: "Phẳng",
  FE_39_V_TERRAIN_FLAT_BOTH: "Cả hai",
  FE_39_V_TERRAIN_FLAT_MODE: "Chế độ làm phẳng",
  FE_39_V_TERRAIN_FLAT_TARGET: "Mục tiêu làm phẳng",
  FE_39_V_TERRAIN_GENERATE: "Tạo ra",
  FE_39_V_TERRAIN_IMPORT: "Nhập liệu",
  FE_39_V_TERRAIN_LOWER: "Thấp hơn",
  FE_39_V_TERRAIN_NAME: "Địa hình",
  FE_39_V_TERRAIN_NEW: "Mới",
  FE_39_V_TERRAIN_PLANT_BRUSH: "Cọ vẽ thực vật",
  FE_39_V_TERRAIN_PLANT_CHOOSE: "Chọn thực vật",
  FE_39_V_TERRAIN_PLANT_DENSITY: "Mật độ cọ vẽ",
  FE_39_V_TERRAIN_RAISE: "Tăng lên",
  FE_39_V_TERRAIN_RANDOM_ANGLE: "Góc ngẫu nhiên",
  FE_39_V_TERRAIN_SCULPT: "Chạm khắc",
  FE_39_V_TERRAIN_SET: "Thiết lập địa hình",
  FE_39_V_TERRAIN_SIZE: "Kích thước",
  FE_39_V_TERRAIN_SMOOTH: "Mượt",
  FE_39_V_TERRAIN_TEXTURE: "Lớp phủ",
  FE_39_V_TERRAIN_TEXTURE_CHANGE: "Thay đổi",
  FE_39_V_TERRAIN_TEXTURE_CHOOSE: "Chọn lớp phủ",
  FE_39_V_TERRAIN_TEXTURE_COVER_ALL: "Đè lên tất cả",
  FE_39_V_TERRAIN_TEXTURE_DEIETE: "Xóa",
  FE_39_V_TERRAIN_TEXTURE_IMPORT: "Nhập liệu",
  FE_39_V_TERRAIN_TEXTURE_LIMIT: "Chỉ có thể nhập tối đa 4 loại lớp phủ",
  FE_39_V_TYPO: "Bố cục văn bản",
  FE_39_XYL_ISTRIGGERHIDE: "Xóa trigger",
  FE_39_XYL_MOVESTRAIGHT1: "Di chuyển tuyến tính A",
  FE_39_XYL_MOVESTRAIGHT2: "Di chuyển tuyến tính B",
  FE_39_XYL_TELEPORTTYPE: "Tự động dịch chuyển",
  FE_39_ZQ_COLLIDER_ACTIVE: "Kích hoạt phạm vi va chạm",
  FE_39_ZQ_COLLIDER_BOX: "Phạm vi va chạm hình hộp",
  FE_39_ZQ_COLLIDER_CAPSULE: "Phạm vi va chạm hình viên nang",
  FE_39_ZQ_COLLIDER_COLLIDER: "Phạm vi va chạm",
  FE_39_ZQ_COLLIDER_COLLIDERNUM: "Phạm vi va chạm {0}",
  FE_39_ZQ_COLLIDER_EDIT: "Chỉnh sửa phạm vi va chạm",
  FE_39_ZQ_COLLIDER_ERROR: "Phạm vi va chạm bị sai lệch, vui lòng kiểm tra và thử lại",
  FE_39_ZQ_COLLIDER_MESH: "Phạm vi va chạm lưới",
  FE_39_ZQ_COLLIDER_RADIUS: "Bán kính",
  FE_39_ZQ_COLLIDER_SPHERE: "Phạm vi va chạm hình cầu",
  FE_39_ZQ_COLLIDER_TRIGGER: "Là vật thể kích hoạt được",
  FE_39_ZQ_COLLIDER_TYPE: "Kiểu phạm vi va chạm",
  FE_39_ZQ_FILETYPE_ALL: "Tất cả tệp",
  FE_39_ZQ_FILETYPE_FBX: "Tệp FBX",
  FE_39_ZQ_FILETYPE_MATERIAL: "Tệp vật liệu",
  FE_39_ZQ_FILETYPE_SOUND: "Tệp âm thanh",
  FE_39_ZQ_FILE_OUTPUT: "Xuất ra",
  FE_39_ZQ_FILE_UNLEGAL: "Kiểu tệp không hợp lệ, vui lòng kiểm tra và thử lại",
  FE_39_ZQ_IMAGE_ERROR: "Hình ảnh bị sai lệch",
  FE_39_ZQ_IMAGE_FORMAT: "Định dạng",
  FE_39_ZQ_IMAGE_RESOURCESIZE: "Kích thước tài nguyên",
  FE_39_ZQ_IMAGE_ROUTE: "Đường",
  FE_39_ZQ_IMAGE_WARNINGRULE: "Kích cỡ hình ảnh không hợp lệ Phải là bội số của 2 để hiển thị chính xác.",
  FE_39_ZQ_IMAGE_WARNINGSIZE: "Kích cỡ ảnh tối đa: 2048x2048. Vui lòng điều chỉnh lại.",
  FE_39_ZQ_INSPECTOR_ACTIVE: "Có sẵn",
  FE_39_ZQ_MATERIAL_BRIGHTNESS: "Độ sáng",
  FE_39_ZQ_MATERIAL_DIFFUSEINTENSITY: "Mức độ khuếch tán",
  FE_39_ZQ_MATERIAL_ERROR: "Vật liệu bị sai lệch, vui lòng kiểm tra và thử lại",
  FE_39_ZQ_MATERIAL_GLOBALILLUMINATION: "Chiếu sáng hai mặt toàn cục",
  FE_39_ZQ_MATERIAL_GPUINSTANCING: "Bật GPU Intancing",
  FE_39_ZQ_MATERIAL_LIGHTINGON: "Bật hiệu ứng ánh sáng",
  FE_39_ZQ_MATERIAL_LOSTQUOTE: "Mất nhãn",
  FE_39_ZQ_MATERIAL_LOWQUALITY: "Chất lượng thấp",
  FE_39_ZQ_MATERIAL_MAINCOLOR: "Màu chủ đạo",
  FE_39_ZQ_MATERIAL_MAINMAP: "Bản đồ chủ đạo",
  FE_39_ZQ_MATERIAL_MATERIAL: "Vật liệu",
  FE_39_ZQ_MATERIAL_NORMALMAP: "Thường",
  FE_39_ZQ_MATERIAL_OFFSET: "Khoảng lệch",
  FE_39_ZQ_MATERIAL_RENDERQUEUE: "Hàng chờ kết xuất",
  FE_39_ZQ_MATERIAL_SHADER: "Đổ bóng",
  FE_39_ZQ_MATERIAL_SHININESS: "Chiếu sáng",
  FE_39_ZQ_MATERIAL_SPECULARCOLOR: "Màu phản xạ",
  FE_39_ZQ_MATERIAL_SPECULARINTENSITY: "Mức độ khuếch tán",
  FE_39_ZQ_MATERIAL_SPECULARMASK: "Bề mặt phản xạ",
  FE_39_ZQ_MATERIAL_TILING: "Nghiêng",
  FE_39_ZQ_MATH_EQUAL: "Bằng",
  FE_39_ZQ_MATH_GREATER: "Lớn hơn",
  FE_39_ZQ_MATH_GREATEREQUAL: "Lớn hơn hoặc bằng",
  FE_39_ZQ_MATH_LESS: "Nhỏ hơn",
  FE_39_ZQ_MATH_LESSEQUAL: "Nhỏ hơn hoặc bằng",
  FE_39_ZQ_MATH_NOTEQUAL: "Không bằng",
  FE_39_ZQ_MESH_ERROR: "Vật liệu bị sai lệch, vui lòng kiểm tra và thử lại",
  FE_39_ZQ_MESH_MESH: "Lưới",
  FE_39_ZQ_PACKAGE_ERROR: "Gói bị sai lệch, vui lòng kiểm tra và thử lại",
  FE_39_ZQ_PACKAGE_EXPORTFAIL: "Xuất dữ liệu thất bại",
  FE_39_ZQ_PACKAGE_EXPORTSUCCESS: "Xuất dữ liệu thành công",
  FE_39_ZQ_PACKAGE_IMPORTFAIL: "Nhập dữ liệu thất bại",
  FE_39_ZQ_PACKAGE_IMPORTSUCCESS: "Nhập dữ liệu thành công",
  FE_39_ZQ_PACKAGE_IMPUTPACKAGE: "Nhập gói dữ liệu",
  FE_39_ZQ_PACKAGE_INCLUDEDEPENDENCY: "Bao gồm dữ liệu phụ thuộc",
  FE_39_ZQ_PACKAGE_LOSTQUOTE: "Mất nhãn {0} ",
  FE_39_ZQ_PACKAGE_NEWID: "Một tệp tin có cùng ID nhưng khác tên đã tồn tại, tiếp tục có thể dẫn đến mất nhãn tệp tin",
  FE_39_ZQ_PACKAGE_OUTPUTPACKAGE: "Xuất theo gói",
  FE_39_ZQ_PACKAGE_WARNING: "ID của tệp này xung đột với một tệp khác trong dự án. Tiếp tục nhập tệp sẽ thay thế tất cả các tệp liên quan.",
  FE_39_ZQ_PART_CONE: "Hình Nón",
  FE_39_ZQ_PART_CUBE: "Hình Lập Phương",
  FE_39_ZQ_PART_CYLINDER: "Hình Trụ",
  FE_39_ZQ_PART_PART: "Hình Học",
  FE_39_ZQ_PART_SPHERE: "Hình Cầu",
  FE_39_ZQ_PART_WEDGE: "Cái Nêm",
  FE_39_ZQ_PREFAB_APPLY: "Áp dụng",
  FE_39_ZQ_PREFAB_APPLYALL: "Áp dụng cho tất cả",
  FE_39_ZQ_PREFAB_ERROR: "Thành phần ghép sẵn lỗi, vui lòng kiểm tra và thử lại",
  FE_39_ZQ_PREFAB_NEWPREFAB: "Thành phần ghép sẵn mới",
  FE_39_ZQ_PREFAB_NOOVERRIDE: "Không có nội dung ghi đè",
  FE_39_ZQ_PREFAB_OVERRIDE: "Ghi đè",
  FE_39_ZQ_PREFAB_PREFAB: "Thành phần ghép sẵn",
  FE_39_ZQ_PREFAB_RESTORE: "Khôi phục",
  FE_39_ZQ_PREFAB_RESTOREALL: "Khôi phục tất cả",
  FE_39_ZQ_PREFAB_UNPACK: "Giải nén",
  FE_39_ZQ_PREFAB_UNPACKALL: "Giải nén tất cả",
  FE_39_ZQ_RENDER_RENDER: "Kết xuất",
  FE_39_ZQ_SHADER_ALWAYS: "Luôn luôn",
  FE_39_ZQ_SHADER_COLORMASK: "Lớp phủ màu",
  FE_39_ZQ_SHADER_CUTOFF: "Cắt ảnh",
  FE_39_ZQ_SHADER_FADEFACTOR: "Yếu tố suy giảm",
  FE_39_ZQ_SHADER_NEVER: "Không bao giờ",
  FE_39_ZQ_SHADER_TINTCOLOR: "Đổ màu",
  FE_39_ZQ_VISIBLE_CURRENTLAYER: "Bố cục hiện tại",
  FE_39_ZQ_VISIBLE_DEFAULTLAYER: "Bố cục mặc định",
  FE_39_ZQ_VISIBLE_LAYER: "Số người chơi",
  FE_40A_B_ECA_TIPS1: "Các khóa bản địa hóa không thể được kết nối.",
  FE_40A_B_SETTING_BASIC: "Cơ bản",
  FE_40A_B_SETTING_BUILD: "Xây dựng",
  FE_40A_B_SETTING_BUILDAIM: "Mục tiêu xây dựng",
  FE_40A_B_SETTING_BUILDSETTING: "Thiết lập xây dựng",
  FE_40A_B_SETTING_CAMERA_INDENTATION: "Thu phóng Camera",
  FE_40A_B_SETTING_CAMERA_ROTATE: "Xoay Camera",
  FE_40A_B_SETTING_CAMERA_TRANSLATE: "Di chuyển Camera",
  FE_40A_B_SETTING_COMMON: "Vận hành cơ bản",
  FE_40A_B_SETTING_COMMONBUILD: "Xây dựng thường",
  FE_40A_B_SETTING_DOWN10PX: "Di chuyển xuống 10 px ",
  FE_40A_B_SETTING_DOWN1PX: "Di chuyển xuống 1 px ",
  FE_40A_B_SETTING_EDITORSWITCH: "Thay đổi trình chỉnh sửa",
  FE_40A_B_SETTING_FOCUS: "Tập trung",
  FE_40A_B_SETTING_LEFT10PX: "Di chuyển sang trái 10 px ",
  FE_40A_B_SETTING_LEFT1PX: "Di chuyển sang phải 1 px ",
  FE_40A_B_SETTING_LEFTMOUSE: "Nút trái chuột",
  FE_40A_B_SETTING_LOG: "In nhật ký",
  FE_40A_B_SETTING_MANY: "Thực thể đa lựa chọn",
  FE_40A_B_SETTING_MIDMOUSE: "Bánh xe trượt",
  FE_40A_B_SETTING_MIDMOUSE_HOLD: "Nhấn và giữ để lăn bánh xe",
  FE_40A_B_SETTING_PREFERENCES: "Ưu tiên",
  FE_40A_B_SETTING_PROJECT: "Vận hành Dự án",
  FE_40A_B_SETTING_RIGHT10PX: "Di chuyển sang phải 10 px ",
  FE_40A_B_SETTING_RIGHT1PX: "Di chuyển sang phải 1 px ",
  FE_40A_B_SETTING_RIGHTMOUSE: "Nút phải chuột",
  FE_40A_B_SETTING_SCENE_ROAMING: "Lướt trường cảnh",
  FE_40A_B_SETTING_SHORTCUTKEYS: "Lối tắt",
  FE_40A_B_SETTING_SINGLE: "Thực thể đơn lựa chọn",
  FE_40A_B_SETTING_UP10PX: "Di chuyển lên trên 10 px",
  FE_40A_B_SETTING_UP1PX: "Di chuyển lên trên 1 px",
  FE_40A_B_SETTING_WEBBUILD: "Gói tiền xuất bản",
  FE_40A_HJ_DEBUG_NETWORKDELAY: "Trì hoãn:",
  FE_40A_HJ_DEBUG_PACKETLOSS: "Gói dữ liệu bị mất:",
  FE_40A_V_ECA_CLEAR_HISTORY: "Lịch sử xóa:",
  FE_40A_V_ECA_COPY_SINGLE: "Sao chép hàng đơn",
  FE_40A_V_ECA_DELETE_MULTIPLE: "Xóa nhiều hàng",
  FE_40A_V_ECA_NO_HISTORY: "Không có lịch sử tìm kiếm",
  FE_40A_XYL_COLORFULCUBE: "Gạch màu",
  FE_40A_XYL_REFCUBE: "Gạch phản chiếu",
  FE_40A_XYL_TOYCUBE: "Gạch đồ chơi",
  FE_40A_ZQ_BATCH_BATCH_STATIC: "Tĩnh",
  FE_40A_ZQ_BATCH_BUTTON_SETTING: "Đến Thiết lập Dự án",
  FE_40A_ZQ_BATCH_CONSOLE_SCRIPT: "tập lệnh ECA {0} tại nút hiện tại {1} không thể được áp dụng. Vui lòng kiểm tra xem có tiếp tục duy trì trạng thái hiện tại không.",
  FE_40A_ZQ_BATCH_TIPS_BADINHERIT: "Lỗi khi đang tối ưu hóa hiệu năng kết xuất. Thực thể này không hỗ trợ kết hợp hoặc gom mô hình.",
  FE_40A_ZQ_BATCH_TIPS_COLLIDER: "Đã bật thuộc tính tĩnh. Thuộc tính này sẽ trở nên vô hiệu và được chuyển đổi thành va chạm mặc định.",
  FE_40A_ZQ_BATCH_TIPS_INHERIT: "Kế thừa thuộc tính tĩnh",
  FE_40A_ZQ_BATCH_TIPS_INSPECTOR: "Đã bật thuộc tính tĩnh. Thuộc tính này sẽ trở nên vô hiệu.",
  FE_40A_ZQ_BATCH_TIPS_INVALID: "Kết hợp tĩnh đã được bật. Những thuộc tính sau đây có thể trở nên vô hiệu.",
  FE_40A_ZQ_BATCH_TIPS_STATICBATCHING: "Bật kết hợp tĩnh sẽ làm vô hiệu logic của các thực thể được áp dụng.",
  FE_40A_ZQ_BATCH_TIPS_UNAVAILABLE: "Logic của các vật thể chính thức vẫn sẽ có hiệu lực.",
  FE_40A_ZQ_SETTINGS_GOTOSETTINGS: "Thiết lập",
  FE_40A_ZQ_SETTINGS_INPUTTIPS: "Nhập liệu tại đây",
  FE_40_B_DATA_SEARCH_ACCOUNTID: "Tìm kiếm UID",
  FE_40_B_DATA_SEARCH_KEY: "Tìm kiếm Khóa",
  FE_40_B_DATA_SEARCH_VALUE: "Tìm kiếm Giá trị",
  FE_40_B_DATA_TIPS1: "Dữ liệu hiện tại không thể chỉnh sửa. Vui lòng xuất bản bản đồ và thử lại.",
  FE_40_B_DATA_TIPS2: "Không thể chỉnh sửa kiểu dữ liệu này.",
  FE_40_B_DATA_TIPS3: "Bạn cần chỉ định UID và Khóa để tìm kiếm thông qua danh sách dữ liệu thông thường.",
  FE_40_B_DATA_TIPS4: "Lưu lại các chỉnh sửa trước đây?",
  FE_40_B_DATA_TIPS5: "Có thay đổi chưa được lưu.",
  FE_40_B_ECA_MISSING: "Thiếu tập lệnh ECA",
  FE_40_B_LOGIN_TIPS1: "Tài khoản khách không thể liên kết. Vui lòng đăng nhập vào Craftland Studio trước.",
  FE_40_B_RECONNECT_OFF: "Tắt chế độ tự động kết nối lại khi ngắt kết nối",
  FE_40_B_SCRIPT: "Tập lệnh",
  FE_40_B_SCRIPT_MISSING: "Thiếu tệp mã lệnh",
  FE_40_B_TERRAIN_TIPS1: "Đã đạt giới hạn bề mặt (4) của địa hình hiện tại",
  FE_40_B_VERSION_TIPS1: `Phiên bản không tương thích. (Phiên bản trình chỉnh sửa: {0}. Phiên bản dự án: : {1}.
Vẫn tiếp tục?`,
  FE_40_JH_AVALTOKENID: "ID của token kích hoạt",
  FE_40_JH_DISPLAYLABEL: "Hiển thị thẻ",
  FE_40_JH_DISPLAYLABELDESC: "Hiển thị thẻ trên các game của Free Fire",
  FE_40_JH_DISPLAYLABELMAX: "Đã đạt số thẻ hiển thị tối đa.",
  FE_40_JH_GAMETYPEDESC: "Chọn loại trò chơi cho bản đồ này",
  FE_40_JH_GAMETYPENAME: "Loại trò chơi",
  FE_40_JH_GETTOKENID: "ID Token",
  FE_40_JH_HIDETAGLIMIT: "Đã đạt số lượng game tối đa có thể được chọn ",
  FE_40_JH_NUM: "Số lượng",
  FE_40_JH_TOKENALIVE: "Token được kích hoạt trong trận đấu",
  FE_40_JH_TOKENGET: "Token được đem vào trận đấu",
  FE_40_JH_TOKENSET: "Thiết lập Token",
  FE_40_JH_TOKENSET1: "Có kích hoạt tính năng token hay không",
  FE_40_JH_TOKENSET2: "Có mang token vào trận đấu hay không",
  FE_40_JH_TOKENSETERROR: "Tính năng token chưa bật.",
  FE_40_JH_TOKENSETNAME: "Thiết lập Token",
  FE_40_M_UPDATELOG: "Cập nhật nhật ký",
  FE_40_SD_EMPTYWARNING: "Thành phần mẹ hiện không trống. Vui lòng kiểm tra xem có tiếp tục sử dụng nó hay không.",
  FE_40_SD_FIND_IN_SCENE: "Tìm tham chiếu trong Trường cảnh",
  FE_40_SD_FIND_IN_UI: "Tìm tham chiếu trong UI",
  FE_40_SD_FIND_IN_WORKFLOW: "Tìm tham chiếu trong Quy trình",
  FE_40_SD_NOTE: "Lưu ý",
  FE_40_SD_NOT_FIND: "Không tìm thấy tham chiếu",
  FE_40_V_UI_COLUMN_LIMIT: "Giới hạn cột",
  FE_40_V_UI_PANEL_CONSTRAINNOTCLIP: "Ràng buộc nhưng không cắt xén",
  FE_40_V_UI_PANEL_MASK: "Lớp phủ",
  FE_40_V_UI_PANEL_SOFTCLIP: "Cắt xén mềm",
  FE_40_V_UI_ROW_LIMIT: "Giới hạn hàng",
  FE_40_V_UI_SCROLLBAR: "Thanh trượt",
  FE_40_V_UI_SCROLLBAR_DRAGGING: "Khi kéo thả",
  FE_40_V_UI_SCROLLBAR_SHOW: "Luôn hiển thị",
  FE_40_V_UI_SCROLLVIEW: "Xem thanh trượt",
  FE_40_V_UI_SCROLLVIEW_DIRECTION_UNRESTRAINED: "Không ràng buộc",
  FE_40_V_UI_SCROLLVIEW_DRAGEFFECT_MOMENTUM: "Đà",
  FE_40_V_UI_SCROLLVIEW_DRAGEFFECT_MOMENTUMNSPRING: "Đà và Lò xo",
  FE_40_XXJ_CLOTHESTYPE: "Loại ngoại trang",
  FE_40_XXJ_ISEXPORT: "Được xuất",
  FE_40_XXJ_PARENTERROR: "Thiết lập thành phần mẹ thất bại",
  FE_40_XXJ_WEASKINSTYPE: "Loại skin vũ khí",
  FE_40_XYL_CUSTOMMINIMAP: "Bản đồ nhỏ tùy chỉnh",
  FE_40_XYL_NOCUSTOMMINIMAP: "Bản đồ nhỏ tùy chỉnh không được bật",
  FE_40_ZQ_COMPONENT_CUSTOMOBJECT: "Vật thể tùy chỉnh",
  FE_40_ZQ_COMPONENT_CUSTOMRENDER: "Thành phần kết xuất tùy chỉnh",
  FE_40_ZQ_GAME_EXITCONFIRM: "Xác nhận rời khỏi trò chơi này?",
  FE_40_ZQ_GAME_EXITOPTION: "Cho phép thoát giữa chừng",
  FE_40_ZQ_GAME_KICKOUT: "Bạn đã AFK một thời gian dài và đã tự động được đưa trở về Sảnh chờ.",
  FE_40_ZQ_GAME_KICKOUTTIME: "Thời gian AFK (đơn vị: phút)",
  FE_40_ZQ_GAME_TIPS: "Thông báo",
  FE_40_ZQ_LD_LDTIPS: `Đã thêm Gói tài nguyên vào bảng nội dung LD.
Sau khi thiết lập file mapinfos.csv, vui lòng bấm vào đây để làm mới, hoặc bạn sẽ bị yêu cầu phải làm mới bằng cách tắt và mở lại dự án.`,
  FE_41A_B_RENAME_TIPS1: "Không thể sử dụng ký tự {0} ",
  FE_41A_B_RENAME_TIPS2: "Giới hạn ký tự: {0}",
  FE_41A_B_RENAME_TIPS3: "Biệt danh không đáp ứng tiêu chuẩn. Đăng nhập thất bại.",
  FE_41A_B_RENAME_TIPS4: "Tên không thể bỏ trống. Chỉnh sửa thất bại.",
  FE_41A_B_RENAME_TIPS5: "Độ dài của biệt danh phải nằm trong khoảng từ {0} đến {1} ký tự.",
  FE_41A_M_FEEDBACK: "Phản hồi của bạn rất quan trọng đối với chúng tôi!",
  FE_41B_HZY_CHECK_TIPS: "Trước tiên, hãy nhấn chọn đồng ý ",
  FE_41B_HZY_COMPARE_NOTSAME: "Loại phía bên trái và bên phải không trùng khớp.",
  FE_41B_HZY_CREATE_PARENTLEVEL: "Tạo nhánh mẹ trống",
  FE_41B_HZY_PRIVACY_POLICY: "Tôi đã đọc và chấp thuận [Điều khoản dịch vụ](http://content.garena.com/legal/tos/tos_en.html) và [Chính sách riêng tư](https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html).",
  FE_41B_HZY_PROJECT_FAVORITE_TIPS: "Thích từ này",
  FE_41B_M_DEFAULTVALUE: "Giá trị mặc định",
  FE_41B_M_RANGE: "Phạm vi giá trị",
  FE_41_B_CONSOLE_TIPS1: "Nhấn đúp để xem thông báo lỗi",
  FE_41_B_DATA_ACCUMULATED_SHEET: "Bảng dữ liệu",
  FE_41_B_DATA_CLEAR_AWARD: "Có lỗi khi xóa.",
  FE_41_B_DATA_CLEAR_CYCLE: "Xóa sạch dữ liệu",
  FE_41_B_DATA_CLEAR_CYCLE_INTERVAL: "Thời gian chu kỳ",
  FE_41_B_DATA_CLEAR_SETTING: "Xóa thiết lập",
  FE_41_B_DATA_CLEAR_SHEET: "Xóa bảng dữ liệu",
  FE_41_B_DATA_CLEAR_TIME: "Xóa thời gian",
  FE_41_B_DATA_CLEAR_TIMING: "Xóa thời gian đếm ngược",
  FE_41_B_DATA_CLEAR_TIPS1: "Bạn sẽ không thể hoàn tác hành động này Xác nhận tiếp tục?",
  FE_41_B_DATA_CLEAR_TIPS2: "Bạn sẽ không thể hoàn tác hành động này Xác nhận tiếp tục?",
  FE_41_B_DATA_DAY: "Ngày",
  FE_41_B_DATA_HOUR: "Giờ",
  FE_41_B_DATA_KEY_MANAGE: "Quản Lý Khóa",
  FE_41_B_DATA_NOTOPEN: "Tắt",
  FE_41_B_DATA_TIMEZONE: "Múi giờ",
  FE_41_B_DATA_TIPS1: "Bạn đã đạt giới hạn số khóa của bảng dữ liệu này.",
  FE_41_B_DATA_TIPS2: "Tạo một bảng dữ liệu giúp lưu trữ ngầm dữ liệu tích lũy nhằm giúp giảm thiểu nguy cơ mất dữ liệu.",
  FE_41_B_DATA_TIPS3: "Thêm vào giới hạn số lượng gradient",
  FE_41_B_DATA_TIPS4: "Thời gian được xóa đang ở sau thời gian hiện tại",
  FE_41_B_DATA_WEEK: "Tuần",
  FE_41_B_ECA_LISTTANY: "Danh sách bất kỳ",
  FE_41_B_LABEL_COPY: "Sao chép tên tập lệnh",
  FE_41_B_LABEL_EDIT: "Chỉnh sửa tên tập lệnh",
  FE_41_B_LABEL_FUNCTION: "Hàm khối",
  FE_41_B_LABEL_FUNCTION_PARA: "Tham số của Hàm khối",
  FE_41_B_LABEL_SCRIPTNAME: "Tên tập lệnh",
  FE_41_B_LABEL_TIPS1: `Tên tập lệnh chỉ có thể bao gồm ký tự, chữ số, dấu gạch dưới, và ký tự đầu tiên không thể là số.
`,
  FE_41_B_LABEL_TIPS2: "Tên tập lệnh đã tồn tại.",
  FE_41_B_LABEL_TIPS3: "Tên tập lệnh không thể là một từ khóa nội bộ.",
  FE_41_B_LABEL_TIPS4: "Tổng hợp thất bại",
  FE_41_B_LABEL_VARIBLE: "Biến khối",
  FE_41_HJ_AC_STATENOTEXIST: "Trạng thái {0} không tồn tại trong bộ điều khiển hoạt ảnh",
  FE_41_HZY_FILE_TERRAIN: "Tệp tin địa hình",
  FE_41_HZY_POINT_CONTEXTLIST: "Danh sách ngữ cảnh",
  FE_41_HZY_POINT_ID: "Số Serial ",
  FE_41_HZY_POINT_LIST: "Danh sách Điểm ngắt",
  FE_41_HZY_POINT_VALUE: "Giá trị",
  FE_41_HZY_SEARCH_NO_FILE: "Không tìm thấy tệp tin",
  FE_41_JH_AI_SELFIMPORTERROR: "Lỗi: Không thể liên tiếp nhập nút tùy chỉnh từ file dự án hiện tại.",
  FE_41_JH_BT_ACTIONNODE: "Hành động",
  FE_41_JH_BT_BEEDITOR: "Trình thiết kế AI",
  FE_41_JH_BT_BTNAME: "Cây hành vi",
  FE_41_JH_BT_COMPOSITE: "Tổ hợp",
  FE_41_JH_BT_CONDITIONNODE: "Điều kiện",
  FE_41_JH_BT_CREATENODE: "Tạo Nút",
  FE_41_JH_BT_DECORATORNODE: "Trang trí",
  FE_41_JH_BT_EDITNODE: "Chỉnh sửa Nút",
  FE_41_JH_BT_NODENAME: "Tên Nút",
  FE_41_JH_BT_NODENAMETIP: "Tên Nút không thể để trống.",
  FE_41_JH_BT_NODES: "Nút",
  FE_41_JH_BT_NODESCRIPT: "tập lệnh Nút",
  FE_41_JH_BT_NODESX: "Biến Nút",
  FE_41_JH_BT_NODETYPE: "Kiểu Nút",
  FE_41_JH_BT_NODEVARNUM: "Giá trị Nút",
  FE_41_JH_BT_NODEVARTYPE: "Kiểu biến Nút",
  FE_41_JH_BT_ROOTNODE: "Nút gốc",
  FE_41_JH_HACK_ANTIHACKCONTROL: "Bật tính năng chống hack",
  FE_41_SD_LOGICFRAME_SETTING: "Chế độ khung hình logic thấp (30>15)",
  FE_41_V_PROJECT_ANIM: "Hoạt ảnh",
  FE_41_V_PROJECT_CSV: "Tệp CSV",
  FE_41_V_PROJECT_ECATEMP: "Mẫu ECA",
  FE_41_V_PROJECT_UITEMP: "Mẫu UI",
  FE_41_V_PROJECT_XBT: "Tệp Cây hành vi",
  FE_41_V_PROJECT_XBTTEMP: "Mẫu XBT",
  FE_41_V_UI_CONTAINER: "Vật chứa 3D",
  FE_41_V_UI_CONTAINER_EFFECT: "Hiệu ứng đặc biệt",
  FE_41_V_UI_CONTAINER_MESH: "Mô hình",
  FE_41_V_UI_PANEL_TIPS: "Danh mục này sẽ luôn đứng đầu trên cây phân cấp UI",
  FE_41_V_UI_PANEL_TYPE: "Kiểu bảng điều khiển",
  FE_41_V_UI_PROFILE: "Ảnh đại diện",
  FE_41_V_UI_PROFILE_NICKNAME: "Biệt danh",
  FE_41_V_UI_PROFILE_PIN: "Mã Pin",
  FE_41_V_UI_PROFILE_PRANKED_TYPE: "Loại xếp hạng",
  FE_41_V_UI_PROFILE_RANKED: "Xếp hạng",
  FE_41_V_UI_PROFILE_TYPE_ONE: "Loại 1",
  FE_41_V_UI_PROFILE_TYPE_TWO: "Loại 2",
  FE_41_V_UI_TEXTURE: "Lớp phủ",
  FE_41_V_UI_TEXTURE_CENTER_INVISIBLE: "Vô hình ở giữa",
  FE_41_V_UI_TEXTURE_FILLED: "Lấp đầy",
  FE_41_V_UI_TEXTURE_FILL_AMOUNT: "Mật độ lớp phủ",
  FE_41_V_UI_TEXTURE_FILL_DIR: "Hướng lớp phủ",
  FE_41_V_UI_TEXTURE_FILL_HOR: "Ngang",
  FE_41_V_UI_TEXTURE_FILL_INVERT: "Đảo ngược lớp phủ",
  FE_41_V_UI_TEXTURE_FILL_RADIAL: "Hướng tròn",
  FE_41_V_UI_TEXTURE_FILL_VER: "Hướng dọc",
  FE_41_V_UI_TEXTURE_FIT: "Vừa vặn",
  FE_41_V_UI_TEXTURE_GRADIENT: "Dốc màu",
  FE_41_V_UI_TEXTURE_GRADIENT_DIR: "Hướng",
  FE_41_V_UI_TEXTURE_SIMPLE: "Đơn giản",
  FE_41_V_UI_TEXTURE_TILED: "Theo ô",
  FE_41_V_UI_TEXTURE_TILED_TRIM: "Cắt",
  FE_41_V_UI_WIDGET_TYPE: "Loại Widget",
  FE_41_XYL_IMPORT_NOTICE001: "Tính năng này không hỗ trợ nhập mã bản đồ Craftland Studio.",
  FE_41_XYL_IMPORT_NOTICE002: "Mã bản đồ hết hạn. Không thể nhập.",
  FE_41_XYL_INPUTMAP: "Bản đồ trực tuyến",
  FE_41_XYL_NAVMESH: "Lưới định vị tĩnh",
  FE_41_XYL_NAVMESHTIPS: "Vật thể với lựa chọn này sẽ chỉ tạo ra Lưới định vị tĩnh khi trận đấu bắt đầu.",
  FE_41_XYL_PREFABGENERATOR: "Mẫu (Thành phần ghép sẵn)",
  FE_41_ZQ_AC_ANIMCONTROLLER: "Điều khiển hoạt ảnh",
  FE_41_ZQ_AC_ANIMEDITOR: "Hoạt ảnh",
  FE_41_ZQ_AC_CLIP: "Hành động",
  FE_41_ZQ_AC_CLIPNO: "Số lượng hành động",
  FE_41_ZQ_AC_LOOP: "Lặp lại",
  FE_41_ZQ_AC_LOOPTIPS: "Hành động trước đang lặp lại. Hành động tiếp theo sẽ không được phát tự động.",
  FE_41_ZQ_AC_NEWCLIP: "Hoạt ảnh động mới",
  FE_41_ZQ_AC_NEWSTATE: "Trạng thái mới",
  FE_41_ZQ_AC_NOCLIP: "Không có hoạt ảnh động.",
  FE_41_ZQ_AC_PLAYSPEED: "Tốc độ phát",
  FE_41_ZQ_AC_STATE: "Trạng thái",
  FE_41_ZQ_ANIM_LENGTH: "Độ dài",
  FE_41_ZQ_BUILD_DYNAMIC: "Tải động",
  FE_41_ZQ_BUILD_DYNAMIC_TIP: "Khi chọn, tài nguyên này sẽ chỉ bắt đầu tải khi người chơi vào game.",
  FE_41_ZQ_BUILD_FILE: "Chọn thủ công bản ghi gói dữ liệu",
  FE_41_ZQ_BUILD_LAUNCH: "Trò chơi của bạn đã được nộp để đánh giá. Bản ghi gói dữ liệu này đã được tạo. Bạn có thể theo dõi quá trình đánh giá tại Trung tâm dữ liệu. Sau khi được chấp thuận, trò chơi của bạn sẽ tự động được xuất bản.",
  FE_41_ZQ_BUILD_PACKAGERULE: "Quy định gói dữ liệu",
  FE_41_ZQ_BUILD_REPACKAGE: "Phuong thức gói dữ liệu cơ bản",
  FE_41_ZQ_OPEN_PACKAGE_HISTORY: "Mở danh sách bản ghi",
  FE_41_ZQ_PACKAGE_RECORD: "Bản ghi gói dữ liệu",
  FE_42A_HJ_HUD_COMMONHUDSWITCH: "HUD Phổ biến",
  FE_42A_HJ_HUD_COUNTDOWN: "Bộ đếm ngược màn",
  FE_42A_HJ_HUD_COUNTDOWNREMIND: "Nhắc nhở đếm ngược",
  FE_42A_HJ_HUD_FACTIONINFO: "Thông tin đội",
  FE_42A_HJ_HUD_FIVECOUNTDOWN: "Đếm ngược 5 giây",
  FE_42A_HJ_HUD_MATCHINFO: "Phụ đề trận đấu",
  FE_42A_HJ_HUD_MATCHINFOSIMPLE: "Thông tin sơ bộ trận đấu",
  FE_42A_HJ_HUD_ROUNDRESULT: "Bảng hiệu vòng đấu bắt đầu",
  FE_42A_HJ_HUD_ROUNDTRANSITION: "Bảng hiệu vòng đấu kết thúc",
  FE_42A_HJ_HUD_TITLEBANNER: "Bảng hiệu tiêu đề",
  FE_42A_HJ_HUD_TWOTEAMMATCHINFO: "Bảng tỉ số",
  FE_42A_HJ_HUD_TWOTEAMSCORE: "Vòng đấu bắt đầu",
  FE_42A_HJ_HUD_TWOTEAMSTART: "Bảng hiệu chiến đấu đội",
  FE_42A_HJ_HUD_TYPE: "HUD tích hợp",
  FE_42A_HZY_ECAMOUNT_TIP: "Loại thành phần tương ứng không tồn tại trong thực thể này. Điều này có thể dẫn đến một phần mã lệnh không hoạt động như dự kiến: {0}.",
  FE_42A_HZY_WS_FUNCTIONCALL_D: `Đang đợi: Gọi hàm tuần tự.
 Thực thi: Gọi hàm song song.`,
  FE_42A_HZY_WS_LOCALVAR_D: "Định nghĩa và khởi tạo một biến cục bộ.",
  FE_42A_XYL_LOOTSWITCH: "Bật chế độ phân phối vật phẩm mặc định trên bản đồ",
  FE_42A_ZQ_ASSET_PICCONTROL: "{0} đã vượt quá cỡ 2048x2048. Vui lòng điều chỉnh và nhập lại.",
  FE_42A_ZQ_ASSET_PICREDUCE: "Kích thước file gốc quá lớn và đã được điều chỉnh lại để có kích thước dưới 2048px.",
  FE_42A_ZQ_ASSET_SIZECONTROL: "{0} đã vượt quá cỡ 2048x2048. Vui lòng điều chỉnh và nhập lại.",
  FE_42A_ZQ_ASSET_SOUNDCONTROL: "{0} fmod đã vượt quá 10,000,000. Vui lòng điều chỉnh và nhập lại.",
  FE_42A_ZQ_BATCH_OFFLINE: "Kết hợp vật thể ngoại tuyến",
  FE_42A_ZQ_BATCH_OFFLINETIPS: "Thực hiện kết hợp tĩnh tại thời điểm xuất file. Điều này có thể yêu cầu người chơi phải tải thêm tài nguyên.",
  FE_42A_ZQ_BATCH_RUNNING: "Kết hợp vật thể thời gian thực",
  FE_42A_ZQ_BATCH_RUNNINGTIPS: "Thực hiện kết hợp tĩnh trong lúc đang chạy. Điều này sẽ không tạo ra thêm tài nguyên mới.",
  FE_42A_ZQ_EFRAME_ADD: "Thêm Khung hình Sự kiện",
  FE_42A_ZQ_EFRAME_COPY: "Sao chép Khung hình Sự kiện",
  FE_42A_ZQ_EFRAME_DTL: "Xóa Khung hình Sự kiện",
  FE_42A_ZQ_EFRAME_PASTE: "Dán Khung hình Sự kiện",
  FE_42A_ZQ_EFRAME_SLT: "Chọn Khung hình Sự kiện",
  FE_42A_ZQ_MESH_FACECONTROL: "{0} chứa hơn 30,000 lưới mesh. Vui lòng giảm số lượng lưới và nhập lại.",
  FE_42A_ZQ_PCK_ROOT: "Chọn trong danh mục gốc",
  FE_42A_ZQ_PCK_ROOTERROR: "Đường dẫn không hợp lệ",
  FE_42A_ZQ_P_OPENING: "Đang mở...",
  FE_42A_ZQ_P_RUNNING: "Dự án đang chạy",
  FE_42A_ZQ_P_RUNNINGV: "Dự án đang chạy: {0}",
  FE_42A_ZQ_WEB_LAUNCH: "Xuất bản ngay",
  FE_42A_ZQ_WEB_LAUNCHERROR: "Xuất bản thất bại Vui lòng thử lại.",
  FE_42A_ZQ_WEB_LAUNCHSUC: "Đã tải lên trang Nhà sáng tạo. Vui lòng xuất bản thông qua Trung Tâm Sáng Tạo",
  FE_42_B_ECA_NORMAL: "ECA Phổ thông",
  FE_42_B_ECA_STATIC: "ECA Tĩnh",
  FE_42_B_SCRIPT_ECARELATED: "Các ECA liên quan",
  FE_42_B_SCRIPT_EXPORTPACKAGE: "Xuất ra",
  FE_42_B_SCRIPT_QUICKNAME: "Đặt tên tập lệnh nhanh",
  FE_42_B_SCRIPT_TIPS1: "Vui lòng chọn module bạn muốn xuất ra. Tên hiện tại nếu trùng với tên tập lệnh sẽ tự động được bỏ qua.",
  FE_42_B_SCRIPT_TIPS10: "Tự động chọn tất cả và chạy",
  FE_42_B_SCRIPT_TIPS2: "Chứa tên thành phần tùy chỉnh và tên thuộc tính tùy chỉnh",
  FE_42_B_SCRIPT_TIPS3: "Chứa tên trị số enum tùy chỉnh và tên trị số enum thuộc tính tùy chỉnh",
  FE_42_B_SCRIPT_TIPS4: "Chứa tên sự kiện tùy chỉnh.",
  FE_42_B_SCRIPT_TIPS5: "Chứa tên tệp tin ECA, tên biến, tên hàm, và giá trị trả về của hàm.",
  FE_42_B_SCRIPT_TIPS6: "Đặt tên tập lệnh nhanh đã hoàn thành cho {0} tập lệnh và thất bại với {1} tập lệnh. Kiểm tra thông báo lỗi để biết thêm chỉ tiết.",
  FE_42_B_SCRIPT_TIPS7: "Đặt tên tập lệnh: {0} không đạt tiêu chuẩn. Đặt tên thất bại.",
  FE_42_B_SCRIPT_TIPS8: "Đặt tên tập lệnh: {0} trùng tên. Đặt tên thất bại.",
  FE_42_B_SCRIPT_TIPS9: "Đặt tên tập lệnh: {0} chứa từ khóa nội bộ. Đặt tên thất bại.",
  FE_42_HJ_API_INTERNAL: "Khối nội bộ",
  FE_42_HJ_API_TEST: "Khối thử nghiệm",
  FE_42_HJ_BLOCKDESCINTERNAL: "Khối nội bộ",
  FE_42_HJ_BLOCKDESCTEST: "Khối thử nghiệm",
  FE_42_HJ_DEBUG_ENTITYNUM: "Số lượng thực thể",
  FE_42_HJ_DEBUG_ENTITYPROPNUM: "Số lượng đồng bộ thực thể",
  FE_42_HJ_DEBUG_LOGICDEBUG: "Debug Logic",
  FE_42_HJ_DEBUG_NETWORKDOWNLOAD: "Dữ liệu mạng (Tải xuống)",
  FE_42_HJ_DEBUG_NETWORKUPLOAD: "Dữ liệu mạng (Tải lên)",
  FE_42_HJ_DEBUG_SCENERYDEBUG: "Debug Trường cảnh",
  FE_42_HJ_DEBUG_WATCHLIST: "Danh sách theo dõi",
  FE_42_HJ_VFX_BLACKHOLE: "Hố đen",
  FE_42_HJ_VFX_BLACKHOLEEXPLOSION: "Hố đen phát nổ",
  FE_42_HJ_VFX_CRYSTALBALL: "Quả cầu pha lê",
  FE_42_HJ_VFX_INK: "Mực",
  FE_42_HJ_VFX_SPLASH: "Tung tóe",
  FE_42_HZY_SEARCH_BLOCK: "Tìm khối toàn cục",
  FE_42_HZY_SEARCH_BLOCKNAME: "Tìm theo tên khối này",
  FE_42_HZY_SEARCH_GLOBAL: "Tìm tham biến trong Toàn cục",
  FE_42_HZY_SEARCH_TIPS: "Nhập và nhấn Enter để tìm kiếm",
  FE_42_HZY_TERRAIN_DELETE_TIPS: `Chọn Cọ vẽ thực vật để bắt đầu đổ bóng.
Cọ + Shift: Xóa tất cả thảm thực vật trong phạm vi.
Cọ + Ctrl: Chỉ xóa loại thực vật được chọn.`,
  FE_42_HZY_TIP_DELETE_SLOT: "Không thể xuất bản bởi bản đồ trong ô này đã hết hạn. Vui lòng ghé qua Free Fire Craftland để xóa bản đồ này.",
  FE_42_JH_AIEDITOR_ACTIONFUNCNAME: "Hành động khởi chạy",
  FE_42_JH_AIEDITOR_TICKFUNCNAME: "Tick",
  FE_42_JH_AI_ADDTONEWNODE: "Sao chép thành Nút mới",
  FE_42_JH_AI_CLEAREDITOR: "Xóa sạch",
  FE_42_JH_AI_DELETEINPUT: "Xóa Nhập liệu nút",
  FE_42_JH_AI_DELETENODE: "Xóa Nút tùy chỉnh",
  FE_42_JH_AI_DELETEOUTPUT: "Xóa Xuất liệu nút",
  FE_42_JH_AI_DRWAERROR: "Nền chưa được khởi tạo",
  FE_42_JH_AI_FILELOADER: "Lỗi tải tệp tin",
  FE_42_JH_AI_NODEID: "ID Nút",
  FE_42_JH_AI_NOROOTNODE: "Vui lòng tạo nút gốc trước",
  FE_42_JH_AI_SETUP: "Thông tin Cơ bản",
  FE_42_JH_ECANAME1: "Cây hành vi - Hành vi thực thi",
  FE_42_JH_ECANAME2: "Cây hành vi - Đánh giá điều kiện",
  FE_42_JH_SCODE_ERROR1: "Độ dài của mã bản đồ rút gọn này không đáp ứng yêu cầu",
  FE_42_JH_SCODE_ERROR2: "Độ dài của mã bản đồ rút gọn phải gồm 6 ký tự chỉ bao gồm chữ in hoa và số.",
  FE_42_JH_SCODE_ERROR3: "Mã bản đồ rút gọn đã tồn tại.",
  FE_42_JH_SCODE_ERROR5: "Bạn có thể nhập 6 ký tự gồm các chữ cái in hoa và chữ số để tạo ra một mã bản đồ rút gọn có thể thay thế mã bản đồ trước đây.",
  FE_42_JH_SCODE_ERROR6: "Bản đồ này đã có sẵn mã rút gọn. Không thể chỉnh sửa.",
  FE_42_JH_SCODE_RANDOMSCODE: "Góc ngẫu nhiên",
  FE_42_JH_SCODE_SCODENAME: "Mã bản đồ rút gọn",
  FE_42_JH_WS_CUSTOMNODEDESC: "Mô tả nút",
  FE_42_JH_WS_DELETECUSTOMNODE: "Xóa nút",
  FE_42_JH_WS_DELETENODEPANEL: "Xác nhận xóa sạch khung nền",
  FE_42_JH_WS_EXSEQUENCE: "Thực thi tất cả nút con theo trình tự thời gian. Khi tất cả nút con trả về true, nút này sẽ trả về true; nếu không nó sẽ trả về false.",
  FE_42_JH_WS_EXWAIT: "Chờ đợi đến thời gian chỉ định. Bạn có thể thiết lập để thực thi hành động tiếp theo sau khi thời gian đó kết thúc.",
  FE_42_JH_WS_INVERTER: "Nhận giá trị ngược với giá trị thực thi của nút con.",
  FE_42_JH_WS_MAXS: "Thiết lập thời gian thực thi tối đa của nút con.",
  FE_42_JH_WS_MENPRIORITY: "Hoạt động như nút ưu tiên, ngoại trừ việc nó sẽ lưu trữ trạng thái thực thi của nút con nhằm thực thi từ tiến trình đã lưu của nút.",
  FE_42_JH_WS_MENSEQUENCE: "Hoạt động như nút nối tiếp, ngoại trừ việc nó sẽ lưu trữ trạng thái thực thi của nút con nhằm thực thi từ tiến trình đã lưu của nút.",
  FE_42_JH_WS_PRIORITY: "Thực thi tất cả nút con theo trình tự thời gian. Khi bất kỳ nút con nào trả về true, nút này sẽ trả về true; nếu không nó sẽ trả về false.",
  FE_42_JH_WS_REPEATX: "Thực thi nút con lặp lại cho đến khi đạt đến số lần thực thi chỉ định.",
  FE_42_JH_WS_REPETFAIL: "Thực thi nút con lặp lại cho đến khi trả về giá trị false.",
  FE_42_JH_WS_REPETSUCC: "Thực thi nút con lặp lại cho đến khi trả về giá trị true.",
  FE_42_M_BOMBER: "Thả Bom",
  FE_42_M_ShutdownDelay: "Thời gian trì hoãn tắt máy chủ",
  FE_42_M_StartTimeout: "Thời gian trì hoãn mở máy chủ",
  FE_42_SD_FCG_VSIX_INSTALL: "Thiếu môi trường phát triển tích hợp Cài đặt VSCode làm môi trường phát triển tích hợp?",
  FE_42_V_ACTION_ABOARD: "Vào Phương Tiện",
  FE_42_V_ACTION_ABOARD_DRIVER: "Vào làm Tài xế",
  FE_42_V_ACTION_ABOARD_OFF: "Vào/Thoát Phương Tiện",
  FE_42_V_ACTION_ABOARD_PASSENGER: "Vào làm Hành khách",
  FE_42_V_ACTION_BACK: "Di chuyển lùi",
  FE_42_V_ACTION_CROUCH: "Ngồi",
  FE_42_V_ACTION_DIVE: "Nhảy dù",
  FE_42_V_ACTION_FIRE: "Bắn",
  FE_42_V_ACTION_FORWARD: "Di chuyển tiến",
  FE_42_V_ACTION_GRENADE: "Lựu đạn",
  FE_42_V_ACTION_HUD_HIDE: "Ẩn UI",
  FE_42_V_ACTION_INTERACT: "Tương tác",
  FE_42_V_ACTION_JUMP: "Nhảy",
  FE_42_V_ACTION_LEFT: "Di chuyển trái",
  FE_42_V_ACTION_MOUSE_LOCKED: "Khóa chuột",
  FE_42_V_ACTION_MOVE: "Di chuyển",
  FE_42_V_ACTION_OFF: "Thoát khỏi Phương tiện",
  FE_42_V_ACTION_PICKUP: "Nhặt lên",
  FE_42_V_ACTION_PRONE: "Nằm",
  FE_42_V_ACTION_QUICK_SWITCH: "Đổi vũ khí nhanh",
  FE_42_V_ACTION_RELOAD: "Nạp đạn",
  FE_42_V_ACTION_RIGHT: "Di chuyển phải",
  FE_42_V_ACTION_RUN: "Chạy",
  FE_42_V_ACTION_SKILL: "Kỹ năng",
  FE_42_V_ACTION_SWITCH: "Đổi vũ khí",
  FE_42_V_ACTION_ZOOM: "Bật ngắm",
  FE_42_V_INPUT_ACTION: "Hành động trên bản đồ",
  FE_42_V_INPUT_CLICK: "Nháy",
  FE_42_V_INPUT_DOUBLE_CLICK: "Nháy đúp",
  FE_42_V_INPUT_DOWN: "Nhấn",
  FE_42_V_INPUT_KEY: "Nhập Nút",
  FE_42_V_INPUT_KEYBOARD: "Bàn phím",
  FE_42_V_INPUT_LIST: "Danh sách kết nối",
  FE_42_V_INPUT_MODE: "Hành động nhập",
  FE_42_V_INPUT_MOUSE: "Chuột",
  FE_42_V_INPUT_NUM: "Số lượng kết nối",
  FE_42_V_INPUT_PRESS: "Nhấn",
  FE_42_V_INPUT_RELEASE: "Thả",
  FE_42_V_INPUT_SYSTEM: "Thiết lập nhập liệu",
  FE_42_V_INPUT_SYSTEM_TIPS: "Trước khi thiết lập kết nối, vui lòng lưu nội dung trên bản sao thành một tệp UI.",
  FE_42_XXJ_FILEMISSING: "Thiếu tệp tài nguyên",
  FE_42_XXJ_INVAR: "Nhập liệu tại đây",
  FE_42_XXJ_NORETURN: "Lỗi: không có giá trị trả về",
  FE_42_XXJ_OUTVAR: "Giá trị xuất ra",
  FE_42_ZQ_ANIM_ADDANIMEVENT: "Thêm Sự kiện Hoạt ảnh",
  FE_42_ZQ_ANIM_ANIMEVENT: "Sự kiện Hoạt ảnh",
  FE_42_ZQ_ANIM_ANIMTIPS: "Mở bằng cách nháy đúp hoặc kéo tệp hoạt ảnh",
  FE_42_ZQ_ANIM_CANNOTEDIT: "Loại sự kiện này không thể bị thay đổi.",
  FE_42_ZQ_ANIM_COPYANIMEVENT: "Sao chép Sự kiện Hoạt ảnh",
  FE_42_ZQ_ANIM_DELETEANIMEVENT: "Xóa Sự kiện Hoạt ảnh",
  FE_42_ZQ_ANIM_DURATION: "Thời gian",
  FE_42_ZQ_ANIM_EFRAME: "Khung hình Sự kiện",
  FE_42_ZQ_ANIM_EVENTNUM: "Sự kiện Hoạt ảnh {0}",
  FE_42_ZQ_ANIM_EVENTSELECT: "Chọn sự kiện",
  FE_42_ZQ_ANIM_FRAME: "Khung hình",
  FE_42_ZQ_ANIM_MODELTIPS: "Không có mô hình có thể xem trước Vui lòng kéo mô hình vào khu vực này.",
  FE_42_ZQ_ANIM_NOANIMEVENT: "Không có Sự kiện Hoạt ảnh",
  FE_42_ZQ_ANIM_PARANUM: "Tham số {0}",
  FE_42_ZQ_ANIM_PASTEANIMEVENT: "Dán Sự kiện Hoạt ảnh",
  FE_42_ZQ_ANIM_TIME: "Thời gian",
  FE_42_ZQ_ASSET_CANNOTEDIT: "Không thể chỉnh sửa tài nguyên tham khảo",
  FE_42_ZQ_BATCH_DYNAMICBATCH: "Kết hợp vật thể động",
  FE_42_ZQ_BATCH_DYNAMICTIPS: "Tạo, phá hủy, hoặc thay đổi thuộc tính (chẳng hạn như thay đổi vị trí, xoay, hay thu phóng lớp phủ) vẫn sẽ được hỗ trợ khi dùng kết hợp vật thể động",
  FE_42_ZQ_ECA_TIP_BONE_EDITOR_DIS_SELECT: "Trường cảnh hiện tại là để điều chỉnh ngoại hình Không thể chọn vật thể",
  FE_42_ZQ_EVENT_NOTIPICALEVENT: "Không có loại sự kiện chỉ định",
  FE_42_ZQ_IMPORT_CANCEL: "Hủy",
  FE_42_ZQ_IMPORT_TARGETFILE: "Tệp mục tiêu",
  FE_42_ZQ_LOGIN_GOLOGIN: "Vui lòng đăng nhập.",
  FE_42_ZQ_MIPMAP: "Bật Mipmap",
  FE_42_ZQ_MIPMAP_TIP: "Bật Mipmap sẽ tăng nhẹ kích cỡ file và chi phí kết xuất nhưng sẽ cải thiện độ mượt của lớp phủ và hiển thị chi tiết.",
  FE_42_ZQ_OPAQUE: "Loại bỏ Alpha",
  FE_42_ZQ_OPAQUE_TIP: "Chọn lựa chọn này sẽ chặn kênh Alpha bị đọc (không ảnh hưởng đến atlas)",
  FE_42_ZQ_SK_APPEARENCE: "Ngoại Hình",
  FE_42_ZQ_SK_APPEARENCEGROUP: "Nhóm Ngoại Hình",
  FE_42_ZQ_SK_BINDMETHOD: "Phương thức liên kết",
  FE_42_ZQ_SK_BONESELECT: "Chọn Xương",
  FE_42_ZQ_SK_CONNECT: "Kết nối",
  FE_42_ZQ_SK_ENABLE: "Bật",
  FE_42_ZQ_SK_GROUP: "Nhóm Tương tranh loại trừ",
  FE_42_ZQ_SK_GROUPCONTROL: "Quản lý Nhóm Tương tranh Loại trừ",
  FE_42_ZQ_SK_MUTUALTIPS: "Trong cùng một Nhóm Tương tranh loại trừ, chỉnh sửa một nhóm ngoại hình sẽ khiến cho các nhóm ngoại hình khác bị vô hiệu.",
  FE_42_ZQ_SK_NEWAPPEARENCE: "Ngoại Hình Mới",
  FE_42_ZQ_SK_NEWAPPEARENCEGROUP: "Nhóm Ngoại Hình Mới",
  FE_42_ZQ_SK_NOBONE: "Không thể tìm xương tương ứng",
  FE_42_ZQ_SK_NORMALMESH: "Lưới Mesh phổ thông",
  FE_42_ZQ_SK_PARENTSK: "Khung xương mẹ",
  FE_42_ZQ_SK_SK: "Khung xương",
  FE_42_ZQ_SK_SKINFO: "Chi tiết xương",
  FE_42_ZQ_SK_SKINNED: "Da",
  FE_42_ZQ_SK_SKINNEDMESH: "Lưới Mesh Da",
  FE_42_ZQ_SK_SKSELECT: "Chọn Khung xương",
  FE_42_ZQ_SK_WARNING: "Không tìm thấy {1} trong {0}",
  FE_42_ZQ_STORE_ADDED: "Thêm vào Tài Nguyên",
  FE_42_ZQ_STORE_ADDFILE: "Vui lòng thêm tệp",
  FE_42_ZQ_STORE_ASSETS: "Tài nguyên",
  FE_42_ZQ_STORE_AUTHOR: "Nhà sáng tạo",
  FE_42_ZQ_STORE_BUILDFAIL: "Xuất ra thất bại",
  FE_42_ZQ_STORE_BUILDPCK: "Gói tài nguyên công cộng",
  FE_42_ZQ_STORE_BUILDPLACE: "Đang xuất bản tài nguyên... Bạn có thể xem chi tiết thông qua Tài nguyên của tôi > Đã xuất bản",
  FE_42_ZQ_STORE_BUILDSUC: "Tác vụ thành công!",
  FE_42_ZQ_STORE_BUILDTIPS: "Tài nguyên được tạo thành công! Xuất bản ngay?",
  FE_42_ZQ_STORE_CHANGEFILE: "Đổi File",
  FE_42_ZQ_STORE_CHOOSEPCK: "Chọn loại Tài nguyên để Tải xuống",
  FE_42_ZQ_STORE_CLOSE: "Dự án này đang bị chiếm dụng bởi một tác vụ khác. Vui lòng kết thúc tác vụ đó và thử lại. Nếu đã kết thúc tác vụ, vui lòng thử lại sau.",
  FE_42_ZQ_STORE_CURRENT_PROJECT_ONLY: "Bạn chỉ có thể nhập dự án hiện tại.",
  FE_42_ZQ_STORE_DESCRIPTION: "Mô tả",
  FE_42_ZQ_STORE_DOWNLOAD: "Tải xuống Tài nguyên",
  FE_42_ZQ_STORE_DOWNLOADED: "Đã tải xuống",
  FE_42_ZQ_STORE_FREE: "Miễn phí",
  FE_42_ZQ_STORE_FULLPCK: "Gói đầy đủ",
  FE_42_ZQ_STORE_FULLPCKSUC: "Đã thông báo thành công đến dự án để nhập toàn bộ gói tài nguyên.",
  FE_42_ZQ_STORE_FULLPCKTIPS: "Hỗ trợ chỉnh sửa. Kích thước file lớn hơn.",
  FE_42_ZQ_STORE_GET: "Lấy",
  FE_42_ZQ_STORE_IMPORT: "Nhập liệu",
  FE_42_ZQ_STORE_MYASSET: "Tài nguyên của tôi",
  FE_42_ZQ_STORE_MYUPLOAD: "Đã xuất bản",
  FE_42_ZQ_STORE_NAME: "Tiêu đề",
  FE_42_ZQ_STORE_NOASSET: "Chưa sở hữu tài nguyên",
  FE_42_ZQ_STORE_NORESULT: "Không có kết quả liên quan. Vui lòng thử lại với từ khóa khác.",
  FE_42_ZQ_STORE_NOTDOWNLOAD: "Chưa tải xuống",
  FE_42_ZQ_STORE_NOTUPLOADED: "Chưa xuất bản",
  FE_42_ZQ_STORE_NOUPLOAD: "Chưa có tài nguyên tải lên",
  FE_42_ZQ_STORE_OPENPROJECT: "Nhập toàn bộ gói tài nguyên bằng cách mở dự án mới.",
  FE_42_ZQ_STORE_OWNED: "Đã sở hữu",
  FE_42_ZQ_STORE_PICTIPS: "Kích thước đề xuất: {0}px. Kích thước phải dưới {1}.",
  FE_42_ZQ_STORE_PICWARNING: "Kích thước file vượt quá {0}.",
  FE_42_ZQ_STORE_PRICE: "Giá",
  FE_42_ZQ_STORE_REDOWNLOAD: "Tải lại",
  FE_42_ZQ_STORE_RELOAD: "Thay thế gói tài nguyên tham khảo. Bạn cần phải tải lại dự án.",
  FE_42_ZQ_STORE_RENEWAL: "Cập nhật gần đây",
  FE_42_ZQ_STORE_RESNAME: "Tên phải nằm trong khoảng từ {0} đến {1} ký tự.",
  FE_42_ZQ_STORE_RESPCK: "Gói tham khảo",
  FE_42_ZQ_STORE_RESPCKSUC: "Nhập thành công gói tài nguyên tham chiếu",
  FE_42_ZQ_STORE_RESPCKTIPS: "Không hỗ trợ chỉnh sửa. Kích thước file nhỏ và tốc độ nhanh hơn.",
  FE_42_ZQ_STORE_SELECTFILE: "Chọn một tệp",
  FE_42_ZQ_STORE_SELECTIMPORT: "Chọn Tài nguyên",
  FE_42_ZQ_STORE_UPDATE: "Nhấn vào đây để cập nhật tài nguyên.",
  FE_42_ZQ_STORE_UPDATEANDUPLOAD: "Xuất bản",
  FE_42_ZQ_STORE_UPDATECONFIRM: "Cập nhật gói tài nguyên? Khi xác nhận, những người dùng khác cũng sẽ được yêu cầu cập nhật tài nguyên.",
  FE_42_ZQ_STORE_UPDATEDOWNLOAD: "Tải xuống cập nhật",
  FE_42_ZQ_STORE_UPLOAD: "Tải lên",
  FE_42_ZQ_STORE_UPLOADCANCEL: "Nội dung đã điền sẽ không được lưu. Xác nhận để hủy tải lên?",
  FE_42_ZQ_STORE_UPLOADED: "Đã xuất bản",
  FE_42_ZQ_STORE_UPLOADING: "Đang xuất bản...",
  FE_43A_HZY_ACCOUNT_BOUNDTIP: "Đã phát hiện tài khoản Free Fire được đăng nhập. Nếu bạn thoát khỏi quá trình liên kết, thông tin về tài khoản được phát hiện sẽ bị xóa đi.",
  FE_43A_HZY_ACCOUNT_UNBOUND: "Hủy liên kết",
  FE_43A_HZY_ERROR_TIP1: "có thể được chuyển thành",
  FE_43A_HZY_ERROR_TIP2: "Không tìm thấy",
  FE_43A_HZY_PROJECT_SCREEN: "Bộ lọc",
  FE_43A_HZY_PROJECT_SCREENRESET: "Làm mới Bộ lọc",
  FE_43A_HZY_SCENE_ALIGNMENT: "Căn lề",
  FE_43A_HZY_SCENE_ALIGNMENTSET: "Thiết lập Căn lề",
  FE_43A_HZY_SCENE_ALIGNMENTTIP: "Nhấn giữ Ctrl để nhanh chóng bật/tắt tính năng này",
  FE_43A_HZY_SCENE_CAMERASPEED: "Chỉnh tốc độ Camera trong trường cảnh",
  FE_43A_HZY_SCENE_OPERATETIP: "Mô tả",
  FE_43A_HZY_SCENE_OPERATE_TIP1: "Chọn/Kéo chọn",
  FE_43A_HZY_SCENE_OPERATE_TIP10: "Hủy Địa hình",
  FE_43A_HZY_SCENE_OPERATE_TIP11: "Hủy",
  FE_43A_HZY_SCENE_OPERATE_TIP12: "Xóa thảm thực vật đã chọn",
  FE_43A_HZY_SCENE_OPERATE_TIP13: "Xóa tất cả thảm thực vật",
  FE_43A_HZY_SCENE_OPERATE_TIP2: "Xoay",
  FE_43A_HZY_SCENE_OPERATE_TIP3: "Di chuyển/Thu phóng",
  FE_43A_HZY_SCENE_OPERATE_TIP4: "Kéo thả nhanh",
  FE_43A_HZY_SCENE_OPERATE_TIP5: "Di chuyển",
  FE_43A_HZY_SCENE_OPERATE_TIP6: "Lên/Xuống",
  FE_43A_HZY_SCENE_OPERATE_TIP7: "Tăng tốc",
  FE_43A_HZY_SCENE_OPERATE_TIP8: "Đặt",
  FE_43A_HZY_SCENE_OPERATE_TIP9: "Thoát",
  FE_43A_M_TASKS: "Thiết lập nhiệm vụ Craftland",
  FE_43A_M_TASKS2: "Thiết lập Nhiệm vụ",
  FE_43A_M_TASKS3: "Tiến trình",
  FE_43A_SD_CLOTH_RES: "Trang phục",
  FE_43A_SD_CSV_RES: "CSV",
  FE_43A_SD_ECAC_RES: "ECAC",
  FE_43A_SD_ECA_RES: "ECA",
  FE_43A_SD_EFFECT_RES: "Hiệu ứng",
  FE_43A_SD_EMOTE_RES: "Hành động biểu cảm",
  FE_43A_SD_FCGC_RES: "FCGC",
  FE_43A_SD_INTERNALHUD_RES: "HUD Nội Bộ",
  FE_43A_SD_ITEM_RES: "Vật Phẩm",
  FE_43A_SD_MOD_RES: "Vật thể trong màn",
  FE_43A_SD_OTHER_RES: "Khác",
  FE_43A_SD_QUIT_INFOR: "Bạn chưa lưu các file sau. Lưu ngay?",
  FE_43A_SD_SOUND_RES: "Âm thanh",
  FE_43A_SD_TABM_CLOSE: "Đóng",
  FE_43A_SD_TABM_CLOSEOTHER: "Xóa thẻ khác",
  FE_43A_SD_TABM_CLOSERIGHT: "Xóa thẻ bên phải",
  FE_43A_SD_TABM_LOCATIONOPEN: "Mở thư mục chứa tệp",
  FE_43A_SD_TABM_LOCATIONVIEW: "Xem vị trí tệp",
  FE_43A_SD_TABM_SAVEALL: "Lưu tất cả thẻ",
  FE_43A_SD_TABM_SAVECURRENT: "Lưu File hiện tại",
  FE_43A_SD_TEXTURE_RES: "Lớp phủ",
  FE_43A_SD_VEHICLESKIN_RES: "Skin Phương Tiện",
  FE_43A_SD_WEAPONSKIN_RES: "Skin Vũ Khí",
  FE_43_HJ_NFPP_3CRESOURCE: "Tải xuống tài nguyên 3C",
  FE_43_HJ_NFPP_SWITCH: "Sử dụng tài nguyên FPP mới nhất",
  FE_43_HZY_COMPLIANT_TIP: `Phát hiện phiên bản không tương thích (phiên bản trình chỉnh sửa: {0}, phiên bản tài nguyên: {1})
Một vài tính năng có thể sẽ bị thiếu. Xác nhận tiếp tục?`,
  FE_43_HZY_UPDATE: "Cập nhật phiên bản",
  FE_43_HZY_UPDATE_CANCEL: "Cập nhật sau",
  FE_43_HZY_UPDATE_CONFIRM: "Cập nhật ngay",
  FE_43_HZY_UPDATE_MENU_TEST: "Kiểm tra cập nhật",
  FE_43_HZY_UPDATE_NETWORKERROR: "Lỗi mạng. Vui lòng thử lại sau.",
  FE_43_HZY_UPDATE_RETRY_TIP: "Việc này sẽ xóa sạch toàn bộ tiến trình hiện tại. Hãy thử tải lại nếu như tiến trình bị kẹt dù kết nối mạng vẫn ổn định.",
  FE_43_HZY_UPDATE_SAVE: "Lưu và Cập nhật",
  FE_43_HZY_UPDATE_TEST: "Kiểm tra phiên bản",
  FE_43_HZY_UPDATE_TIP: "Phiên bản Trình chỉnh sửa hiện tại đã lỗi thời. Vui lòng lưu lại file và cập nhật trình chỉnh sửa để sử dụng tính năng Xuất bản.",
  FE_43_HZY_UPDATE_TIP1: "Trình chỉnh sửa đã được cập nhật mới nhất",
  FE_43_HZY_UPDATE_TIP2: `Xác nhận phiên bản thất bại.
 Chưa kết nối với máy chủ. Vui lòng kiểm tra kết nối mạng và thử lại.`,
  FE_43_HZY_UPDATE_W_CLOSETIP: "Tải xuống Craftland Studio {0}. Bạn có muốn thoát?",
  FE_43_HZY_UPDATE_W_DEFAULT: `1. Sửa một vài lỗi đã nhận diện.
2. Tối ưu hóa một vài tính năng để tăng trải nghiệm.`,
  FE_43_HZY_UPDATE_W_DETAIL: "Cập nhật vào ngày {0}",
  FE_43_HZY_UPDATE_W_LOAD: "Đang tải xuống...",
  FE_43_HZY_UPDATE_W_RECONNECT: "Đang kết nối lại...",
  FE_43_HZY_UPDATE_W_RETRY: "Tải lại",
  FE_43_HZY_UPDATE_W_TIP1: "Lưu ý: Tìm thấy phiên bản mới. Khuyến nghị cập nhật từ phiên bản hiện tại {0} lên phiên bản mới nhất.",
  FE_43_HZY_UPDATE_W_TIP2: "Lưu ý: Phiên bản hiện tại {0} đã lỗi thời. Vui lòng cập nhật để tiếp tục sử dụng.",
  FE_43_HZY_UPDATE_W_WEB: "Xem Trang Chủ",
  FE_43_M_BOMBERSCRIPT: "Thả bom (Mã lệnh)",
  FE_43_SD_ASSETS: "Tài nguyên",
  FE_43_SD_ASSETS_IMPACK: "Nhập gói tài nguyên",
  FE_43_SD_ASSETS_IMPORT: "Nhập liệu",
  FE_43_SD_ASSETS_OUTPACK: "Xuất gói tài nguyên",
  FE_43_SD_ASSETS_PACKSHOP: "Cửa hàng tài nguyên",
  FE_43_SD_ASSETS_UPLOADPACK: "Xây dựng & Tải lên Gói tài nguyên",
  FE_43_SD_EDIT: "Chỉnh sửa",
  FE_43_SD_EDIT_COPY: "Sao chép",
  FE_43_SD_EDIT_DELETE: "Xóa",
  FE_43_SD_EDIT_DUPLICATE: "Nhân bản",
  FE_43_SD_EDIT_FOCUS: "Tập trung",
  FE_43_SD_EDIT_PASTE: "Dán",
  FE_43_SD_EDIT_REDO: "Tái thực hiện",
  FE_43_SD_EDIT_RENAME: "Đổi tên",
  FE_43_SD_EDIT_SAVE: "Lưu",
  FE_43_SD_EDIT_UNDO: "Hoàn tác",
  FE_43_SD_ERROR_DIVISOR: "Số bị chia không thể là 0",
  FE_43_SD_ERROR_KEY_NOTINMAP: "Khóa không tồn tại trong bản đồ: {0}",
  FE_43_SD_ERROR_LIST_OUTRANGE: "Dấu chỉ danh sách vượt quá phạm vi: {0}",
  FE_43_SD_FCG_ASSETLOST: "Mất file. Nội dung đăng ký không hợp lệ.",
  FE_43_SD_FCG_ASS_RES: "Đăng ký tài nguyên",
  FE_43_SD_FCG_DELETE_TEXT_B: "Xóa đăng ký tài nguyên?",
  FE_43_SD_FCG_DELETE_TEXT_F: "Bạn đã đăng ký sẵn nút con của tài nguyên. Đăng ký nút sẽ bị vô hiệu nếu bạn xóa đăng ký tài nguyên.",
  FE_43_SD_FCG_DELETE_WIN: "Lưu ý",
  FE_43_SD_FCG_ENTITYSELETE: "Chọn thực thể",
  FE_43_SD_FCG_FCG_RES: "FCG",
  FE_43_SD_FCG_FILESELETE: "Chọn File",
  FE_43_SD_FCG_KEY_NAMEINL: "Tên khóa không hợp lệ",
  FE_43_SD_FCG_N_DICT: "Tên biến tập lệnh",
  FE_43_SD_FCG_N_ENUM: "Tên Enum",
  FE_43_SD_FCG_N_GRAPH: "Tên đồ thị",
  FE_43_SD_FCG_OBJ_RES: "Đăng ký vật thể trường cảnh",
  FE_43_SD_FCG_PREFAB_RES: "Thành phần ghép sẵn",
  FE_43_SD_FCG_SCE_RES: "Trường cảnh",
  FE_43_SD_FCG_SCE_WAITRESIST: "Vui lòng đăng ký file trường cảnh trước",
  FE_43_SD_FCG_SYN_DES: "Cú pháp tham khảo",
  FE_43_SD_FCG_UI_RES: "UI",
  FE_43_SD_FCG_UI_WAITRESIST: "Vui lòng đăng ký file trường cảnh trước",
  FE_43_SD_FCG_UI_WID_RES: "Đăng ký điều khiển UI",
  FE_43_SD_FCG_WINDOWNAME: "Đăng ký tài nguyên tập lệnh",
  FE_43_SD_FILE: "Tệp tin",
  FE_43_SD_FILE_BUILD: "Xây dựng",
  FE_43_SD_FILE_EXIT: "Thoát",
  FE_43_SD_FILE_MODULE: "Thiết lập Hệ thống",
  FE_43_SD_FILE_NEW: "Dự án mới",
  FE_43_SD_FILE_OPEN: "Mở Dự án",
  FE_43_SD_FILE_PUBLISH: "Xuất bản Dự án",
  FE_43_SD_FILE_QUITRUN: "Thoát",
  FE_43_SD_FILE_RUN: "Chạy",
  FE_43_SD_FILE_SAVE: "Lưu Dự án",
  FE_43_SD_HELP: "Trợ giúp",
  FE_43_SD_HELP_ABOUT: "Thông tin",
  FE_43_SD_HELP_ACCOUNT: "Quản lý tài khoản",
  FE_43_SD_HELP_APIMANUAL: "Tài liệu API",
  FE_43_SD_HELP_CONTACT: "Thông tin liên hệ",
  FE_43_SD_HELP_SUGGEST: "Phản hồi và đóng góp",
  FE_43_SD_HELP_UPDATE: "Cập nhật phiên bản",
  FE_43_SD_HELP_UPDATELOG: "Cập nhật nhật ký",
  FE_43_SD_HELP_USERMANUAL: "Hướng dẫn người dùng",
  FE_43_SD_MODULE_ENTRY: "Thiết lập Hệ thống",
  FE_43_SD_SINGLEFILE_SAVE: "Lưu",
  FE_43_SD_TOOLS: "Công cụ",
  FE_43_SD_TOOLS_COMPONENT: "Quản lý Thành phần",
  FE_43_SD_TOOLS_DEBUG: "Thiết lập Debug",
  FE_43_SD_TOOLS_DEVELOPER: "Công cụ nhà phát triển",
  FE_43_SD_TOOLS_ENUM: "Quản lý Enum",
  FE_43_SD_TOOLS_FCG: "Công cụ tập lệnh",
  FE_43_SD_TOOLS_FCG_NAME: "Đặt tên tập lệnh nhanh",
  FE_43_SD_TOOLS_FCG_REGISTER: "Đăng ký tài nguyên tập lệnh",
  FE_43_SD_TOOLS_LOC: "Thiết lập Cục bộ",
  FE_43_SD_TOOLS_OPENLOG: "Mở Nhật ký",
  FE_43_SD_TOOLS_PREFER: "Yêu thích",
  FE_43_SD_TOOLS_SEARCH: "Tìm kiếm tất cả",
  FE_43_SD_TOOLS_WORDFILTER: "Lọc từ khiếm nhã",
  FE_43_SD_WINDOW: "Cửa sổ",
  FE_43_SD_WINDOW_DECK: "Bản lưu",
  FE_43_SD_WINDOW_FULL: "Toàn màn hình",
  FE_43_SD_WINDOW_LAYOUT: "Bố cục",
  FE_43_SD_WINDOW_LAYOUT_DEF: "Mặc định",
  FE_43_SD_WINDOW_LAYOUT_DEL: "Xóa bố cục",
  FE_43_SD_WINDOW_LAYOUT_SAVE: "Lưu bố cục",
  FE_43_TYC_ENABLE_UGC_SPECTATOR: "Bật chế độ theo dõi",
  FE_43_TYC_FREE_PERSPECTIVE: "Góc nhìn tự do",
  FE_43_TYC_FREE_PERSPECTIVE_WITH_REBOUND: "Góc nhìn tự do có làm mới góc nhìn",
  FE_43_TYC_KEEP_TARGET_PERSPECTIVE: "Khóa trên người chơi đã chọn",
  FE_43_TYC_ONLY_ALLOW_SPECTATING_SELF: "Chỉ bản thân",
  FE_43_TYC_ONLY_SPECTATING_ALLIES: "Chỉ người chơi không phải kẻ thù",
  FE_43_TYC_ONLY_SPECTATING_SAME_FACTION: "Chỉ người cùng phe",
  FE_43_TYC_ONLY_SPECTATING_SAME_TEAM: "Chỉ đồng đội",
  FE_43_TYC_PHYSICS_DESC_ANG: "Theo độ. Nếu góc nghiêng của dốc vượt quá giá trị này, nhân vật sẽ không thể đi lên và sẽ tự trượt xuống.",
  FE_43_TYC_PHYSICS_DESC_G: "Gia tốc trọng trường áp dụng lên nhân vật điều khiển",
  FE_43_TYC_PHYSICS_DESC_H: "Độ cao của phạm vi va chạm, bao gồm độ cao ở các bán cầu.",
  FE_43_TYC_PHYSICS_DESC_MAX_V: "Giá trị tốc độ tuyệt đối mà nhân vật điều khiển không thể vượt quá",
  FE_43_TYC_PHYSICS_DESC_MIN_D: "Nếu khoảng cách di chuyển thấp hơn giá trị này, nhân vật sẽ không di chuyển.",
  FE_43_TYC_PHYSICS_DESC_OFFSET: "Vector độ lệch kể từ tâm biến hình đến tâm phạm vi va chạm.",
  FE_43_TYC_PHYSICS_DESC_R: "Bán kính của phạm vi va chạm. Không thể vượt quá một nửa độ cao của phạm vi va chạm.",
  FE_43_TYC_PHYSICS_DESC_SKIN_W: "Độ sâu có thể khoét vào phạm vi va chạm để ngăn nhân vật bị kẹt hoặc giật lag",
  FE_43_TYC_PHYSICS_DESC_VTD: "Khoảng lệch cho phép khi nhân vật bước lên hoặc xuống cầu thang mà không bị chặn hoặc bay khỏi mặt đất",
  FE_43_TYC_SHOW_LOBBY_BUTTON: "Hiển thị nút sảnh chờ",
  FE_43_TYC_SPECTATING_ANY_TARGET: "Bất kỳ ai",
  FE_43_TYC_SPECTATOR_CAMERA_CONTROL_SETTING: "Điều khiên camera người xem",
  FE_43_TYC_SPECTATOR_SETTINGS: "Thiết lập Người xem",
  FE_43_TYC_SPECTATOR_TARGET_SETTING: "Mục tiêu Người xem",
  FE_43_TYC_UIED_TEXT_CLIPPING_SETTING: "Cắt xén văn bản",
  FE_43_TYC_UIED_TEXT_DIRECT_CLIPPING: "Cắt xén văn bản bị tràn",
  FE_43_TYC_UIED_TEXT_NO_CLIPPING: "Không cắt xén",
  FE_43_TYC_UIED_TEXT_REDUCE_FONT_SIZE: "Giảm kích cỡ phông chữ",
  FE_43_TYC_UIED_TEXT_SHADOW_COLOR: "Màu đổ bóng",
  FE_43_TYC_UIED_TEXT_SHADOW_ENABLED: "Bật đổ bóng",
  FE_43_TYC_UIED_TEXT_SHADOW_OFFSET: "Độ lệch đổ bóng",
  FE_43_TYC_UNEDITABEL_INTERNAL_TEXTURE: "Đây là một tài nguyên Free Fire. Bạn không thể chỉnh sửa nó.",
  FE_43_XXJ_COPYCOMPONENT: "Sao chép thành phần",
  FE_43_XXJ_GETVECTOR2COMPONENT: "Nhận Thành phần Vector2",
  FE_43_XXJ_GETVECTOR3COMPONENT: "Nhận Thành phần Vector3",
  FE_43_XXJ_MODULEUNOPENED: "Vui lòng bật các module tương ứng và thử lại.",
  FE_43_XXJ_PASTECOMPNEW: "Dán thành phần thành Mới",
  FE_43_XXJ_PASTECOMPVALUE: "Dán giá trị Thành phần",
  FE_43_XXJ_PHYSICS_ISCONVEX: "Có tính lồi",
  FE_43_XXJ_REQUIRECOMP: "Cần có thành phần",
  FE_43_XXJ_SETVECTOR2COMPONENT: "Gán Thành phần Vector2",
  FE_43_XXJ_SETVECTOR3COMPONENT: "Gán Thành phần Vector3",
  FE_43_XXJ_VECTOR2OPERATIONS: "Thao tác Vector2",
  FE_43_XXJ_VECTOR3OPERATIONS: "Thao tác Vector3",
  FE_43_XYL_AUTORENDERING: "Tự động kết hợp & kết xuất thực thể",
  FE_43_XYL_BATCHING: "Kết hợp vật thể",
  FE_43_XYL_CLIENT: "Máy khách (Client)",
  FE_43_XYL_CLIENTFCG: "FCG Máy khách",
  FE_43_XYL_CLINETECA: "ECA Máy khách",
  FE_43_XYL_CROSSEND: "Gửi qua hai đầu?",
  FE_43_XYL_CULLBACK: "Cull Back",
  FE_43_XYL_CULLMODE: "Chế độ Cull",
  FE_43_XYL_CULLOFF: "Tắt Cull",
  FE_43_XYL_ECACTEMPLATE: "Mẫu ECAC",
  FE_43_XYL_EVENTTARGETSIDE: "Phía sự kiện",
  FE_43_XYL_INHERITRENDERINGOPT: "Kế thừa thiết lập mẹ",
  FE_43_XYL_MASKCOLOR: "Màu phủ",
  FE_43_XYL_MASKTEXTURE: "Vân phủ",
  FE_43_XYL_MERGEMODELS: "Tự động kết hợp mô hình",
  FE_43_XYL_NOTIFYCLIENT: "Thông báo đến Client",
  FE_43_XYL_OFFLINECHILD: "Kết hợp các mô hình nút con khi ngoại tuyến",
  FE_43_XYL_ONLINECHILD: "Kết hợp các mô hình nút con tại thời điểm chạy",
  FE_43_XYL_PREFORMANCEOPT: "Tối ưu hiệu năng bản đồ",
  FE_43_XYL_REDUCTION: "Cắt giảm lưới mesh",
  FE_43_XYL_RENDERINGOPT: "Tối ưu hiệu năng kết xuất",
  FE_43_XYL_SERVER: "Máy chủ",
  FE_43_XYL_SERVERCLIENT: "Máy khách và Máy chủ",
  FE_43_XYL_SERVERECA: "ECA Máy chủ",
  FE_43_XYL_SERVERFCG: "FCG Máy chủ",
  FE_43_XYL_STREAMINGDIST: "Khoảng cách Stream",
  FE_43_XYL_STREAMINGDIVD: "Kích thước khu vực phân chia",
  FE_43_YU_WS_MODULEOPERATION: "Bạn cần phải tải module để sử dụng tính năng này",
  FE_43_YU_WS_MODULE_ALL: "Tất cả",
  FE_43_YU_WS_MODULE_BELONGEDMODULEDISABLE: "Các module phụ thuộc đang bất hoạt",
  FE_43_YU_WS_MODULE_BELONGEDMODULEMISS: "Các module tương ứng chưa được kích hoạt:",
  FE_43_YU_WS_MODULE_CANCEL: "Hủy",
  FE_43_YU_WS_MODULE_CANNOTINSTALLEDMODULES: "Không thể cài đặt một module thử nghiệm lên phiên bản chính",
  FE_43_YU_WS_MODULE_CANNOTINSTALLINTERNALMODULE: "Bạn không được cho phép cài đặt module này:",
  FE_43_YU_WS_MODULE_CONFIRMTHEUNINSTALL: "Tất cả API, sự kiện, và tài nguyên được sử dụng của module sẽ trở nên vô hiệu. Xác nhận gỡ cài đặt?",
  FE_43_YU_WS_MODULE_CUSTOMCURRENCY: "Tiền tệ tùy chỉnh",
  FE_43_YU_WS_MODULE_CUSTOMMINIMAP: "Bản đồ nhỏ tùy chỉnh",
  FE_43_YU_WS_MODULE_DEATHWATCH: "Chế độ theo dõi",
  FE_43_YU_WS_MODULE_DEFAULTMINIMAP: "Bản đồ nhỏ mặc định",
  FE_43_YU_WS_MODULE_DELETIONFAILED: "Xóa thiết lập module thất bại",
  FE_43_YU_WS_MODULE_DESCRIPTION: "Mô tả",
  FE_43_YU_WS_MODULE_DISABLE: "Tắt",
  FE_43_YU_WS_MODULE_DISABLEMODULE: "Các module phụ thuộc đang bất hoạt Vui lòng bật tất cả chúng lên để sử dụng các tính năng liên quan. Các module phụ thuộc bất hoạt bao gồm:",
  FE_43_YU_WS_MODULE_EXCLUSIVEMODULE: "Có module xung đột với một module hiện tại đang được bật. Vui lòng đảm bảo rằng chúng đã được tắt hết. Các module bao gồm:",
  FE_43_YU_WS_MODULE_EXITEXCLUSIVEMODULE: "Có module xung đột",
  FE_43_YU_WS_MODULE_FUNCTIONSTATUS: "Bật tính năng",
  FE_43_YU_WS_MODULE_LOADED: "Đã tải",
  FE_43_YU_WS_MODULE_LOADING: "Tải",
  FE_43_YU_WS_MODULE_LOADINGTIPS: "Lưu ý tải",
  FE_43_YU_WS_MODULE_MARKEDDISCARD: "Module này đã bị lỗi thời và không còn được hỗ trợ trong các phiên bản sau. Vui lòng ngừng sử dụng nó để tránh các nguy cơ có thể xảy ra.",
  FE_43_YU_WS_MODULE_MINIMAPTYPE: "Loại bản đồ nhỏ",
  FE_43_YU_WS_MODULE_MODMOVED: "Module này đã bị xóa",
  FE_43_YU_WS_MODULE_MODULEMANAGEMENT: "Quản lý Module",
  FE_43_YU_WS_MODULE_NAME: "Module",
  FE_43_YU_WS_MODULE_NOTLOADED: "Gỡ tải",
  FE_43_YU_WS_MODULE_NUMBEROFPLAYERS: "Số lượng Người chơi",
  FE_43_YU_WS_MODULE_ONECLICKLOADING: "Tải tất cả",
  FE_43_YU_WS_MODULE_ONLINEDATAMANAGEMENT: "Quản lý trực tuyến",
  FE_43_YU_WS_MODULE_OPENTHEMOD: "Module được bật:",
  FE_43_YU_WS_MODULE_PRESETTYPE: "Loại bộ chiến thuật nhân vật",
  FE_43_YU_WS_MODULE_REGISTRATIONFAILED: "Đăng ký thất bại",
  FE_43_YU_WS_MODULE_SCENE: "Trường cảnh",
  FE_43_YU_WS_MODULE_SETTINGS: "Thiết lập",
  FE_43_YU_WS_MODULE_SPECIALSETTINGS: "Thiết lập Đặc biệt",
  FE_43_YU_WS_MODULE_TYPESELECTION: "Chọn loại",
  FE_43_YU_WS_MODULE_UNINSTALL: "Gỡ cài đặt",
  FE_43_YU_WS_MODULE_UNINSTALLED: "Gỡ cài đặt Module thành công",
  FE_43_YU_WS_MODULE_UNINSTALLPROMPT: "Lưu ý gỡ cài đặt",
  FE_43_YU_WS_MODULE_UNLOADEDDEPENDENCYFEATURES: "Module này có tính năng phụ thuộc và cần phải được tải và bật để sử dụng các tính năng liên quan. Các tính năng phụ thuộc bị gỡ bao gồm:",
  FE_43_YU_WS_MODULE_WARNING1: "Khóa này không tồn tại trong bảng cài đặt",
  FE_43_YU_WS_MODULE_WARNING2: "Lỗi bảng cài đặt",
  FE_43_ZQ_PLAYER_ACTION: "Hành động",
  FE_43_ZQ_PLAYER_ADDACTION: "Thêm hành động nhân vật",
  FE_43_ZQ_PLAYER_ATTACK1FIST: "Tấn công trái",
  FE_43_ZQ_PLAYER_ATTACK2FIST: "Tấn công phải",
  FE_43_ZQ_PLAYER_ATTACK2GUN: "Bắn (Súng trường)",
  FE_43_ZQ_PLAYER_ATTACK2PISTOL: "Bắn (Súng lục)",
  FE_43_ZQ_PLAYER_BONETIPS: "Một vài khung xương sẽ không trùng khớp với nhân vật trong Free Fire. Điều này có thể dẫn đến hoạt ảnh bị sai lệch.",
  FE_43_ZQ_PLAYER_CACTION: "Hành động nhân vật",
  FE_43_ZQ_PLAYER_CHANGECLIPGUN: "Nạp đạn (Súng trường)",
  FE_43_ZQ_PLAYER_CHANGECLIPPISTOL: "Nạp đạn (Súng lục)",
  FE_43_ZQ_PLAYER_CHANGEWEAPON: "Đổi vũ khí",
  FE_43_ZQ_PLAYER_CMESH: "Lưới Mesh nhân vật",
  FE_43_ZQ_PLAYER_CRAWIDLEFIST: "Nằm",
  FE_43_ZQ_PLAYER_CRAWLCHANGECLIPGUN: "Nạp đạn khi Nằm (Súng trường)",
  FE_43_ZQ_PLAYER_CRAWLCHANGECLIPPISTOL: "Nạp đạn khi Nằm (Súng lục)",
  FE_43_ZQ_PLAYER_CRAWLCHANGEWEAPON: "Đổi vũ khí khi Nằm",
  FE_43_ZQ_PLAYER_CRAWLFFIST: "Trườn",
  FE_43_ZQ_PLAYER_CRAWLFGUN: "Trườn (Súng trường)",
  FE_43_ZQ_PLAYER_CRAWLFIREGUN: "Nhắm bắn khi Nằm (Súng trường)",
  FE_43_ZQ_PLAYER_CRAWLFIREPISTOL: "Nhắm bắn khi Nằm (Súng lục)",
  FE_43_ZQ_PLAYER_CRAWLFIRINGGUN: "Bắn khi Nằm (Súng trường)",
  FE_43_ZQ_PLAYER_CRAWLFIRINGPISTOL: "Bắn khi Nằm (Súng lục)",
  FE_43_ZQ_PLAYER_CRAWLFPISTOL: "Trườn (Súng lục)",
  FE_43_ZQ_PLAYER_CRAWLIDLEGUN: "Nằm (Súng trường)",
  FE_43_ZQ_PLAYER_CRAWLIDLEPISTOL: "Nằm (Súng lục)",
  FE_43_ZQ_PLAYER_CROUCHATTACK1FIST: "Tấn công trái khi Ngồi",
  FE_43_ZQ_PLAYER_CROUCHATTACK2FIST: "Tấn công trái khi Ngồi",
  FE_43_ZQ_PLAYER_CROUCHATTACK2GUN: "Bắn khi Ngồi (Súng trường)",
  FE_43_ZQ_PLAYER_CROUCHATTACK2PISTOL: "Bắn khi Ngồi (Súng lục)",
  FE_43_ZQ_PLAYER_CROUCHBGUN: "Ngắm bắn và lùi khi Ngồi (Súng trường)",
  FE_43_ZQ_PLAYER_CROUCHBPISTOL: "Ngắm bắn và lùi khi Ngồi (Súng lục)",
  FE_43_ZQ_PLAYER_CROUCHCHANGECLIPGUN: "Nạp đạn khi Ngồi (Súng trường)",
  FE_43_ZQ_PLAYER_CROUCHCHANGECLIPPISTOL: "Nạp đạn khi Ngồi (Súng lục)",
  FE_43_ZQ_PLAYER_CROUCHCHANGEWEAPON: "Đổi vũ khí khi Ngồi",
  FE_43_ZQ_PLAYER_CROUCHFFIST: "Di chuyển khi Ngồi",
  FE_43_ZQ_PLAYER_CROUCHFGUN: "Di chuyển khi Ngồi (Súng trường)",
  FE_43_ZQ_PLAYER_CROUCHFPISTOL: "Di chuyển khi Ngồi (Súng lục)",
  FE_43_ZQ_PLAYER_CROUCHIDLEFIST: "Ngồi",
  FE_43_ZQ_PLAYER_CROUCHIDLEGUN: "Ngồi (Súng trường)",
  FE_43_ZQ_PLAYER_CROUCHIDLEPISTOL: "Ngồi (Súng lục)",
  FE_43_ZQ_PLAYER_CROUCHLGUN: "Ngắm bắn và đi sang trái khi Ngồi (Súng trường)",
  FE_43_ZQ_PLAYER_CROUCHLPISTOL: "Ngắm bắn và đi sang trái khi Ngồi (Súng lục)",
  FE_43_ZQ_PLAYER_CROUCHRGUN: "Ngắm bắn và đi sang phải khi Ngồi (Súng trường)",
  FE_43_ZQ_PLAYER_CROUCHRPISTOL: "Ngắm bắn và đi sang phải khi Ngồi (Súng lục)",
  FE_43_ZQ_PLAYER_CUSTOMP: "Bộ chiến thuật nhân vật",
  FE_43_ZQ_PLAYER_DACTION: "Hành động mặc định",
  FE_43_ZQ_PLAYER_DASHRUNFFIST: "Chạy nhanh",
  FE_43_ZQ_PLAYER_DASHRUNFGUN: "Chạy nhanh (Súng trường)",
  FE_43_ZQ_PLAYER_DASHRUNFPISTOL: "Chạy nhanh (Súng lục)",
  FE_43_ZQ_PLAYER_DRIVERIDLE: "Thiết lập là Tài xế nhàn rỗi",
  FE_43_ZQ_PLAYER_FEMALE: "Nữ",
  FE_43_ZQ_PLAYER_GENDER: "Giới tính",
  FE_43_ZQ_PLAYER_GETRIG: "Nhấn vào đây để lấy hoạt ảnh khung xương mặc định",
  FE_43_ZQ_PLAYER_HIT: "Đánh",
  FE_43_ZQ_PLAYER_IDLE: "Nhàn rỗi",
  FE_43_ZQ_PLAYER_INCARIDLE: "Thiết lập là Hành khách nhàn rỗi",
  FE_43_ZQ_PLAYER_JUMPDOWNFIST: "Rơi",
  FE_43_ZQ_PLAYER_JUMPDOWNGUN: "Rơi (Súng trường)",
  FE_43_ZQ_PLAYER_JUMPDOWNPISTOL: "Rơi (Súng lục)",
  FE_43_ZQ_PLAYER_JUMPLANDFIST: "Đáp đất",
  FE_43_ZQ_PLAYER_JUMPLANDGUN: "Đáp đất (Súng trường)",
  FE_43_ZQ_PLAYER_JUMPLANDPISTOL: "Đáp đất (Súng lục)",
  FE_43_ZQ_PLAYER_JUMPUPFIST: "Bắt đầu nhảy",
  FE_43_ZQ_PLAYER_JUMPUPGUN: "Bắt đầu nhảy (Súng trường)",
  FE_43_ZQ_PLAYER_JUMPUPPISTOL: "Bắt đầu nhảy (Súng lục)",
  FE_43_ZQ_PLAYER_LINE: "Gạch dưới",
  FE_43_ZQ_PLAYER_MALE: "Nam",
  FE_43_ZQ_PLAYER_MOVE: "Di chuyển",
  FE_43_ZQ_PLAYER_NEARDEATHIDLE: "Bị hạ gục",
  FE_43_ZQ_PLAYER_NEARDEATHMOVE: "Bò về phía trước khi gục",
  FE_43_ZQ_PLAYER_NEWCUSTOMP: "Bộ chiến thuật nhân vật mới",
  FE_43_ZQ_PLAYER_NORMALDEAD: "Bị tiêu diệt",
  FE_43_ZQ_PLAYER_ONLYADDEDANIM: "Chỉ sử dụng các hoạt động được thêm",
  FE_43_ZQ_PLAYER_PLATFORM: "Nhân vật Free Fire",
  FE_43_ZQ_PLAYER_PREVIEWTIPS: "Vui lòng thêm mô hình trước!",
  FE_43_ZQ_PLAYER_RIG: "Lấy hoạt ảnh khung xương mặc định",
  FE_43_ZQ_PLAYER_RIGTIPS: "Nếu bạn muốn tùy chỉnh lưới mesh của nhân vật, khuyến nghị sử dụng hoạt ảnh khung xương chính thức và nhập chúng vào các phần mềm thiết kế mô hình để đảm bảo tất cả hoạt ảnh đều có thể phát chính xác.",
  FE_43_ZQ_PLAYER_RUNFFIST: "Tiến lên",
  FE_43_ZQ_PLAYER_RUNFGUN: "Tiến lên (Súng trường)",
  FE_43_ZQ_PLAYER_RUNFPISTOL: "Tiến lên (Súng lục)",
  FE_43_ZQ_PLAYER_SHOOTIDLEGUN: "Nhắm bắn khi Đứng yên (Súng trường)",
  FE_43_ZQ_PLAYER_SHOOTIDLEPISTOL: "Nhắm bắn khi Đứng yên (Súng lục)",
  FE_43_ZQ_PLAYER_STANDIDLEFIST: "Đứng yên",
  FE_43_ZQ_PLAYER_STANDIDLEGUN: "Đứng yên (Súng trường)",
  FE_43_ZQ_PLAYER_STANDIDLEPISTOL: "Đứng yên (Súng lục)",
  FE_43_ZQ_PLAYER_WALKBGUN: "Lùi lại khi Nhắm (Súng trường)",
  FE_43_ZQ_PLAYER_WALKBPISTOL: "Lùi lại khi Nhắm (Súng lục)",
  FE_43_ZQ_PLAYER_WALKFGUN: "Tiến lên khi Nhắm (Súng trường)",
  FE_43_ZQ_PLAYER_WALKFPISTOL: "Tiến lên khi Nhắm (Súng lục)",
  FE_43_ZQ_PLAYER_WALKLGUN: "Di chuyển trái khi Nhắm (Súng trường)",
  FE_43_ZQ_PLAYER_WALKLPISTOL: "Di chuyển trái khi Nhắm (Súng lục)",
  FE_43_ZQ_PLAYER_WALKRGUN: "Di chuyển phải khi Nhắm (Súng trường)",
  FE_43_ZQ_PLAYER_WALKRPISTOL: "Di chuyển phải khi Nhắm (Súng lục)",
  FE_43_ZQ_REMOVE_REMOVE: "Loại bỏ",
  FE_43_ZQ_REVIEW_LINEROW: "Phát hiện từ ngữ nhạy cảm {3}  tại Hàng {1}, Cột {2} ở {0}. Vui lòng kiểm tra và thử lại.",
  FE_43_ZQ_REVIEW_MEANNING: "Phát hiện nội dung nhạy cảm tại {0}. Vui lòng kiểm tra và thử lại.",
  FE_43_ZQ_STORE_BACK: "Quay lại",
  FE_43_ZQ_STORE_CHANGEPROJECT: "Tài nguyên tham khảo này đến từ dự án hiện tại. Vui lòng thử lại với từ khóa khác.",
  FE_43_ZQ_STORE_CODE: "Mã Định Danh Tài Nguyên",
  FE_43_ZQ_STORE_CODECHANGE: "Mã Định Danh Tài Nguyên đã thay đổi!",
  FE_43_ZQ_STORE_CREATE: "Tài nguyên mới",
  FE_43_ZQ_STORE_DELETEPURCHASE: "Loại bỏ khỏi Tài nguyên",
  FE_43_ZQ_STORE_DETAIL: "Chi tiết",
  FE_43_ZQ_STORE_DOWN: "Loại bỏ khỏi Cửa hàng",
  FE_43_ZQ_STORE_EDIT: "Chỉnh sửa",
  FE_43_ZQ_STORE_ESTSIZE: "Ước tính Kích thước",
  FE_43_ZQ_STORE_FABCANNOT: "Tài nguyên này không thể được đóng gói thành tài nguyên cửa hàng",
  FE_43_ZQ_STORE_HIGHVERSION: "Phiên bản của tài nguyên cửa hàng này cao hơn tài nguyên hiện tại",
  FE_43_ZQ_STORE_NEEDLOGIN: "Vui lòng đăng nhập trước để tải lên",
  FE_43_ZQ_STORE_NEWRES: "Xuất bản Tài nguyên mới",
  FE_43_ZQ_STORE_NEWRESTIPS: "Thêm Tài nguyên vào Cửa hàng tài nguyên",
  FE_43_ZQ_STORE_NEXT: "Tiếp theo",
  FE_43_ZQ_STORE_NOSEARCH: "Không có tài nguyên liên quan",
  FE_43_ZQ_STORE_OPENED: "Không thể thoát Craftland Studio khi dự án vẫn đang mở",
  FE_43_ZQ_STORE_PUBSET: "Thiết lập Xuất bản",
  FE_43_ZQ_STORE_QUOTECANNOT: "Tài nguyên không thể được đóng gói thành tài nguyên cửa hàng bởi nó hoặc tham chiếu của nó chứa tài nguyên từ gói tham khảo.",
  FE_43_ZQ_STORE_REMOVEMYASSET: "Tài nguyên này sẽ bị xóa khỏi mục Tài nguyên, nhưng tệp tin trong hệ thống sẽ không bị xóa. Xác nhận tiếp tục?",
  FE_43_ZQ_STORE_REMOVEMYUPLOAD: "Tài nguyên sẽ bị loại bỏ khỏi mục Đã xuất bản. Xác nhận tiếp tục?",
  FE_43_ZQ_STORE_RESDETAIL: "Chi tiết Tài nguyên",
  FE_43_ZQ_STORE_RESERRORTIPS: "Lưu lại thất bại do lỗi tác vụ",
  FE_43_ZQ_STORE_RESSCENETIPS: "Đây là tài nguyên tham chiếu và không thể được lưu. Nó sẽ được khôi phục lại khi bạn truy cập lần sau.",
  FE_43_ZQ_STORE_TRANSFERTIPS: "Đang chuyển giao tài nguyên... Tác vụ sẽ bị ngắt nếu bạn chọn thoát. Xác nhận tiếp tục?",
  FE_43_ZQ_STORE_TYPE: "Loại tài nguyên",
  FE_43_ZQ_STORE_UNPUB: "Loại bỏ khỏi Cửa hàng",
  FE_43_ZQ_STORE_UNPUBCONFIRM: "Tài nguyên này không còn được mở cho những người chơi khác nếu bạn loại bỏ nó khỏi cửa hàng. Xác nhận tiếp tục?",
  FE_43_ZQ_STORE_UPDATERES: "Cập nhật Tài nguyên",
  FE_43_ZQ_STORE_UPDATERESTIPS: "Thay thế tài nguyên được xuất bản trong Cửa hàng tài nguyên.",
  FE_43_ZQ_STORE_UPDATETIME: "Thời gian cập nhật",
  FE_43_ZQ_STORE_UPLOAD: "Tải lên",
  FE_43_ZQ_STORE_UPTIME: "Thời gian tải lên",
  FE_43_ZQ_STORE_VERSION: "Phiên bản trình chỉnh sửa",
  FE_44A_HJ_ERRORCODE1: "Lỗi sự kiện tùy chỉnh",
  FE_44A_HJ_ERRORCODE2: "Lỗi kiểu tùy chỉnh",
  FE_44A_SD_SETTING_UNITTESTBUILD: "Sử dụng để thực hiện kiểm thử đơn vị cho mục đích QA",
  FE_44A_SD_UNITTEST_BUILD: "Xây Dựng Đơn Vị Kiểm Thử",
  FE_44A_XXJ_ACTION: "Hành động",
  FE_44A_XXJ_BASIC: "Cơ bản",
  FE_44A_XXJ_COMPCONFLICK: "Thành phần này xung đột với các thành phần khác: {0}",
  FE_44A_XXJ_CONDITION: "Điều kiện",
  FE_44A_XXJ_CSVDATA: "Dữ liệu CSV",
  FE_44A_XXJ_DEPENDMISS: "Thành phần phụ thuộc chưa được thêm vào: {0}",
  FE_44A_XXJ_SUPPLY: "Bổ trợ",
  FE_44A_XXJ_VARIABLE: "Biến",
  FE_44A_XXJ_WARNING_COMPCONFLICK: "{0}: Thành phần {1} xung đột với {2}",
  FE_44A_XXJ_WARNING_COMPDEPENDMISS: "{0}: Thành phần phụ thuộc {2} của {1} chưa được thêm",
  FE_44_HZY_BLADEBALL: "Blade Ball",
  FE_44_HZY_BLOCKINVALID_TIP1: "Khối không được hỗ trợ trên máy chủ",
  FE_44_HZY_BLOCKINVALID_TIP2: "Khối không được hỗ trợ trên máy khách",
  FE_44_HZY_BLOCKPERMISSION_CONCSOLE: "Bạn sẽ không thể xuất bản vì bạn đang sử dụng khối mình không được quyền sử dụng",
  FE_44_HZY_BLOCKPERMISSION_WARNING: "Bạn không được phép sử dụng khối này",
  FE_44_HZY_GUNKING: "Gun King",
  FE_44_HZY_HIERARCHY_MOUNTSCRIPT: "có Tập lệnh",
  FE_44_HZY_INSPECTOR_ADDCOMPONENT: "Thêm Thành phần",
  FE_44_HZY_INSPECTOR_TEXTURE: "Lớp phủ",
  FE_44_HZY_INSPECTOR_TILLING: "Phân ô",
  FE_44_HZY_INSPECTOR_TYPE: "Loại",
  FE_44_HZY_MAPCOVER_PERMISIONTIP: "Không được phép sử dụng ảnh nền tùy chỉnh",
  FE_44_HZY_PERMISSIONTIPS1: "Dự án này có thể chứa các tài nguyên bạn không có quyền chỉnh sửa. Điều này có thể gây lỗi khi xuất bản.",
  FE_44_HZY_PERMISSIONTIPS2: "Không thể xuất bản dự án do có chứa tài nguyên bạn không có quyền chỉnh sửa",
  FE_44_HZY_PROJECT_BASICOBJECT: "Vật thể cơ bản",
  FE_44_HZY_PROJECT_CREATIONTIME: "Sắp xếp theo thời gian được tạo",
  FE_44_HZY_PROJECT_LASTEDITTIME: "Sắp xếp theo thời gian mở gần nhất",
  FE_44_HZY_PVE: "Bắn Zombie",
  FE_44_HZY_REVIEW_BASE: "Thông tin cơ bản",
  FE_44_HZY_REVIEW_ROOMPAR: "Tham số phòng tùy chọn",
  FE_44_HZY_SEARCH_FUNCTIONNAME: "Tìm kiếm theo tên Hàm",
  FE_44_HZY_SEARCH_VARIABLENAME: "Tìm kiếm theo tên Biến",
  FE_44_HZY_SNIPER: "Bắn tỉa",
  FE_44_M_WS_LOCALVAR: "Biến Cục Bộ",
  FE_44_SD_CUSRESULT: "Tải lên Kết Quả Trận Đấu Tùy Chỉnh",
  FE_44_SD_EDIT_SELECT_ALL: "Chọn tất cả",
  FE_44_SD_EDIT_SELECT_CHILD: "Chọn tất cả con",
  FE_44_SD_EDIT_SELECT_INV: "Nghịch đảo",
  FE_44_SD_EDIT_SELECT_PARENT: "Chọn tất cả mẹ",
  FE_44_SD_FCG_COMPILE: "Biên dịch tập lệnh",
  FE_44_SD_FCG_ENV: "Môi trường triển khai FCG thủ công",
  FE_44_SD_TIPSFCG: "Cú pháp tập lệnh",
  FE_44_TYC_ACTIVE: "Trạng thái kích hoạt",
  FE_44_TYC_ADD_ANIMATION_CLIP: "Vui lòng thêm hoạt ảnh",
  FE_44_TYC_ARROR: "Mũi tên định hướng",
  FE_44_TYC_DRAG_RADIUS: "Bán kính kéo",
  FE_44_TYC_INACTIVE: "Trạng Thái Bất Hoạt",
  FE_44_TYC_JOYSTICK: "Joystick",
  FE_44_TYC_JOYSTICK_BG: "Nền cần điều khiển",
  FE_44_TYC_JOYSTICK_CAP: "Nút cần điều khiển",
  FE_44_TYC_KEEP_PRESSED_OUTSIDE: "Cho phép kéo ra ngoài phạm vi",
  FE_44_TYC_OFFSET: "Khoảng lệch",
  FE_44_TYC_PLAYER_ANIMATION_NEED_SSS: "Vui lòng thêm hoạt ảnh Đứng, Đứng (Súng Trường), và Đứng (Súng Lục).",
  FE_44_TYC_RADIUS: "Bán kính",
  FE_44_TYC_TOGGLE: "Nút bật tắt",
  FE_44_TYC_TOUCHPAD: "Touchpad",
  FE_44_TYC_TRANSPARENCY: "Độ trong suốt",
  FE_44_TYC_WARNING_SERVER_DRIVEN_DISABLED: 'Thuộc tính "IsServerDrive" của điều khiển nhân vật Craftland {0} đã bị tắt, vì vậy API máy chủ liên quan không có hiệu lực.',
  FE_44_XXJ_ASSETTYPE: "Loại tài nguyên",
  FE_44_XXJ_COMPOBSOLETE: "Thành phần này đã bị lỗi thời. Vui lòng loại bỏ nó để tránh các lỗi liên quan.",
  FE_44_XXJ_EDITCCTSHAPE: "Chỉnh sửa hình dạng CCT",
  FE_44_XXJ_GAMERESULT: "Kết quả trận đấu",
  FE_44_XXJ_GETRIGISTERASSETBYKEY: "Lấy Tài nguyên đã đăng ký theo Khóa",
  FE_44_XXJ_MODULEERROR: "Xuất thất bại do xung đột module. Vui lòng kiểm tra lại thiết lập quản lý module và thử lại.",
  FE_44_XXJ_PREPARING: "Sắp ra mắt",
  FE_44_XXJ_ROUNFPHASEINDEX: "Chỉ mục Vòng Đấu & Giai Đoạn",
  FE_44_XXJ_TIPCONTENTHIDE: "Số lượng vật phẩm bị ẩn: {0}. Không phải tất cả các danh sách đều chứa các vật phẩm này.",
  FE_44_XXJ_WOWEMPTY: "Úi... không có gì ở đây cả",
  FE_44_XXJ_WS_RIGISTERRESNAME: "Khóa",
  FE_44_XYL_AUTOLOD0: "Không tự động tạo LOD",
  FE_44_XYL_AUTOLOD1: "Kích thước mô hình > 15m",
  FE_44_XYL_AUTOLOD2: "2m < Kích thước mô hình < 15m",
  FE_44_XYL_AUTOLOD3: "Kích thước mô hình < 2m",
  FE_44_XYL_AUTOREDUCTION: "Tự động tinh giản đồ họa",
  FE_44_XYL_DYNAMICNAVBLOCK: "Khối NavMesh Động",
  FE_44_XYL_DYNAMICNAVBLOCKDESC: "Tạo hoặc hủy khối cản trở quá trình tìm đường của lưới mesh dựa trên trạng thái thêm hoặc loại bỏ của vật thể được thiết lập động. Thiết lập toàn cục cho  lưới NavMesh Động phải được bật trước để có thể sử dụng tính năng này.",
  FE_44_XYL_PREVIEWANIM: "Vui lòng chọn tệp hoạt ảnh có thể xem trước",
  FE_44_XYL_REDUCTIONLIST: "Danh sách Tinh giản Mesh",
  FE_44_XYL_SERVERSLOADAREA: "Khu vực chờ tải máy chủ",
  FE_44_XYL_SERVERSLOADAREACHILD: "Khu vực",
  FE_44_XYL_SERVERSLOADCHOOSE: "Mở khu vực chờ tải máy chủ trong trường cảnh",
  FE_44_XYL_SERVERSLOADDESC: "Chọn để cho phép chỉnh sửa khu vực chờ tải máy chủ trong Cây Phân Cấp và trong cảnh (tính năng chưa hỗ trợ đối với Đảo Quân Sự)",
  FE_44_XYL_SERVERSLOADSETTING: "Thiết lập tải máy chủ",
  FE_44_XYL_SERVERTOCLIENT: "Đồng bộ với Máy khách",
  FE_44_XYL_SERVERTOCLIENTDESC: "Đồng bộ logic máy chủ của vật thể với máy khách",
  FE_44_XYL_STREAMING0: "Luôn Stream",
  FE_44_ZQ_IMPORT_PCKWARNING: "Dự án đã có gói tài nguyên này. Nhập lại gói tài nguyên có thể dẫn đến một số tài nguyên bị thay thế hoặc tham chiếu bị ngắt. Xác nhận tiếp tục?",
  FE_44_ZQ_PREVIEW_RUNGAME: "Tài nguyên này không hỗ trợ xem trước. Vui lòng khởi chạy trò chơi để kiểm tra.",
  FE_44_ZQ_PREVIEW_SELECT: "Vui lòng chọn mô hình để xem trước",
  FE_44_ZQ_RES_LOST: "Tài nguyên tham chiếu {0} bị mất",
  FE_44_ZQ_RES_NOEDIT: "Từ tài nguyên tham chiếu: {0}. Không thể chỉnh sửa.",
  FE_44_ZQ_RES_PHASETIPS: "Khối với chỉ số giai đoạn sẽ không thể được xuất ra thành gói tham khảo",
  FE_44_ZQ_RES_PREECA: "Tập lệnh đặt sẵn",
  FE_44_ZQ_RES_PRESFROM: "Tham chiếu từ {0}",
  FE_44_ZQ_RES_RESENUM: "Enum từ Gói tham chiếu",
  FE_45A_M_MODIFICATION: "Xác nhận chỉnh sửa dữ liệu?",
  FE_45A_M_SAVEFAILED: "Lỗi xảy ra khi chỉnh sửa dữ liệu. Không thể lưu dữ liệu.",
  FE_45A_SD_ISSTATIC: "Tĩnh",
  FE_45A_SD_NAME_ECA: "Tập khối lệnh",
  FE_45A_SD_NAME_ECAC: "Tập khối lệnh máy khách",
  FE_45A_SD_NAME_FCC: "Thư viện tùy chọn",
  FE_45A_SD_NAME_FCG: "Tập mã lệnh",
  FE_45A_SD_NAME_FCGC: "Tập mã lệnh máy khách",
  FE_45A_SD_NAME_OTHER: "Tập lệnh khác",
  FE_45A_SD_SCRIPTNAME_CURRENT: "Tên hiện tại",
  FE_45A_SD_SCRIPTNAME_HOLDER: "Nhập tên ở đây",
  FE_45A_SD_SCRIPTNAME_TYPE: "Kiểu",
  FE_45A_SD_STATICTIPS: "Tập lệnh tĩnh sẽ được tự động gán vào thực thể Toàn cục và thực thi tại thời điểm khởi chạy.",
  FE_45A_SD_STATIC_FILE: "Tập lệnh tĩnh",
  FE_45A_XXJ_ERRORCODE: "Mã trạng thái",
  FE_45A_XXJ_OVERLIMIT: "Ngoài giới hạn",
  FE_45A_XXJ_PARAMERROR: "Lỗi tham số",
  FE_45A_XXJ_TIMEOUT: "Hết thời gian",
  FE_45A_XYL_FEBRUSHGRASS: "Số lượng cỏ tối đa",
  FE_45A_XYL_FEBRUSHROCK: "Số lượng đá tối đa",
  FE_45A_XYL_FEBRUSHSHRUB: "Số lượng bụi cây tối đa",
  FE_45A_XYL_FEBRUSHTREE: "Số lượng cây tối đa",
  FE_45A_XYL_FEBRUSHWARN: "Không thể điều chỉnh các địa hình cùng lúc vì chúng đang sử dụng chung tài nguyên.",
  FE_45A_XYL_FETIPS1: "Thoát chế độ điêu khắc",
  FE_45A_XYL_FETIPS2: "Giảm kích cỡ",
  FE_45A_XYL_FETIPS3: "Tăng kích cỡ",
  FE_45A_XYL_FETIPS4: "Cọ vẽ thực vật",
  FE_45A_XYL_FETIPS5: "Số cọ vẽ thực vật đạt giới hạn. vui lòng giảm số lượng.",
  FE_45A_XYL_FETIPS6: "File địa hình",
  FE_45_HJ_PLATFORM_ADDFRIEND: "Thêm nút bạn bè",
  FE_45_HJ_PLATFORM_BRIGHT: "Kiểu nút 1",
  FE_45_HJ_PLATFORM_DARK: "Kiểu nút 2",
  FE_45_HJ_PLATFORM_PERMISSIONTIPS1: "Bạn không thể xuất bản dự án, bởi tài khoản của bạn không được cấp phép một vài widget UI đã sử dụng.",
  FE_45_HJ_PLATFORM_REPORT: "Nút báo cáo",
  FE_45_HJ_PLATFORM_SEETING: "Loại thông báo lời mời kết bạn",
  FE_45_HJ_PLATFORM_SEETINGMESSAGE: "Thông báo tin nhắn",
  FE_45_HJ_PLATFORM_SEETINGTYPE: "Bật pop-up lời mời kết bạn",
  FE_45_HJ_PLATFORM_SEETINGWINDOW: "Thông báo pop-up trong trận",
  FE_45_HJ_PLATFORM_WIDGET: "Widget tính năng Free Fire",
  FE_45_HZY_FOURFRIENDS: "Giải Đố",
  FE_45_HZY_FOURFRIENDS_D: "Khám phá lối chơi giải đố tương tác với góc nhìn thứ nhất",
  FE_45_HZY_SCENE_OPERATE_TIP14: "Xoay quanh trục X/Y/Z",
  FE_45_HZY_SCENE_OPERATE_TIP15: "Vẽ",
  FE_45_SD_AIS_AI: "Tìm kiếm AI",
  FE_45_SD_AIS_BTN: "Tìm với AI",
  FE_45_SD_AIS_DEF: "Tìm kiếm mặc định",
  FE_45_SD_AIS_NORESULT: "Tìm kiếm AI không tìm thấy kết quả mới",
  FE_45_SD_BASICTEMPLATE: "Mẫu cơ bản",
  FE_45_SD_BERMUDA: "Đảo Quân Sự",
  FE_45_SD_CREATE: "Tạo",
  FE_45_SD_DESC_BERMUDA: "Một dự án không có API và địa hình mặc định: Đảo Quân Sự",
  FE_45_SD_DESC_BLADEBALL: "Mở khóa kỹ năng khác nhau để thắng trận đấu!",
  FE_45_SD_DESC_BOMBER: "Đặt bom để tấn công kẻ địch, cẩn thận đừng để bản thân nổ tung nhé",
  FE_45_SD_DESC_BOMBERSCRIPT: "Một dự án tệp lệnh mẫu. Đặt bom để tấn công kẻ địch, nhưng hãy cẩn thận đừng tự làm mình nổ.",
  FE_45_SD_DESC_EMPTYMAP: "Một dự án không có API và địa hình mặc định: bản đồ trống",
  FE_45_SD_DESC_GUNKING: "Sử dụng vũ khí khác nhau để tiêu diệt nhiều kẻ địch nhất có thể",
  FE_45_SD_DESC_ISLANDL: "Một dự án không có API và địa hình mặc định: Quần Đảo",
  FE_45_SD_DESC_ISLANDS: "Một dự án không có API và địa hình mặc định: Đảo Gốc (100*100).",
  FE_45_SD_DESC_PVE: "Nhận các hiệu ứng mạnh mẽ để tiêu diệt trùm cuối!",
  FE_45_SD_DESC_SNIPER: "Thoát ra thành công và trở thành bậc thầy xạ thủ!",
  FE_45_SD_EMPTYMAP: "Bản Đồ Trống",
  FE_45_SD_GAMEPLAYTEMPLATE: "Mẫu Gameplay",
  FE_45_SD_ISLAND_L: "Đảo Gốc",
  FE_45_SD_ISLAND_S: "Quần Đảo",
  FE_45_SD_NEWPROJECT: "Quản lý dự án",
  FE_45_SD_PROJECTLOST: "File cục bộ của dự án không tồn tại",
  FE_45_SD_REGIST_DYNAMIC: "Gọi Động",
  FE_45_SD_REGIST_LOST: "Không thể tìm thấy tệp (loại tài nguyên: {1}, tên tập lệnh: {2}) trong {0}",
  FE_45_SD_REGIST_STATIC: "Gọi Tĩnh",
  FE_45_SD_SPECIALTEMPLATE: "Mẫu đặc biệt",
  FE_45_SD_SPRITE_RES: "File Sprite",
  FE_45_SD_TEXTURE_RES: "File Texture",
  FE_45_SD_TIMEOFMODIFY: "Thời gian chỉnh sửa",
  FE_45_SD_VERSION: "Phiên bản",
  FE_45_TYC_CCT_COLLISION_THRESHOLD: "Ngưỡng va chạm của nhân vật điều khiển",
  FE_45_TYC_CCT_COLLISION_THRESHOLD_ANNOT: "Thiết lập ngưỡng va chạm của nhân vật khi chạm vào một vật thể rắn. Nếu không đạt ngưỡng, nhân vật được điều khiển sẽ đẩy  nhẹ vật thể ra thay vì va chạm  mạnh.",
  FE_45_TYC_CCT_CUSTOMIZE_PUSH: "Bật lực đẩy tùy chỉnh",
  FE_45_TYC_CCT_CUSTOMIZE_PUSH_ANNOT: "Tùy chỉnh lực đẩy của nhân vật điều khiển áp dụng lên vật thể rắn",
  FE_45_TYC_CCT_ORIENTATION2GRAVITY: "Chỉnh hướng theo trọng trường",
  FE_45_TYC_CCT_ORIENTATION2GRAVITY_ANNOT: "Cho phép nhân vật điều khiển tự động điều chỉnh hướng để phù hợp với hướng của trọng trường",
  FE_45_TYC_CCT_PUSH_FORCE: "Lực đẩy tùy chỉnh",
  FE_45_TYC_CCT_PUSH_FORCE_ANNOT: "Lực đẩy được áp dụng lên vật thể rắn bởi nhân vật được điều khiển",
  FE_45_TYC_COLLIDER_CONVEX: "Là Convex",
  FE_45_TYC_COLLIDER_CONVEX_ANNOT: "Xem lưới mesh này là một convex khi tính toán va chạm",
  FE_45_TYC_COLLIDER_GEN: "Tạo bộ va chạm",
  FE_45_TYC_COLLIDER_GEN_ANNOT: "Tự động thêm và thiết lập thành phần va chạm khi kéo một lưới mesh vào trường cảnh để tạo vật thể",
  FE_45_TYC_COLLIDER_OPTIMIZATION: "Tối ưu bộ va chạm",
  FE_45_TYC_COLLIDER_OPTIMIZATION_ANNOT: "Tối ưu hiệu năng của lưới mesh khi va chạm bằng cách streamline dữ liệu lưới mesh",
  FE_45_TYC_MESH_SCALE_FACTOR: "Tỉ lệ thu phóng",
  FE_45_TYC_MESH_SCALE_FACTOR_ANNOT: "Điều chỉnh kích thước lưới trong file dựa theo tham số đã thiết lập",
  FE_45_TYC_MIDAIR_MOVE: "Di chuyển trên không",
  FE_45_TYC_MIDAIR_MOVE_ANNOT: "Cho phép thay đổi hướng và tốc độ di chuyển của người chơi trên không trung",
  FE_45_TYC_MULTI_JUMP_HEIGHT: "Độ cao nhảy",
  FE_45_TYC_MULTI_JUMP_HEIGHT_ANNOT: "Độ cao của các cú nhảy liên tiếp trên không trung",
  FE_45_TYC_MULTI_JUMP_MAX: "Số lần nhảy tối đa",
  FE_45_TYC_MULTI_JUMP_MAX_ANNOT: "Số lượng bước nhảy tối đa có thể thực hiện trên không",
  FE_45_TYC_OPTIMIZATION_NONE: "Không",
  FE_45_XXJ_DELETECUSTOMEVENT: "Xóa tín hiệu {0}",
  FE_45_XXJ_EDITCUSTOMEVENT: "Chỉnh sửa tín hiệu {0}",
  FE_45_XXJ_WARNING_EDITVARTYPE: "Đổi kiểu dữ liệu có thể gây ra lỗi trong",
  FE_45_XXJ_WORKFLOWLOGIC: "Logic Định Sẵn Theo Quy Trình",
  FE_45_XXJ_WORKFLOWLOGICENABLE: "Bật Logic Định Sẵn Theo Quy Trình",
  FE_45_XXJ_WORKFLOWLOGICENABLE_D: "Bật logic đã được thiết lập trước khi vòng đấu bắt đầu, ví dụ như hiệu ứng bất tử cho người chơi hoặc âm thanh nền khi vòng đấu bắt đầu.",
  FE_45_XYL_STOREBAN_1: "Tính năng chưa mở. Vui lòng đợi!",
  FE_45_XYL_STOREBAN_2: "Xảy ra lỗi. Tính năng này chưa được mở.",
  FE_46A_HZY_PROJECT_EMCTIP: "Đây là dự án trực tuyến. Vui lòng lưu về máy bạn trước khi sử dụng.",
  FE_46A_HZY_REVIEW_PUBLISH: "Phát hiện từ ngữ nhạy cảm. Vui lòng kiểm tra chi tiết tại thông báo lỗi.",
  FE_46_ERRORCODE_UNKONW_PROP: "{1} có tài nguyên không xác định: {0}",
  FE_46_HJ_ERRORCODE_CUSTOMTYPE: "Lỗi kiểu tùy chỉnh: {0}",
  FE_46_HJ_ERRORCODE_CUSTOMTYPE_LOOP: "Yêu cầu vòng lặp với kiểu tùy chỉnh: {0}",
  FE_46_HJ_ERRORCODE_FUNCTION_SIGNATURE: "Không khớp cấu trúc hàm: {0}",
  FE_46_HJ_ERRORCODE_GFILEE: "GFile cho {1} không hợp lệ: {0}",
  FE_46_HJ_ERRORCODE_IMAGE: "File image bị chuyển thành texture vì kiểu không xác định: {0}",
  FE_46_HJ_ERRORCODE_MISSGRAPH: "Tập lệnh Khối bị mất",
  FE_46_HJ_ERRORCODE_NOTENTITY: "Không thể chuyển kiểu {0} thành thực thể",
  FE_46_HJ_ERRORCODE_NOTENUM: "Không thể chuyển kiểu {0} thành Enum",
  FE_46_HJ_ERRORCODE_NOTFIND_FILE: "Không tìm thấy file: {0}",
  FE_46_HJ_ERRORCODE_NOTFIND_GRAPH: "Không thể tìm thấy Tập lệnh Khối {0}",
  FE_46_HJ_ERRORCODE_NOTVALUE: "Giá trị không phải là {0}",
  FE_46_HJ_ERRORCODE_NOTVALUE_P: "Giá trị {1} không phải {0}",
  FE_46_HJ_ERRORCODE_NOTVALUE_RANGE: "Giá trị ({0}) không có [{1},{2}), kiểu {3}",
  FE_46_HJ_ERRORCODE_NULLPARAM: "Tham số là null",
  FE_46_HJ_ERRORCODE_REFEREDFILE: "File tham chiếu không phải là một file byte hợp lệ: {0}",
  FE_46_HJ_ERRORCODE_TYPEABSTRACT: "Kiểu {0} là kiểu trừu tượng",
  FE_46_HJ_ERRORCODE_TYPE_ERROR: "Không thể chuyển kiểu {0} thành kiểu không xác định",
  FE_46_HJ_ERRORCODE_TYPE_ERROR_P: "Không thể chuyển kiểu '{1}' thành kiểu '{0}'",
  FE_46_HJ_ERRORCODE_UNKNOW_API1: "API chưa được định nghĩa trong thiết lập: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_API2: "API không được định nghĩa: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_APIID: "API ID không được định nghĩa: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_ENTITY_P: "{1} có thực thể không rõ: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_EVENT: "Sự kiện tùy chỉnh chưa được định nghĩa",
  FE_46_HJ_ERRORCODE_UNKNOW_EVENTID: "Sự kiện tùy chỉnh {0} không được định nghĩa",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPE: "Kiểu không xác định: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPEASSIGNING: "Tài nguyên không được định nghĩa",
  FE_46_HJ_ERRORCODE_UNKNOW_TYPE_P: "Kiểu không rõ {1}: {0}",
  FE_46_HJ_ERRORCODE_UNKNOW_VALUE_P: "{1} đã có giá trị xác định: {0}",
  FE_46_HJ_ERRORCODE_UNKONW_ACTION: "Khối {0} chưa được định nghĩa",
  FE_46_HJ_ERRORCODE_UNKONW_ENTITY: "Tham số có kiểu không xác định",
  FE_46_HJ_ERRORCODE_UNKONW_ENUM: "Đối tượng Enum {0} không thể  được định nghĩa theo kiểu enum {1}",
  FE_46_HJ_ERRORCODE_UNKONW_ENUM_P: "Đối tượng Enum {0} không hợp lệ với kiểu enum {1}",
  FE_46_HJ_ERRORCODE_UNKONW_FUNCTION: "Khối {0} không xác định",
  FE_46_HJ_ERRORCODE_UNKONW_FUNCTION2: "Hàm/hành động có định nghĩa không rõ: {0}",
  FE_46_HJ_ERRORCODE_UNKONW_PROP: "Tài nguyên {0} không được định nghĩa bởi kiểu {1}",
  FE_46_HJ_ERRORCODE_UNKONW_PROPID: "Tài nguyên {0} không hợp lệ với kiểu {1}",
  FE_46_HJ_ERRORCODE_UNKONW_PROP_P: "Tài nguyên {0} chưa được định nghĩa",
  FE_46_HJ_ERRORCODE_UNKONW_VAR: "Biến {0} chưa được định nghĩa",
  FE_46_HJ_ERRORCODE_UNKONW_VARLOCAL: "Chưa định nghĩa biến cục bộ {0}",
  FE_46_HJ_ERRORCODE_UNSPPPORTFILE: "Không hỗ trợ xuất file, kiểu {1}: {0}",
  FE_46_HJ_ERRORCODE_UPSUPPORTTYPE: "{1} có kiểu giá trị không được hỗ trợ: {0}",
  FE_46_HZY_SHOW_INASSETS: "Xem trong Tài Nguyên",
  FE_46_HZY_SOUNDTYPE_CUSTOM: "Tùy chỉnh",
  FE_46_LJY_NUMTOSTRING5: "Dấu phân cách thập phân",
  FE_46_SD_BUTTON_DOUBLECLICK: "Nhấp đôi",
  FE_46_SD_NODELETE_WHEN_OPENED: "File mục tiêu đang mở và sẽ tự động đóng khi bị xóa",
  FE_46_SD_NODELETE_WHEN_OPENED_2: "File mục tiêu đang mở và sẽ tự động đóng khi bị xóa. Hành động này không thể hoàn tác.",
  FE_46_SD_NODELETE_WHEN_OPENED_CONSOLE: "File bạn muốn xóa hiện đang được mở: {0}",
  FE_46_SD_RESTORE_FILE_MISS: "Không thể khôi phục {0} vì không tồn tại",
  "FE_46_SD_RESTORE_FILE_NO_PERMISSION ": "{0} không thể bị ghi vào",
  "FE_46_SD_RESTORE_FILE_OVERRIDE ": "{0} đã tồn tại và sẽ bị thay thế bởi file này",
  "FE_46_SD_RESTORE_FILE_PATH_ERROR ": "Không thể khôi phục {0} vì file tài nguyên không thuộc dự án hiện tại",
  FE_46_SD_UNDOREDOING: "Đang thực thi tác vụ...",
  "FE_46_SD_UNREDO_RENAME_NOT_FIND ": "Không tìm thấy {0}. Không thể di chuyển hoặc xóa file này",
  FE_46_SD_UNSELECTCALLBACK: "Chọn Callback",
  FE_46_TYC_CUSTOM_UI_DEPTH: "Chiều sâu kết xuất",
  FE_46_TYC_CUSTOM_UI_DEPTH_DESC: "Thuộc tính này xác định thứ tự kết xuất của các UI tùy chỉnh và thứ tự kết xuất của các widget. Xung đột với các chiều sâu kết xuất khác có thể dẫn đến ảnh hưởng thứ tự kết xuất. Chúng tôi khuyến nghị giữ khoảng cách chiều sâu hợp lý nhằm tránh ảnh hưởng đến UI tùy chỉnh.",
  FE_46_TYC_ENABLEAOIFILTER: "Bật AOI Filter",
  FE_46_TYC_ENABLEAOIFILTER_DESC: "Nếu TẮT, tất cả vật thể sẽ được đồng bộ; Nếu BẬT, các vật thể ở xa sẽ bị bỏ qua để tối ưu hóa hiệu năng.",
  FE_46_TYC_NO_COLLIDERS_TIPS: "Không thể thêm Bộ va chạm",
  FE_46_TYC_PANEL_DEPTH: "Chiều sâu kết xuất",
  FE_46_TYC_PANEL_DEPTH_CONFLICT: "Chiều sâu kết xuất xung đột với:",
  FE_46_TYC_PANEL_DEPTH_DESC: "Thuộc tính này sẽ xác định thứ tự kết xuất UI tùy chỉnh. Xung đột với các chiều sâu kết xuất khác có thể khiến thứ tự kết xuất bị ảnh hưởng. Bạn không thể trực tiếp thay đổi thuộc tính này vì nó sẽ dựa trên chiều sâu kết xuất của UI tùy chỉnh.",
  FE_46_TYC_PANEL_DEPTH_TOTAL: "Tổng chiều sâu kết xuất",
  FE_46_TYC_PANEL_DEPTH_TOTAL_DESC: "Chiều sâu kết xuất của UI tùy chỉnh và widget của nó, nếu bị xung đột với các chiều sâu kết xuất khác, có thể khiến thứ tự kết xuất bị sai lệch",
  FE_46_XXJ_ADDOERSONA: "Thêm Nhân Dạng",
  FE_46_XXJ_DYNAMICRES: "Tải tài nguyên động",
  FE_46_XXJ_FORMAT: "Định dạng",
  FE_46_XXJ_FORMATVALUE: "Số",
  FE_46_XXJ_MUSTRES: "Tài nguyên yêu cầu",
  FE_46_XXJ_NOFOUND: "Không tìm được nhân dạng tương ứng",
  FE_46_XXJ_NOPERMISSIONTOUSE: "Bạn không có quyền sử dụng cái này",
  FE_46_XXJ_NUMTOFLOAT: "Number to String",
  FE_46_XXJ_NUMTOFLOAT1: "Giữ nguyên dấu thập phân",
  FE_46_XXJ_NUMTOFLOAT2: "Thường",
  FE_46_XXJ_NUMTOFLOAT3: "Ký hiệu khoa học",
  FE_46_XXJ_NUMTOFLOAT4: "Phần trăm",
  FE_46_XXJ_PERSONALIMIT: "Đã đạt giới hạn nhân dạng. Không thể thêm nữa.",
  FE_46_XXJ_PLAYERDIAMOND: "Kim cương của người chơi",
  FE_46_XXJ_PLAYERPREMIUM: "Kích hoạt Thẻ Thành Viên cho người chơi",
  FE_46_XXJ_PLEASEENTER: "Nhập ID nhân dạng",
  FE_46_XXJ_PREMIUMSETTING: "Điều chỉnh Thẻ Thành Viên",
  FE_46_XXJ_RESCOLLECT: "Bộ sưu tập tài nguyên",
  FE_46_XXJ_SEARCH: "Tìm kiếm",
  FE_46_XXJ_WARNINGMATCHRESULT: "Cảnh báo kết quả trận đấu: Logic kết quả trận đấu trước không còn hiệu lực. Đề xuất bạn bật Kết Quả Trận Đấu Tùy Chọn, sẽ đưa người chơi trực tiếp trở lại sảnh chờ sau khi trận đấu kết thúc. Bạn có thể tùy chỉnh giao diện này hoặc sử dụng các mẫu liên quan nếu cần thiết.",
  FE_46_XYL_FINDINCLASSIFICATION: "Hiển thị trong Danh Mục",
  FE_46_XYL_FINDUGCDOCS: "Xem hướng dẫn",
  FE_46_XYL_NAVMESHSHOW: "Xem trước trong Trường Cảnh",
  FE_47A_HZY_BOMBERSCRIPT_LEVEL: "Trung cấp - Đặt bom (Mã lệnh)",
  FE_47A_HZY_BOMBER_LEVEL: "Trung cấp - Đặt bom",
  FE_47A_HZY_SNIPER_LEVEL: "Nâng cao - Bắn tỉa",
  FE_47A_MX_CUSTOMEVENT_TIP: "Block tương ứng sẽ trở nên không hợp lệ. Bạn có chắc không?",
  FE_47_GT_USERMANUAL: "Cẩm nang người dùng",
  FE_47_HJ_FOG_DENSITY: "Mật độ sương mù",
  FE_47_HJ_FOG_ENABLEFOG: "Bật sương mù",
  FE_47_HJ_FOG_ENDDISTANCE: "Khoảng cách kết thúc sương mù",
  FE_47_HJ_FOG_EXPONENTIAL: "Hàm mũ",
  FE_47_HJ_FOG_EXPONENTIALSQUARED: "Hàm mũ bình phương",
  FE_47_HJ_FOG_FOGMODE: "Chế độ sương mù",
  FE_47_HJ_FOG_LINEAR: "Tuyến tính",
  FE_47_HJ_FOG_STARTDISTANCE: "Khoảng cách bắt đầu sương mù",
  FE_47_HL_FREE_VIEW: "Góc nhìn người chơi/góc nhìn tự do",
  FE_47_HZY_BLOCK_CATEGORY: "Danh mục",
  FE_47_HZY_BLOCK_CUSTOMVARIABLE: "Biến tùy chỉnh",
  FE_47_HZY_BLOCK_DESC: "Mô tả",
  FE_47_HZY_BLOCK_ID: "ID khối",
  FE_47_HZY_BLOCK_INPUT: "Input",
  FE_47_HZY_BLOCK_MODULE: "Module",
  FE_47_HZY_BLOCK_NAME: "Tên khối",
  FE_47_HZY_BLOCK_OUTPUT: "Output",
  FE_47_HZY_BLOCK_OWNERTYPE: "Có thể kích hoạt",
  FE_47_HZY_BLOCK_PARADESC: "Thông tin tham số",
  FE_47_HZY_BLOCK_RETURNDESC: "Mô tả giá trị trả về",
  FE_47_HZY_BLOCK_RETURNTYPE: "Kiểu trả về",
  FE_47_HZY_CLIENTNUM_D: "Thiết lập số lượng máy khách",
  FE_47_HZY_CUSTOMSTORE: "Cửa hàng tùy chỉnh",
  FE_47_HZY_CUSTOMSTORE_ADDCUSTOM: "Thêm vật phẩm tùy chọn",
  FE_47_HZY_CUSTOMSTORE_ADDITEM: "Kéo vào một vật phẩm",
  FE_47_HZY_CUSTOMSTORE_ADDSHELVE: "Tạo kệ hàng",
  FE_47_HZY_CUSTOMSTORE_COVER: "Ảnh bìa",
  FE_47_HZY_CUSTOMSTORE_CURRENCY: "Loại tiền tệ",
  FE_47_HZY_CUSTOMSTORE_DELETETIP1: "Xóa vĩnh viễn cửa hàng tùy chỉnh này?",
  FE_47_HZY_CUSTOMSTORE_DELETETIP2: "Xóa sạch vật phẩm và xóa kệ hàng",
  FE_47_HZY_CUSTOMSTORE_DELETETIP3: "Khi đã bị xóa, cửa hàng tùy chỉnh sẽ không thể khôi phục. Bạn chắc chứ?",
  FE_47_HZY_CUSTOMSTORE_DOWN: "Di chuyển xuống",
  FE_47_HZY_CUSTOMSTORE_EDIT: "Vào Cửa hàng tùy chỉnh",
  FE_47_HZY_CUSTOMSTORE_ENTITY: "Cửa hàng",
  FE_47_HZY_CUSTOMSTORE_FFITEM: "Vật phẩm mặc định",
  FE_47_HZY_CUSTOMSTORE_INFO: "Thông tin vật phẩm",
  FE_47_HZY_CUSTOMSTORE_LIMIT: "Giới hạn",
  FE_47_HZY_CUSTOMSTORE_LIMITNUM: "Giới hạn mua",
  FE_47_HZY_CUSTOMSTORE_PRODUCTCONTENT: "Nội dung vật phẩm",
  FE_47_HZY_CUSTOMSTORE_PRODUCTNAME: "Tên vật phẩm",
  FE_47_HZY_CUSTOMSTORE_PROP: "Thuộc tính vật phẩm",
  FE_47_HZY_CUSTOMSTORE_SHELVES: "Kệ hàng",
  FE_47_HZY_CUSTOMSTORE_UP: "Di chuyển lên",
  FE_47_HZY_MODULE_CUSTOMRESULT_D: "Chọn để trang kết quả trận đấu mặc định sẽ không hiển thị",
  FE_47_HZY_MODULE_D: "Quản lý module và thiết lập tham số",
  FE_47_HZY_MODULE_LOGICFRAME_D: "Chọn để sử dụng Chế độ logic khung hình thấp (30 > 15)",
  FE_47_HZY_MODULE_LOOTSWITCH_D: "Chọn để bật chế độ loot vật phẩm cổ điển cho các bản đồ lớn như Đảo Quân Sự",
  FE_47_HZY_MODULE_NAVMESH_D: "Chọn và bật NavMesh Động để tạo các vật cản khi tìm đường tương tự như bộ va chạm. Những vật cản này sẽ được tạo và phá hủy đồng thời với vật thể.",
  FE_47_HZY_MODULE_NFPP_D: "Chọn để sử dụng tài nguyên góc nhìn thứ nhất mới",
  FE_47_HZY_SCENESWITCH_TIP: "Khu vực tải server trong trường cảnh không được hỗ trợ trong bản đồ này",
  FE_47_HZY_SCENE_ALIGNMENTLOCK_D: "Khi mở khóa, thiết lập khoảng cách di chuyển cố định trên trục x/y/z",
  FE_47_HZY_SCENE_ALIGNMENTRESET_D: "Đặt về mặc định",
  FE_47_HZY_SCENE_ALIGNMENTSET_D: "Sử dụng tính năng căn chỉnh để xoay, thu phóng, hoặc di chuyển vật thể theo khoảng cách cố định",
  FE_47_HZY_SERVERSLOAD_BERMUDA: "Không thể bật khu vực tải trận trong trường cảnh trong bản đồ này",
  FE_47_HZY_TERRAIN_DOWN_D: "Giảm chiều cao địa hình tại khu vực này",
  FE_47_HZY_TERRAIN_FLAT_D: "Sử dụng cùng độ cao địa hình cho khu vực này",
  FE_47_HZY_TERRAIN_SMOOTH_D: "Trung hòa khu vực xung quanh, làm mềm địa hình và giảm sự thay đổi đột ngột",
  FE_47_HZY_TERRAIN_TEXTURE_CHANGE_D: "Thay thế texture đã chọn với texture mới",
  FE_47_HZY_TERRAIN_TEXTURE_COVERALL_D: "Chọn để tô texture đã chọn vào toàn bộ một khu vực",
  FE_47_HZY_TERRAIN_TEXTURE_DEL_D: "Xóa texture đã chọn",
  FE_47_HZY_TERRAIN_TEXTURE_INPUT_D: "Nhập texture mới",
  FE_47_HZY_TERRAIN_TEXTURE_TIP: "Chọn texture để tô",
  FE_47_HZY_TERRAIN_UP_D: "Tăng chiều cao địa hình tại khu vực này",
  FE_47_HZY_UI_3D_D: "Widget để hiển thị nội dung 3D, chẳng hạn như Prefab",
  FE_47_HZY_UI_AVATAR_D: "Một widget để hiển thị ảnh đại diện của người chơi",
  FE_47_HZY_UI_BUTTON_D: "Widget kích hoạt sự kiện logic khi nhấn",
  FE_47_HZY_UI_EMPTY_D: "Một widget vô hình nhằm quản lý các widget cha/con",
  FE_47_HZY_UI_JOYSTICK_D: "Widget giả lập cần điều khiển và sẽ phản ứng với hành động kéo thả được nhập vào (chỉ máy khách)",
  FE_47_HZY_UI_LAYOUT_D: "Một widget dùng để tự động sắp xếp các widget con của nó",
  FE_47_HZY_UI_PANEL_D: "Panel có chứa các widget con khác",
  FE_47_HZY_UI_PICTURE_D: "Widget hiển thị hình ảnh",
  FE_47_HZY_UI_PLATFORM_D: "Bảng hỗ trợ tính năng Thêm Bạn và Tố Cáo",
  FE_47_HZY_UI_SCROLLVIEW_D: "Widget con trong bảng này có thể được cuộn",
  FE_47_HZY_UI_TEXTBOX_D: "Widget để nhận văn bản nhập từ người dùng",
  FE_47_HZY_UI_TEXTURE_D: "Widget để hiển thị texture",
  FE_47_HZY_UI_TEXT_D: "Widget hiển thị văn bản thô",
  FE_47_HZY_UI_TOGGLE_D: "Một widget hình nút có thể chuyển giữa hai trạng thái khi nhấn",
  FE_47_HZY_UI_TOUCHPAD_D: "Widget phản ứng với hành động chạm/kéo được nhập vào (chỉ máy khách)",
  FE_47_JH_WS_ROOMMINPLAYERCNT: "Người chơi tối thiểu",
  FE_47_TYC_ANIM_BLEND_TIME: "Độ dài làm mờ Blend",
  FE_47_TYC_AOI_FILTER_ALWAYS: "Luôn luôn",
  FE_47_TYC_AOI_FILTER_AUTO: "Tự động",
  FE_47_TYC_AOI_FILTER_D: "Xác định thiết lập bộ lọc cho vật thể: Auto:  bật hoặc tắt bộ lọc dựa trên việc vật thể có tĩnh hay không. Không bao giờ: Vật thể luôn được đồng bộ. Luôn luôn: Vật thể sẽ luôn được lọc, có nghĩa nó sẽ không đồng bộ khi ở xa.",
  FE_47_TYC_AOI_FILTER_NEVER: "Không bao giờ",
  FE_47_TYC_AOI_FILTER_T: "Bộ lọc AOI",
  FE_47_TYC_CCT_ENABLED_D: "Tắt: Sử dụng bộ điều khiển nhân vật mặc định. Có thể dẫn đến lỗi khi người chơi và rigid body tương tác nhau; Bật: sử dụng bộ điều khiển nhân vật của Craftland",
  FE_47_TYC_CCT_HEIGHT_D: "Bán kính của viên nang cho Điều Khiển Nhân Vật này. Vui lòng lưu ý rằng chiều cao của viên nang phải lớn hơn gấp đôi chiều rộng.",
  FE_47_TYC_CCT_RADIUS_D: "Bán kính của viên nang cho Điều Khiển Nhân Vật này. Vui lòng lưu ý rằng chiều cao của viên nang phải lớn hơn gấp đôi chiều rộng.",
  FE_47_TYC_GLOBAL_GRAVITY_D: "Trọng lực tác dụng lên tất cả rigid body",
  FE_47_TYC_HINT_COLOR_TEXTURE_RESTRICTION: "Texture trong hoặc texture vượt quá 128*128 px không được hỗ trợ",
  FE_47_TYC_PHYSICS_DEFAULT_MAT: "Texture vật lý mặc định nếu không có thiết lập gì cho bộ và chạm và rigid body",
  FE_47_TYC_PHYSICS_SLEEP_THRESHOLD_D: "Nếu năng lượng từ trường hoặc trọng lực của rigid body thấp hơn giá trị này, nó sẽ tự động vào trạng thái ngủ (giảm tiêu hao hiệu năng)",
  FE_47_TYC_PLAYER_PHYSICS_LAYER_D: "Lớp layer vật lý mà nhân vật người chơi đứng trên",
  FE_47_TYC_PTC: "Particle Emitter",
  FE_47_TYC_PTC_A_ACCELERATION: "Gia tốc",
  FE_47_TYC_PTC_A_ACCELERATION_D: "Thuộc tính này xác định gia tốc của particle theo thời gian",
  FE_47_TYC_PTC_A_ACCELERATION_RANDOMNESS: "Ngẫu số gia tốc",
  FE_47_TYC_PTC_A_ACCELERATION_RANDOMNESS_D: `Giá trị ngẫu nhiên được thêm vào gia tốc của particle.
(Giá trị cuối sẽ được chọn ngẫu nhiên từ [Giá trị cơ bản] đến [Giá trị cơ bản + Ngẫu số gia tốc].`,
  FE_47_TYC_PTC_A_ANGLE: "Góc độ",
  FE_47_TYC_PTC_A_ANGLE_D: "Góc quay ban đầu của particle (theo trục ngẫu nhiên)",
  FE_47_TYC_PTC_A_ANGLE_RANDOMNESS: "Ngẫu số góc",
  FE_47_TYC_PTC_A_ANGLE_RANDOMNESS_D: `Giá trị ngẫu nhiên được thêm vào góc quay tốc ban đầu của particle.
(Giá trị cuối sẽ được chọn ngẫu nhiên từ [Giá trị cơ bản] đến [Giá trị cơ bản + Ngẫu số góc quay].`,
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY: "Vận tốc góc",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_D: "Particle sẽ xoay theo thời gian (theo trục ngẫu nhiên)",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_RANDOMNESS: "Ngẫu số vận tốc góc",
  FE_47_TYC_PTC_A_ANGULAR_VELOCITY_RANDOMNESS_D: `Giá trị ngẫu nhiên được thêm vào vận tốc góc ban đầu của particle.
(Giá trị cuối sẽ được chọn ngẫu nhiên từ [Giá trị cơ bản] đến [Giá trị cơ bản + Ngẫu số vận tốc góc].`,
  FE_47_TYC_PTC_A_BOX: "Khối Lập Phương",
  FE_47_TYC_PTC_A_BOX_D: "Phát xạ particle lên phía trên từ đáy của hình hộp",
  FE_47_TYC_PTC_A_CIRCLE: "Hình tròn",
  FE_47_TYC_PTC_A_CIRCLE_D: "Phát xạ particle ra ngoài từ tâm của hình tròn",
  FE_47_TYC_PTC_A_COLOR: "Màu Particle",
  FE_47_TYC_PTC_A_COLOR_D: "Thuộc tính ảnh hưởng đến màu của Particle",
  FE_47_TYC_PTC_A_COLOR_OVER_LIFETIME: "Màu sắc trong vòng đời",
  FE_47_TYC_PTC_A_COLOR_OVER_LIFETIME_D: "Màu của particle sẽ thay đổi theo thời gian",
  FE_47_TYC_PTC_A_CONE: "Hình nón",
  FE_47_TYC_PTC_A_CONE_D: "Phát xạ particle ra từ đáy của hình nón (thay vì từ bên trong)",
  FE_47_TYC_PTC_A_DAMPING: "Giảm chấn",
  FE_47_TYC_PTC_A_DAMPING_D: "Giảm xóc cho vận tốc của particle. Giá trị giảm xóc càng lớn thì độ ma sát càng cao.",
  FE_47_TYC_PTC_A_DAMPING_RANDOMNESS: "Ngẫu số giảm xóc",
  FE_47_TYC_PTC_A_DAMPING_RANDOMNESS_D: `Giá trị ngẫu nhiên được thêm vào giảm xóc ban đầu của particle.
(Giá trị cuối sẽ được chọn ngẫu nhiên từ [Giá trị cơ bản] đến [Giá trị cơ bản + Ngẫu số giảm xóc].`,
  FE_47_TYC_PTC_A_DURATION: "Thời hạn",
  FE_47_TYC_PTC_A_DURATION_D: "Thời gian mà emitter đi qua một chu kỳ",
  FE_47_TYC_PTC_A_FINAL_VALUE: "Giá trị cuối",
  FE_47_TYC_PTC_A_HEMISPHERE: "Bán cầu",
  FE_47_TYC_PTC_A_HEMISPHERE_D: "Phát xạ particle ra ngoài từ bên trong và bề mặt của một bán cầu",
  FE_47_TYC_PTC_A_INITIAL_VALUE: "Giá trị ban đầu",
  FE_47_TYC_PTC_A_LIFETIME: "Vòng đời",
  FE_47_TYC_PTC_A_LIFETIME_D: "Thời gian một particle tồn tại",
  FE_47_TYC_PTC_A_LIFETIME_RANDOMNESS: "Ngẫu số vòng đời",
  FE_47_TYC_PTC_A_LIFETIME_RANDOMNESS_D: `Giá trị ngẫu nhiên được thêm vào vòng đời của particle.
(Giá trị cuối sẽ được chọn ngẫu nhiên từ [Giá trị cơ bản] đến [Giá trị cơ bản + Ngẫu số vòng đời].`,
  FE_47_TYC_PTC_A_LOOP: "Vòng lặp",
  FE_47_TYC_PTC_A_LOOP_D: "Bật thuộc tính này sẽ cho phép emitter tự động lặp lại sau khi đã phát xạ",
  FE_47_TYC_PTC_A_MATERIAL: "Chất liệu Particle",
  FE_47_TYC_PTC_A_MATERIAL_D: "Kết xuất vật liệu áp dụng cho Particle",
  FE_47_TYC_PTC_A_MAX_PARTICLES: "Particle tối đa",
  FE_47_TYC_PTC_A_MAX_PARTICLES_D: "Số lượng particle tối đa có thể tồn tại trong cùng một thời điểm. Nếu đạt đến giới hạn, sẽ không có thêm particle mới được tạo ra.",
  FE_47_TYC_PTC_A_MESH: "Mesh Tùy Chỉnh",
  FE_47_TYC_PTC_A_MESH_D: "Phát xạ Particle ra ngoài từ phần đỉnh của bất kỳ mesh nào",
  FE_47_TYC_PTC_A_MODE: "Chế độ phát xạ",
  FE_47_TYC_PTC_A_MODE_D: "Thuộc tính này xác định thứ tự phát xạ của particle",
  FE_47_TYC_PTC_A_RATE_OVER_TIME: "Tốc độ phát xạ",
  FE_47_TYC_PTC_A_RATE_OVER_TIME_D: "Số lượng particle mà emitter phát xạ mỗi giây",
  FE_47_TYC_PTC_A_RENDER_MODE: "Chế độ kết xuất",
  FE_47_TYC_PTC_A_RENDER_MODE_D: "Xác định chế độ kết xuất particle được sử dụng",
  FE_47_TYC_PTC_A_SHAPE: "Dạng phát xạ",
  FE_47_TYC_PTC_A_SHAPE_D: "Thuộc tính này xác định vị trí bắt đầu và hướng phát xạ. Mỗi hình dạng có thể có những lựa chọn khác nhau.",
  FE_47_TYC_PTC_A_SIMULATION_SPACE: "Tọa độ giả lập",
  FE_47_TYC_PTC_A_SIMULATION_SPACE_D: "Thuộc tính này xác định hệ tọa độ mà particle sẽ sử dụng khi di chuyển",
  FE_47_TYC_PTC_A_SIMULATION_SPEED: "Vận tốc giả lập",
  FE_47_TYC_PTC_A_SIMULATION_SPEED_D: "Điều chỉnh vận tốc tổng quát của emitter và particle",
  FE_47_TYC_PTC_A_SIZE: "Kích cỡ",
  FE_47_TYC_PTC_A_SIZE_D: "Kích thước ban đầu của particle",
  FE_47_TYC_PTC_A_SIZE_RANDOMNESS: "Ngẫu số kích thước",
  FE_47_TYC_PTC_A_SIZE_RANDOMNESS_D: `Giá trị ngẫu nhiên được thêm vào gia tốc của particle.
(Giá trị cuối sẽ được chọn ngẫu nhiên từ [Giá trị cơ bản] đến [Giá trị cơ bản + Ngẫu số kích thước].`,
  FE_47_TYC_PTC_A_SORT_MODE: "Kiểu sắp xếp",
  FE_47_TYC_PTC_A_SORT_MODE_D: "Thuộc tính xác định cách tính toán thứ tự kết xuất particle",
  FE_47_TYC_PTC_A_SPHERE: "Hình cầu",
  FE_47_TYC_PTC_A_SPHERE_D: "Phát xạ particle ra ngoài từ bên trong và bề mặt của hình cầu này",
  FE_47_TYC_PTC_A_START_SPEED: "Tốc độ ban đầu",
  FE_47_TYC_PTC_A_START_SPEED_D: "Tốc độ ban đầu mà particle được phát xạ về phía hướng định sẵn",
  FE_47_TYC_PTC_A_START_SPEED_RANDOMNESS: "Ngẫu số tốc độ ban đầu",
  FE_47_TYC_PTC_A_START_SPEED_RANDOMNESS_D: `Giá trị ngẫu nhiên được thêm vào tốc độ ban đầu của particle.
(Giá trị cuối sẽ được chọn ngẫu nhiên từ [Giá trị cơ bản] đến [Giá trị cơ bản + Ngẫu số tốc độ ban đầu].)`,
  FE_47_TYC_PTC_A_TEXTURE: "Lớp Phủ Màu",
  FE_47_TYC_PTC_A_TEXTURE_D: "Texture này sẽ xác định màu của các particle được phát xạ từ vị trí tương ứng",
  FE_47_TYC_PTC_A_TRANSFORM: "Chuyển dạng phát xạ",
  FE_47_TYC_PTC_A_TRANSFORM_D: "Thuộc tính này sẽ chỉ áp dụng đến hình dạng phát xạ và không ảnh hưởng đến các particle",
  FE_47_TYC_PTC_A_VELOCITY: "Vận tốc",
  FE_47_TYC_PTC_A_VELOCITY_D: "Vận tốc ban đầu",
  FE_47_TYC_PTC_A_VELOCITY_RANDOMNESS: "Ngẫu số vận tốc",
  FE_47_TYC_PTC_A_VELOCITY_RANDOMNESS_D: `Giá trị ngẫu nhiên được thêm vào vận tốc ban đầu của particle.
(Giá trị cuối sẽ được chọn ngẫu nhiên từ [Giá trị cơ bản] đến [Giá trị cơ bản + Ngẫu số vận tốc].`,
  FE_47_TYC_PTC_BASIC: "Cơ bản",
  FE_47_TYC_PTC_ENUM_BILLBOARD: "Bề mặt Billboard",
  FE_47_TYC_PTC_ENUM_BY_DIST: "Theo khoảng cách",
  FE_47_TYC_PTC_ENUM_GLOBAL: "Khoản trống toàn cục",
  FE_47_TYC_PTC_ENUM_LOCAL: "Khoảng trống cục bộ",
  FE_47_TYC_PTC_ENUM_LOOP: "Vòng lặp",
  FE_47_TYC_PTC_ENUM_OLDEST_IN_FRONT: "Từ cũ nhất",
  FE_47_TYC_PTC_ENUM_PING_PONG: "Chuyển hướng",
  FE_47_TYC_PTC_ENUM_RANDOM: "Ngẫu nhiên",
  FE_47_TYC_PTC_ENUM_YOUNGEST_IN_FRONT: "Từ mới nhất",
  FE_47_TYC_PTC_PARA: "Tham số Particle",
  FE_47_TYC_PTC_PROPERTY_FILE: "Thuộc tính Particle",
  FE_47_TYC_PTC_PROPERTY_FILE_D: "Tệp thuộc tính particle sẽ mô tả hành vi của particle và emitter. Bạn sẽ không thể thay đổi các thuộc tính khi tệp này đang khởi chạy, nhưng có thể đổi sang tệp khác.",
  FE_47_TYC_PTC_RENDERING: "Kết xuất",
  FE_47_TYC_PTC_SHAPE: "Hình dạng",
  FE_47_TYC_SHD_BLENDMODE: "Chế độ Blend",
  FE_47_TYC_SHD_COLOR_CORRECTION: "Chuẩn hóa màu sắc",
  FE_47_TYC_SHD_CULL_BACK: "Trước",
  FE_47_TYC_SHD_CULL_FRONT: "Sau",
  FE_47_TYC_SHD_MAIN_ROTATION: "Xoay chính",
  FE_47_TYC_SHD_MASK: "Mask",
  FE_47_TYC_SHD_ON: "Bật",
  FE_47_TYC_SHD_Z_TEST: "Z Test",
  FE_47_TYC_SHD_Z_WRITE: "Ghi Z",
  FE_47_XXJ_ACCOUNTNOPERMISSION: "Tài khoản của bạn không được sử dụng nhân dạng",
  FE_47_XXJ_AUTOCLEAR: "Tự động xóa sau khi trận đấu kết thúc",
  FE_47_XXJ_IMPORTED: "Nhân dạng đã tồn tại",
  FE_47_XXJ_LOGINTIMEOUT: "Phiên đăng nhập hết hạn, vui lòng đăng nhập lại",
  FE_47_XXJ_MEMORYTYPE: "Kiểu bộ nhớ",
  FE_47_XXJ_NOCONECT: "Lỗi mạng",
  FE_47_XXJ_NOPERMISSION: "Không được sử dụng nhân dạng này",
  FE_47_XXJ_NOTAUTOCLEAR: "Tự động dọn dẹp",
  FE_47_XXJ_PERSONAIDSEARCH: "Nhập ID nhân dạng để tìm kiếm",
  FE_47_XXJ_PERSONAOFFLINE: "Nhân dạng này không còn tồn tại nữa",
  FE_47_XXJ_PERSONATOOTIP: "Sao chép ID Nhân nhận được tạo từ Trung Tâm Nhân Dạng và dán nó ở đây để nhập nhân dạng",
  FE_47_XXJ_SELECTOBSERVOR: "Chọn người quan sát",
  FE_47_XYL_ASSETSTORE_TYPE: "Kiểu cửa hàng tài nguyên",
  FE_47_XYL_IMAPGEUPDATEFAIL: "Kiểu file hình ảnh này không được hỗ trợ",
  FE_47_XYL_PROJECTTEMPLATE: "Mẫu dự án",
  FE_47_XYL_SHOPSEARCHCOUNT: "tìm thấy {0} kết quả",
  FE_47_XYL_SHOPSELECTTYPE: "Kiểu chọn",
  FE_47_XYL_SHOPTAGS: "Nhãn",
  FE_47_XYL_SHOPTYPENONEERROR: "Cửa hàng không thể trống",
  FE_47_XYL_SHOP_CLASSNEWEST: "Từ mới nhất",
  FE_47_XYL_SHOP_CLASSOLDEST: "Từ cũ nhất",
  FE_47_XYL_SHOP_ENTERTOADD: "Nhấn ENTER để tạo nhãn",
  FE_47_XYL_SHOP_TAGLIMITED: "Giới hạn nhãn",
  FE_47_XYL_SHOP_TAGRECOMMEND: "Nhãn đề xuất",
  FE_47_XYL_STORE2DASSET: "Tài nguyên 2D",
  FE_47_XYL_STORE3ASSET: "Tài nguyên 3D",
  FE_47_ZCS_EDITOR_EXIT_REMINDER: "Dự án chưa lưu",
  FE_47_ZCS_EDITOR_FILTER_NOTICE: "Không thể dán khi đang tìm kiếm",
  FE_48A_HZY_CUSTOMRES_ADDTIP: "Bạn không có quyền sử dụng tài nguyên tùy chỉnh. Việc sử dụng tài nguyên này có thể khiến xuất bản bị thất bại.",
  FE_48A_HZY_CUSTOMRES_CONSOLETIP: "Bạn không có quyền sử dụng tài nguyên tùy chỉnh này. Vui lòng xóa hoặc dùng tài nguyên khác.",
  FE_48A_HZY_SAVEFAIL_TIP1: "Lưu lại thất bại",
  FE_48A_HZY_SAVEFAIL_TIP2: "Tệp sau đây chỉ có thể được đọc. Vui lòng điều chỉnh thuộc tính tệp và lưu lại.",
  FE_48A_HZY_SAVEFAIL_TIP3: "Bạn chỉ có thể đọc tệp này. Vui lòng điều chỉnh thuộc tính tệp và lưu lại.",
  FE_48A_XXJ_LOOPWARNIG: "Hoạt ảnh động này sẽ không kích hoạt vì hoạt ảnh trước được thiết lập để lặp lại vĩnh viễn",
  FE_48A_XXJ_UNSELECT: "Hủy chọn",
  FE_48A_XYL_NAVMESHSWITCH: "Bật NavMesh Tĩnh ngoại tuyến",
  FE_48A_ZCS_EDITOR_SELECTED_NOTICE: "Đã chọn",
  FE_48_HL_REVIEW_MEANNING: "Phát hiện thông tin nhạy cảm trong {0}: {1}",
  FE_48_HZY_COSTLIMIT_CONSOLETIPS: "Vượt quá giới hạn {0} tài nguyên. Hãy xóa bớt.",
  FE_48_HZY_COSTLIMIT_TIPS1: "Xuất bản có thể thất bại nếu có quá nhiều tài nguyên trong cảnh.",
  FE_48_HZY_COSTLIMIT_TIPS2: "Xuất bản thất bại do có quá nhiều tài nguyên trong cảnh: {0}. Vui lòng kiểm tra chi tiết lỗi và xóa một vài tài nguyên.",
  FE_48_HZY_DEFINEDPATH: "Định nghĩa đường dẫn",
  FE_48_HZY_ECA_TIP_ONLY_SCENE_SELECT: "Chỉ chọn được vật phẩm trong cảnh",
  FE_48_HZY_EDITCUSTOMEVENT: "Tủy chỉnh tín hiệu",
  FE_48_HZY_FUNCTIONNAME: "Tên hàm",
  FE_48_HZY_GETEXFUNCTION: "Lấy hàm ngoài",
  FE_48_HZY_GETEXVARIABLE: "Lấy biến ngoài",
  FE_48_HZY_GETVARIABLE: "Lấy biến",
  FE_48_HZY_RECEIVEEVENT: "Nhận tín hiệu",
  FE_48_HZY_SELECTENTITY: "Gửi thực thể",
  FE_48_HZY_SENDEVENT: "Truyền tín hiệu",
  FE_48_HZY_SETEXVARIABLE: "Thiết lập biến ngoài",
  FE_48_SD_ASSET_REGIST: "Đăng ký tài nguyên",
  FE_48_SD_QUICKREGIST: "Đăng ký nhanh",
  FE_48_TYC_CONVEX_WARNING_RIGIDBODY: "Hình dạng va chạm chứa lưới mesh không lồi, nên không thể được sử dụng làm rigidbody động hoặc rigidbody kinematic. Sử dụng lưới mesh lồi hoặc chia nhỏ thành các bộ va chạm đơn giản hơn.",
  FE_48_TYC_CONVEX_WARNING_TRIGGER: "Hình dạng va chạm chứa lưới mesh không lồi, nên không thể được sử dụng làm vật kích hoạt. Sử dụng lưới mesh lồi hoặc kiểu hình va chạm khác.",
  FE_48_TYC_SPECTATOR_FF: "Free Fire",
  FE_48_TYC_SPECTATOR_FF_RULE: "Giống như Free Fire",
  FE_48_TYC_SPECTATOR_TYPE: "Kiểu theo dõi",
  FE_48_TYC_SPECTATOR_UGC: "Craftland Studio",
  "FE_48_TYC_UI_ADAPT_SCREEN ": "Vừa màn hình",
  FE_48_TYC_UI_PENETRATABLE: "Xuyên qua",
  FE_48_TYC_UI_PENETRATABLE_D: "Nếu bật, widget sẽ không chặn sự kiện kích hoạt của widget cơ bản",
  FE_48_XXJ_ADDBEHINDWAYPOINT: "Thêm điểm đường đi sau",
  FE_48_XXJ_ADDBODYPARTTRACK: "Thêm bám theo chuyển động bộ phận thân thể",
  FE_48_XXJ_ADDEVENT: "Thêm sự kiện",
  FE_48_XXJ_ADDFRONTWAYPOINT: "Thêm điểm đường đi trước",
  FE_48_XXJ_ADDITIVE: "Thêm vào",
  FE_48_XXJ_ADDWAYPOINT: "Thêm điểm đường đi",
  FE_48_XXJ_BASETRAK: "Bám theo bệ",
  FE_48_XXJ_BETA: "Đây là bản beta và sẽ có thể chứa lỗi",
  FE_48_XXJ_BODY: "Thân thể",
  FE_48_XXJ_BODYPART: "Bộ phận thân thể",
  FE_48_XXJ_BODYPARTCONFIG: "Điều chỉnh bộ phận thân thể",
  FE_48_XXJ_BODYPARTTRACK: "Bám theo chuyển động bộ phận thân thể",
  FE_48_XXJ_BONESELECTOR: "Trình lựa chọn Xương",
  FE_48_XXJ_COLLAPSEALL: "Đóng hết",
  FE_48_XXJ_CREATECLIP: "Tạo hoạt ảnh động",
  FE_48_XXJ_DELETECURRENTWAYPOINT: "Xóa điểm đường đi",
  FE_48_XXJ_DELETEEVENT: "Xóa sự kiện",
  FE_48_XXJ_ENDTIME: "Thời gian kết thúc",
  FE_48_XXJ_EVENTTRACK: "Theo dõi sự kiện",
  FE_48_XXJ_EXPANDALL: "Mở rộng tất cả",
  FE_48_XXJ_HOLD: "Giữ",
  FE_48_XXJ_LOCK: "Khóa",
  FE_48_XXJ_LOOP: "Vòng lặp",
  FE_48_XXJ_LOOPFOREVER: "Lặp lại vĩnh viễn",
  FE_48_XXJ_MASK: "mask",
  FE_48_XXJ_MUTE: "Tắt tiếng",
  FE_48_XXJ_NONE: "Không có gì",
  FE_48_XXJ_OVERRIDE: "Ghi đè",
  FE_48_XXJ_PAUSE: "Tạm dừng",
  FE_48_XXJ_PINGPONG: "Chuyển hướng",
  FE_48_XXJ_PLAY: "Chơi",
  FE_48_XXJ_PLAYBACKLENGHT: "Thời lượng phát lại",
  FE_48_XXJ_POSTEXTRA: "Hậu ngoại suy",
  FE_48_XXJ_PREAXTRA: "Tiền ngoại suy",
  FE_48_XXJ_PREGERTANGENTDRAG: "Ưu tiên kéo theo đường thẳng",
  FE_48_XXJ_REPLAY: "Xem lại",
  FE_48_XXJ_SELECTBONES: "Chọn xương",
  FE_48_XXJ_SELECTEDBONES: "Đã chọn {0} xương",
  FE_48_XXJ_SELECTEDWAYPOINT: "Điểm đường đi đã chọn",
  FE_48_XXJ_SETGAPEXTRA: "Đặt khoảng cách ngoại suy",
  FE_48_XXJ_SETTOCAMERA: "Đặt về vị trí camera cảnh hiện tại",
  FE_48_XXJ_STARTTIME: "Thời gian bắt đầu",
  FE_48_XXJ_TOGGLEALL: "Bật tất cả",
  FE_48_XXJ_UNLOCK: "Mở khóa",
  FE_48_XXJ_UNMUTE: "Bật tiếng",
  FE_48_XXJ_WAYPOINTS: "Điểm đường đi",
  FE_48_XXJ_WEIGHT: "Trọng lượng",
  FE_48_XYL_CUTOFF: "Ngắt quãng",
  FE_48_ZCS_EDITOR_CHECK_UPDATES: "Kiểm tra cập nhật...",
  FE_48_ZCS_EDITOR_COMPILER_VERSION: "Phiên bản trình biên dịch",
  FE_48_ZCS_EDITOR_COPY_PATH: "Sao chép thông tin đường dẫn",
  FE_48_ZCS_EDITOR_DELETE_INVALID_PROJECT: "Xóa dự án không hợp lệ",
  FE_48_ZCS_EDITOR_MANAGEMENT: "Quản lý",
  FE_48_ZCS_EDITOR_OFFICIAL_WEBSITE: "Trang chủ chính thức",
  FE_48_ZCS_EDITOR_PRIVACY_POLICY: "Chính sách riêng tư",
  FE_48_ZCS_EDITOR_REFRESH_PROJECTLIST: "Làm mới danh sách dự án",
  FE_48_ZCS_EDITOR_TERMS_OF_SERVICE: "Điều khoản dịch vụ",
  FE_48_ZCS_EDITOR_UPDATES_ABOUT: "Cập nhật và Giới thiệu",
  FE_49A_HJ_OPENDATAFILE: "Mở tệp lưu trữ dữ liệu",
  FE_49A_HZY_COLLIDER_LIMITTIP1: "Mesh va chạm của tệp vẫn vượt quá 4000 mặt sau khi đã tối ưu hóa hiệu suất. Việc sử dụng tệp này có thể dẫn đến xuất bản thất bại.",
  FE_49A_HZY_COLLIDER_LIMITTIP2: "Mesh va chạm cho {0} vượt quá giới hạn. Vui lòng tối ưu hóa va chạm vật lý hoặc thay thế tệp.",
  FE_49A_HZY_COLLIDER_LIMITTIP3: "Xuất bản thất bại vì dự án chứa tệp có mesh va chạm tạo bởi quá nhiều mặt. Vui lòng kiểm tra Bảng điều khiển để biết thêm thông tin lỗi.",
  FE_49A_HZY_SHADER_ALPHABC_D: "Chất liệu trong suốt hỗ trợ vẽ lồng màu và điều khiển độ trong suốt, phù hợp với hiệu ứng cơ bản, kính, thành phần UI và các hiệu ứng chất liệu không hoàn toàn trong suốt khác.",
  FE_49A_HZY_SHADER_BUILDCARTOON_D: "Loại chất liệu theo phong cách hoạt hình, hỗ trợ ánh sáng gradient, normal map, highlight phản xạ, và hiệu ứng Matcap. Rất phù hợp cho công trình theo phong cách cách điệu.",
  FE_49A_HZY_SHADER_BUMPDIFFUSE_D: "Chất liệu khuếch tán hỗ trợ normal map, phù hợp với vật thể cần ánh sáng cơ bản và chi tiết normal map, như là công trình, prop, v.v.",
  FE_49A_HZY_SHADER_BUMPSPECULAR_D: "Chất liệu phản xạ dựa trên mô hình ánh sáng Blinn-Phong, hỗ trợ normal map và map phản xạ. Phù hợp với vật thể kim loại, nhựa hoặc các bề mặt bóng.",
  FE_49A_HZY_SHADER_DIFFUSECOLORMULTI_D: "Chất liệu khuếch tán nhiều nguồn ánh sáng được tạo từ chất liệu khuếch tán cổ điển, hỗ trợ nhiều nguồn ánh sáng và phù hợp với vật thể cơ bản yêu cầu hiệu ứng kết xuất nhiều nguồn ánh sáng.",
  FE_49A_HZY_SHADER_DIFFUSECOLOR_D: "Chất liệu khuếch tán tiêu chuẩn hỗ trợ ánh sáng cơ bản và vẽ lồng màu, phừ hợp với vật thể trường cảnh, prop hoặc nhân vật chỉ yêu cầu chất liệu cơ bản.",
  FE_49A_HZY_SHADER_DIFFUSECWE_D: "Chất liệu khuếch tán với hiệu ứng phát sáng trên bề mặt, hỗ trợ texture mask và hoạt ảnh chạy UV. Phù hợp với vật thể yêu cầu cải thiện hình ảnh và hiệu ứng linh hoạt.",
  FE_49A_HZY_SHADER_PARTICLE_D: "Chất liệu hiệu ứng tiêu chuẩn hỗ trợ vẽ lồng màu, điều chỉnh độ sáng, xoay texture và mask blending. Chất liệu cung cấp 3 chế độ blending cơ bản: Mờ đục, Alpha Blend, và Cộng thêm, phù hợp với hiệu ứng hạt cơ bản hoặc thành phần UI.",
  FE_49A_HZY_SHADER_REFLECTIONBM_D: "Chất liệu phản xạ nhiều ánh sáng hỗ trợ normal map, highlight phản xạ, phản xạ môi trường, và hiệu ứng Fresnel. Chất liệu còn cung cấp nhiều kiểu blending, phù hợp với vật thể trường cảnh, prop và nhân vật yêu cầu hiển thị chất lượng cao và hiệu ứng đa nguồn ánh sáng.",
  FE_49A_HZY_SHADER_SKYBOXPRO_D: "Chất liệu nền trời thủ tục hỗ trợ màu gradient và vết sáng mặt trời, phù hợp để tạo hiệu ứng bầu trời đơn giản hoặc theo chủ đề hoạt hình.",
  FE_49A_HZY_SHADER_SKYBOX_D: "Chất liệu nền trời hỗ trợ texture 6 cạnh, xoay texture và điều chỉnh phơi sáng, phù hợp để kết xuất nền trời.",
  FE_49A_MX_ACTUAL_HEIGHT: "Độ cao thực",
  FE_49A_MX_ACTUAL_WIDTH: "Độ rông thực",
  FE_49A_MX_TEXTURE_MAX_SIZE: "Kích cỡ tối đa",
  FE_49A_XYL_STORE_BANNED: "Tài nguyên đã bị cấm",
  FE_49A_XYL_STORE_REVIEW_FAILED: "Đánh giá thất bại",
  FE_49_HJ_DEBUG_ERROR: "Kết nối với máy chủ thất bại, vui lòng thử lại sau",
  FE_49_HJ_DEBUG_GAMEOVER: "Trận đấu đã kết thúc",
  FE_49_HJ_PLAYER_SlowMove_FIST: "Di chuyển chậm",
  FE_49_HJ_PLAYER_SlowMove_GUN: "Di chuyển chậm (cầm súng trường)",
  FE_49_HJ_PLAYER_SlowMove_PISTOL: "Di chuyển chậm (cầm súng lục)",
  FE_49_HZY_CONTROLLER: "Điều khiển chơi",
  FE_49_HZY_CONTROLLERATTACH: "Thành phần thực thể có thể được gắn thêm điều khiển chơi",
  FE_49_HZY_CONTROLLER_DELETETIP: "Không tìm thấy vật thể",
  FE_49_HZY_CONTROLLER_FRAMEMOVE: "Theo frame",
  FE_49_HZY_CONTROLLER_FRAMEMOVETIP: "Thiết lập chuyển động theo frame hay không. Nếu true: chuyển động theo frame; nếu false: chuyển động tích lũy",
  FE_49_HZY_CONTROLLER_LIFETIME: "Vòng đời (ms)",
  FE_49_HZY_CONTROLLER_OVERRIDETIP: "Xung đột với chuyển động khác: thực thể có thể chơi {0}",
  FE_49_HZY_CONTROLLER_PLAYABLE: "Có thể chơi {0}",
  FE_49_HZY_CONTROLLER_STARTTIME: "Thời gian chờ trước khi bắt đầu (ms)",
  FE_49_HZY_FFA: "Loạn Chiến",
  FE_49_HZY_FFA_D: "Bạn sẽ một mình chiến đấu mọi người trong chế độ Loạn Chiến, mỗi vòng bạn sẽ đấu trong một khu vực ngẫu nhiên của Đảo Quân Sự. Bạn có thể mua vũ khí và diệt địch để tích lũy điểm. Sẽ có bảng điểm số được cập nhật liên tục trong trận để mọi người biết xếp hạng và điểm số của mình.",
  FE_49_HZY_PARKOUR: "Vượt chướng ngại vật",
  FE_49_HZY_PARKOUR_D: "Bản đồ vượt chướng ngại vật cổ điển, bao gồm các điểm mốc cơ bản và đích trong trường cảnh. Thử tay thiết kế một bản đồ vượt chướng ngại vật thật sáng tạo và thú vị nhé!",
  FE_49_HZY_TEMPLATE_COMPLEXITY_1: "Thấp",
  FE_49_HZY_TEMPLATE_COMPLEXITY_2: "Trung",
  FE_49_HZY_TEMPLATE_COMPLEXITY_3: "Cao",
  FE_49_HZY_TEMPLATE_ECACOMPLEXITY: "Độ phức tạp của ECA",
  FE_49_HZY_TEMPLATE_LEVEL1: "Đơn giản",
  FE_49_HZY_TEMPLATE_LEVEL2: "Cao cấp",
  FE_49_HZY_TEMPLATE_LEVEL3: "Chuyên nghiệp",
  FE_49_HZY_TEMPLATE_SCENECOMPLEXITY: "Độ phức tạp của Trường cảnh",
  FE_49_HZY_TEMPLATE_TUTORIAL: "Xem hướng dẫn",
  FE_49_HZY_TEMPLATE_UICOMPLEXITY: "Độ phức tạp của UI",
  FE_49_TYC_PHYS_FREEZE_POS_X: "Khóa vị trí - x",
  FE_49_TYC_PHYS_FREEZE_POS_Y: "Khóa vị trí - y",
  FE_49_TYC_PHYS_FREEZE_POS_Z: "Khóa xoay - z",
  FE_49_TYC_PHYS_FREEZE_ROT_X: "Khóa xoay - x",
  FE_49_TYC_PHYS_FREEZE_ROT_Y: "Khóa xoay - y",
  FE_49_TYC_PHYS_FREEZE_ROT_Z: "Khóa vị trí - z",
  FE_49_TYC_PHYS_HINT_ANGULAR_DRAG: "Áp dụng mô men lực lên vật thể tương ứng với vận tốc góc hiện tại của vật thể theo hướng ngược lại, nhằm làm vật thể ngừng xoay",
  FE_49_TYC_PHYS_HINT_DRAG: "Áp dụng lực lên vật thể tương đương với vận tốc tuyến tính hiện tại của vật thể và theo hướng ngược lại, nhằm khiến vật thể chậm lại khi không có lực bên ngoài.",
  FE_49_TYC_PHYS_MAT_HINT_BOUNCINESS: "Độ nảy của vật thể trong mô phỏng vật lý.",
  FE_49_TYC_PHYS_MAT_HINT_BOUNCINESS_COMBINATION: `Đặc tính này quyết định cách tính độ nảy khi 2 vật va chạm trong mô phỏng vật lý: 
Trung bình: Sử dụng giá trị trung bình của 2 giá trị nảy.
Tối thiểu: Sử dụng giá trị nảy nhỏ hơn.
Tích: Nhân 2 giá trị nảy.
Tối đa: Sử dụng giá trị nảy lớn hơn.

Khi 2 vật thể có cài đặt khác nhau, thứ tự ưu tiên sẽ thành: Trung bình < Tối thiểu < Tích < Tối đa.`,
  FE_49_TYC_PHYS_MAT_HINT_DYNAMIC_FRICTION: "Giá trị ma sát động của vật thể trong mô phỏng vật lý",
  FE_49_TYC_PHYS_MAT_HINT_FRICTION_COMBINATION: `Đặc tính này quyết định cách tính ma sát khi 2 vật thể va chạm trong mô phỏng vật lý: 
Trung bình: Dùng giá trị trung bình của 2 giá trị ma sát.
Tối thiểu: Sử dụng giá trị ma sát nhỏ hơn.
Tích: Nhân hai giá trị ma sát.
Tối đa: Sử dụng giá trị ma sát lớn hơn.

Khi hai vật thể có cài đặt khác nhau, thứ tự ưu tiên sẽ thành: Trung bình < Tối thiểu < Tích < Tối đa. Ví dụ, nếu một vật thể được đặt "Trung bình" và vật thể còn lại được đặt "Tối đa", va chạm sẽ được tính theo cài đặt Tối đa.`,
  FE_49_TYC_PHYS_MAT_HINT_STATIC_FRICTION: "Giá trị ma sát tĩnh của vật thể trong mô phỏng vật lý",
  FE_49_TYC_PHYS_OPTIMIZATION_MAX: "Tối ưu hóa tối đa",
  FE_49_TYC_PHYS_OPTIMIZATION_MEDIUM: "Tối ưu hóa trung bình",
  FE_49_TYC_PHYS_OPTIMIZATION_MIN: "Tối ưu hóa một ít",
  FE_49_TYC_PHYS_OPTIMIZATION_NONE: "Không tối ưu hóa",
  FE_49_TYC_SHADER_SKYBOX_ENUM_MAIN_COLOR: "Sử dụng màu của nguồn sáng trong trường cảnh",
  FE_49_TYC_SHADER_SKYBOX_ENUM_SUN_COLOR: "Sử dụng màu mặt trời",
  FE_49_TYC_SHADER_SKYBOX_EXPOSURE: "Độ phơi sáng",
  FE_49_TYC_SHADER_SKYBOX_GROUND_COLOR: "Màu mặt đất",
  FE_49_TYC_SHADER_SKYBOX_GROUND_GRADIENT: "Màu gradient của mặt đất",
  FE_49_TYC_SHADER_SKYBOX_GROUND_HORIZON_COLOR: "Màu mặt đất gần đường chân trời",
  FE_49_TYC_SHADER_SKYBOX_ROTATION: "Xoay",
  FE_49_TYC_SHADER_SKYBOX_SKY_COLOR: "Màu của bầu trời",
  FE_49_TYC_SHADER_SKYBOX_SKY_GRADIENT: "Màu gradient của bầu trời",
  FE_49_TYC_SHADER_SKYBOX_SKY_HORIZON_COLOR: "Màu bầu trời gần đường chân trời",
  FE_49_TYC_SHADER_SKYBOX_SUN_COLOR: "Màu mặt trời",
  FE_49_TYC_SHADER_SKYBOX_SUN_COLOR_MODE: "Chế độ màu mặt trời",
  FE_49_TYC_SHADER_SKYBOX_SUN_SIZE: "Kích cỡ mặt trời",
  FE_49_TYC_SHADER_SKYBOX_TEX_BACK: "Shader sau",
  FE_49_TYC_SHADER_SKYBOX_TEX_DOWN: "Shader dưới",
  FE_49_TYC_SHADER_SKYBOX_TEX_FRONT: "Shader trước",
  FE_49_TYC_SHADER_SKYBOX_TEX_LEFT: "Shader trái",
  FE_49_TYC_SHADER_SKYBOX_TEX_RIGHT: "Shader phải",
  FE_49_TYC_SHADER_SKYBOX_TEX_UP: "Shader trên",
  FE_49_TYC_SHADER_SKYBOX_TINT_COLOR: "Màu",
  FE_49_TYC_SKY_CUSTOM_MATERIAL: "Chất liệu nền trời",
  FE_49_TYC_SKY_MAT_TYPE_WARNING: "Bạn nên dùng chất liệu và shader phù hợp với nền trời",
  FE_49_XXJ_CUSTOMEVENT: "Sự kiện tùy chỉnh",
  FE_49_XXJ_EVENT: "Sự kiện định nghĩa bởi mã lệnh",
  FE_49_XXJ_EVENTMGR: "Trình quản lý Sự kiện",
  FE_49_XXJ_EVENTPRAM: "Gửi tham số sự kiện",
  FE_49_XXJ_EVENTPRAM_D: "Khi gửi sự kiện tùy chỉnh, bạn có thể chọn chạy một số dữ liệu qua các tham số. Đây là các tên và kiểu tham số đã được thiết lập trước.",
  FE_49_XXJ_NOEVENT: "Không có sự kiện tùy chỉnh",
  FE_49_XXJ_PERFORMANCE_1: "Chọn tài nguyên trình diễn để bắt đầu điều chỉnh",
  FE_49_XXJ_PERFORMANCE_10: "Dừng",
  FE_49_XXJ_PERFORMANCE_11: "Nhảy nhanh về đầu",
  FE_49_XXJ_PERFORMANCE_12: "Nhảy nhanh về đích",
  FE_49_XXJ_PERFORMANCE_13: "Đi tiếp 1 frame",
  FE_49_XXJ_PERFORMANCE_14: "Lùi lại 1 frame",
  FE_49_XXJ_PERFORMANCE_15: "Phạm vi chơi",
  FE_49_XXJ_PERFORMANCE_16: "Quản lý sub-track",
  FE_49_XXJ_PERFORMANCE_17: "Đã khóa",
  FE_49_XXJ_PERFORMANCE_18: "Đã tắt tiếng",
  FE_49_XXJ_PERFORMANCE_19: "Vật nhận",
  FE_49_XXJ_PERFORMANCE_2: "Mở trình chọn Tài nguyên",
  FE_49_XXJ_PERFORMANCE_20: "Đang xem trước",
  FE_49_XXJ_PERFORMANCE_21: "Không thể điều chỉnh vì đang chọn track diễn viên không liên kết và track diễn viên liên kết",
  FE_49_XXJ_PERFORMANCE_3: "Nhóm track",
  FE_49_XXJ_PERFORMANCE_4: "Phương pháp tính độ dài",
  FE_49_XXJ_PERFORMANCE_5: "Cố định",
  FE_49_XXJ_PERFORMANCE_6: "Tự động tính",
  FE_49_XXJ_PERFORMANCE_7: "Bắt đầu ghi",
  FE_49_XXJ_PERFORMANCE_8: "Dừng ghi",
  FE_49_XXJ_PERFORMANCE_9: "Bắt đầu chơi",
  FE_49_XXJ_RECEIVEEVENT: "Khi nhận Sự kiện {0}",
  FE_49_XXJ_RECEIVERTYPE: "Kiểu vật nhận",
  FE_49_XXJ_RECEIVERTYPE_D: 'Khi gửi sự kiện tùy chỉnh, vật nhận sự kiện phải được định dạng là tham số. Đây là cài đặt được thiết lập trước cho kiểu vật nhận. Chọn kiểu và trình chỉnh sửa sẽ hỗ trợ kiểm tra kiểu vật nhận. Nếu bạn không biết rõ là kiểu gì, chọn "Thực thể" làm kiểu vật nhận.',
  FE_49_XXJ_SENDEVENT: "Gửi Sự kiện {0}",
  FE_49_XYL_GAMEPLAYOBJECTTIPDESC: "Vật thể có tính năng chơi",
  FE_49_ZCS_FEASSETSTORENOT_SUPPORT_ITEM: "Không có vật phẩm để chọn",
  FE_49_ZCS_FEASSETSTORE_CLPACKAGE: "Kiểu tài nguyên",
  FE_49_ZCS_FEASSETSTORE_CLSETTING: "Cài đặt tải lên Craftland",
  FE_49_ZCS_FEASSETSTORE_COMMON_CANTUPLOAD_ITEMBYTES: "Dự án của bạn không thể được tải lên làm tài nguyên stream",
  FE_49_ZCS_FEASSETSTORE_COST: "Giá",
  FE_49_ZCS_FEASSETSTORE_CUSTOM_SELECTION: "Lựa chọn tùy chỉnh",
  FE_49_ZCS_FEASSETSTORE_DEFAULTTEXT_UI: "Cung cấp thông tin về vật thể {0}",
  FE_49_ZCS_FEASSETSTORE_DEFAULT_CATAGORY: "Danh mục mặc định",
  FE_49_ZCS_FEASSETSTORE_DEFAULT_VALUE: "Giá trị mặc định",
  FE_49_ZCS_FEASSETSTORE_ENTITYTYPE: "Kiểu thực thể",
  FE_49_ZCS_FEASSETSTORE_ERROR_ASSET_SELECT: "Bạn chỉ có thể chọn trong danh mục tài nguyên để đóng gói",
  FE_49_ZCS_FEASSETSTORE_ERROR_CANTBUILD: "Chưa có tài nguyên được chọn để đóng gói",
  FE_49_ZCS_FEASSETSTORE_ERROR_NOASSET: "Không tìm thấy tài nguyên",
  FE_49_ZCS_FEASSETSTORE_EXPAND_DETAIL: "Mở rộng",
  FE_49_ZCS_FEASSETSTORE_EXPORT_ALL: "Xuất tất cả",
  FE_49_ZCS_FEASSETSTORE_FESETTING: "Cài đặt tải lên Craftland Studio",
  FE_49_ZCS_FEASSETSTORE_HIDE_SOURCEFILE: "Giấu tệp nguồn",
  FE_49_ZCS_FEASSETSTORE_ITEMBYTES_ADVANCED: 'Bạn có thể thủ công chỉnh sửa "manifest" và "description.ecad" để có thêm tính năng nâng cao',
  FE_49_ZCS_FEASSETSTORE_ITEM_CATAGORY: "Danh mục vật phẩm",
  FE_49_ZCS_FEASSETSTORE_ITEM_DESC: "Mô tả",
  FE_49_ZCS_FEASSETSTORE_ITEM_NAME: "Tên vật phẩm",
  FE_49_ZCS_FEASSETSTORE_MAX_VALUE: "Giá trị tối đa",
  FE_49_ZCS_FEASSETSTORE_MIN_VALUE: "Giá trị tối thiểu",
  FE_49_ZCS_FEASSETSTORE_NOTSELECT_PREFEB: "Chưa chọn thành phần ghép sẵn",
  FE_49_ZCS_FEASSETSTORE_SCALE: "Kích cỡ",
  FE_49_ZCS_FEASSETSTORE_SCALING_RANGEERROR: "Lỗi phạm vi. Giá trị chỉ nằm trong {0} - {1}",
  FE_49_ZCS_FEASSETSTORE_SCALING_SIZEERROR: "Lỗi kích cỡ. Vui lòng điều chỉnh giá trị tối thiểu thấp hơn giá trị tối đa.",
  FE_49_ZCS_FEASSETSTORE_SELECTION_SIZE: "Kích cỡ lựa chọn",
  FE_49_ZCS_FEASSETSTORE_SELECTION_TIP: "Chọn một vật phẩm trong gói để sử dụng",
  FE_49_ZCS_FEASSETSTORE_SELECT_PLATFORMS: "Chọn nền tảng xuất bản",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_ANNO: "Không có vật phẩm có thể chọn",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_COST: "Tổng giá trị",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_INFO: "Thông tin vật phẩm nhỏ",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_INFO_TIPS: "Tài nguyên này đến từ gói tài nguyên gốc. Bạn có thể dùng riêng hoặc dùng kết hợp với tài nguyên khác",
  FE_49_ZCS_FEASSETSTORE_SMALLITEMS_SELECTALL: "Chọn tất cả",
  FE_49_ZCS_FEASSETSTORE_STEP_VALUE: "Giá trị theo bước",
  FE_49_ZCS_FEASSETSTORE_TAG_NOTICE: "Nhập văn bản để tạo nhãn tùy chỉnh",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_ALL: "Tất cả",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_CL: "Craftland",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_DUAL: "Hai nền tảng",
  FE_49_ZCS_FEASSETSTORE_UPLOADPAGE_FE: "Craftland Studio",
  FE_49_ZCS_PREFABCHANGE_WARNING: "Hành động của bạn sẽ thay đổi cấu trúc của thành phần ghép sẵn, nhưng các thành phần ghép sẵn hiện có trong trường cảnh sẽ không bị thay đổi. Vui lòng thay đổi thủ công các thành phần ghép sẵn đó.",
  FE_50A_M_UNPUBLISH: "Hủy xuất bản",
  FE_50A_M_UNPUBLISH2: "Việc phát hành dự án đang bị hủy bỏ. Vui lòng chờ một chút……",
  FE_50A_SJZ_MANAGE_ASAVESC: "Tự động lưu thành công",
  FE_50A_SJZ_MANAGE_ASAVETIME: "Khoảng thời gian tự động lưu",
  FE_50A_SJZ_MANAGE_HOUR: "{0}giờ",
  FE_50A_SJZ_MANAGE_MIN: "{0}phút",
  FE_50A_SJZ_MANAGE_NEVER: "Không bao giờ",
  FE_50A_SJZ_MANAGE_SAVEAS: "Lưu thành",
  FE_50A_SJZ_MANAGE_SAVEASSC: "Lưu thành công",
  FE_50A_SJZ_MANAGE_SEC: "{0}giây",
  FE_50A_SJZ_SEL_ACT: "Không hoạt động",
  FE_50A_SJZ_SEL_HID: "Ẩn",
  FE_50A_SJZ_SEL_LOC: "Đã khóa",
  FE_50A_SJZ_SEL_VIS: "Tàng hình",
  FE_50A_XXJ_PREVIEW_PREFAB: "Hiện tại không hỗ trợ xem trước nội dung đặt trước.",
  FE_50A_XYL_PREFABSCREENSHOTSGEN: "Chụp ảnh màn hình nội dung đặt trước",
  FE_50_HJ_COL_ALLCOL: "Thiết lập thông tin cột",
  FE_50_HJ_COL_COLNUMWARNING: "Đã đạt số cột tối đa",
  FE_50_HJ_COL_ISUID: "UID làm khóa",
  FE_50_HJ_COL_ISUID_TIP: "Dùng UID người chơi làm khóa",
  FE_50_HJ_COL_KEYNAME: "KHÓA",
  FE_50_HJ_COL_TABLENAME: "Bảng dữ liệu nhiều cột",
  FE_50_MX_Action_Enumeration: "Enum hành động của Nhân dạng {0}",
  FE_50_MX_Persona_Action_ID_Check: "Hành động {1} của Nhân dạng {0} không tồn tại, hãy kiểm tra",
  FE_50_MX_Persona_ID_Check: "Nhân dạng {0} không tồn tại, vui lòng kiểm tra",
  FE_50_M_CANCELPUBLISH: "Xuất bản đã bị hủy, bạn có thể xuất bản lại nếu cần thiết.",
  FE_50_M_PUBLISHING: "Xuất bản",
  FE_50_TYC_PTC_ACCELERATION_OVER_LIFETIME: "Đường cong Gia tốc Hạt",
  FE_50_TYC_PTC_ACCELERATION_OVER_LIFETIME_DESC: "Thuộc tính này quyết định việc thay đổi gia tốc của hạt trong thời gian tồn tại của nó",
  FE_50_TYC_PTC_ANGLE_OVER_LIFETIME: "Đường cong Góc Hạt",
  FE_50_TYC_PTC_ANGLE_OVER_LIFETIME_DESC: "Thuộc tính này quyết định việc thay đổi góc của hạt trong thời gian tồn tại của nó",
  FE_50_TYC_PTC_ENUM_HORIZONAL_BILLBOARD: "Bảng quảng cáo ngang",
  FE_50_TYC_PTC_ENUM_HORIZONAL_BILLBOARD_DESC: "Hạt được tạo được kết xuất dưới dạng tứ giác với hướng đối diện thế giới Y+. Khi hạt xoay, chúng sẽ xoay theo trục Y+.",
  FE_50_TYC_PTC_ENUM_VERTICAL_BILLBOARD: "Bảng quảng cáo dọc",
  FE_50_TYC_PTC_ENUM_VERTICAL_BILLBOARD_DESC: "Hạt được tạo được kết xuất dưới dạng tứ giác và liên tục hướng theo camera theo mặt phẳng ngang; khi xoay, trục xoay được căn chỉnh theo normal của bảng.",
  FE_50_TYC_PTC_SIZE_OVER_LIFETIME: "Đường cong Kích cỡ Hạt",
  FE_50_TYC_PTC_SIZE_OVER_LIFETIME_DESC: "Thuộc tính này quyết định việc thay đổi kích cỡ của hạt trong thời gian tồn tại của nó",
  FE_50_TYC_PTC_VELOCITY_OVER_LIFETIME: "Đường cong Vận tốc Hạt",
  FE_50_TYC_PTC_VELOCITY_OVER_LIFETIME_DESC: "Thuộc tính này quyết định việc thay đổi vận tốc hạt trong thời gian tồn tại của nó",
  FE_50_TYC_TRS: "Nội suy",
  FE_50_TYC_TRS_BLEND_RATIO: "Tỉ lệ được áp dụng",
  FE_50_TYC_TRS_BLEND_RATIO_DESC: "Chỉnh tỉ lệ của giá trị dự đoán được áp dụng. Ví dụ, 0.8 tương đương với dùng 20% dữ liệu hiện tại và 80% dữ liệu dự đoán làm kết quả cuối.",
  FE_50_TYC_TRS_ENUM_EXTRAPOLATION: "Ngoại suy",
  FE_50_TYC_TRS_ENUM_INTRAPOLATION: "Nội suy",
  FE_50_TYC_TRS_INTERPOLATION_METHOD: "Phương pháp",
  FE_50_TYC_TRS_INTERPOLATION_METHOD_DESC: `Ngoại suy: Vị trí của vật thể ở trước vị trí thực của nó một chút, nên có thể gây đi xuyên trong thời gian ngắn.
Nội suy: Vị trí của vật thể ở sau vị trí thực của nó một chút, nên có thể gây giật trong va chạm.`,
  FE_50_TYC_TRS_MAX_ERROR: "Lỗi tối đa",
  FE_50_TYC_TRS_MAX_ERROR_DESC: "Khi lỗi vượt quá giá trị này, lỗi sẽ tự động được sửa ngay (làm có hiệu ứng như dịch chuyển)",
  FE_50_TYC_TRS_MAX_ERROR_TIME: "Thời gian sửa lỗi",
  FE_50_TYC_TRS_MAX_ERROR_TIME_DESC: "Khi lỗi vượt quá giá trị này, sẽ bắt đầu đếm ngược dựa vào giá trị này, và lỗi sẽ tự động được sửa (làm có hiệu ứng như dịch chuyển)",
  FE_50_TYC_TRS_MIN_ERROR: "Ngưỡng lỗi",
  FE_50_TYC_TRS_MIN_ERROR_DESC: "Khi lỗi vượt quá giá trị này, sẽ bắt đầu đếm ngược, và lỗi sẽ tự động được sửa (làm có hiệu ứng như dịch chuyển)",
  FE_50_TYC_TRS_PREDICT_RATIO: "Tỉ lệ dự đoán",
  FE_50_TYC_TRS_PREDICT_RATIO_DESC: `Chỉnh tỉ lệ dữ đoán ngoại suy. Ví dụ, giá trị 1.2 sẽ tăng kết quả lên 20%.
Nếu tốc độ vật thể thay đổi thường xuyên, giá trị này nên được giảm tương đương.`,
  FE_50_XXJ_ACONCE: "Một lần",
  FE_50_XXJ_ACPOSTEXTRA: "Sau khi ngoại suy",
  FE_50_XXJ_ACWRAPMODE: "Chế độ cuộn",
  FE_50_XXJ_PERFORMANCE_BETA: "Trình diễn (bản beta)",
  FE_50_XXJ_RESLENGTH: "Độ dài tài nguyên",
  FE_50_XXJ_TIMELINE_TRACK_ID: "ID Track",
  FE_50_XXJ_TL_CLIP_RESET_ALL: "Làm lại tất cả",
  FE_50_XXJ_TL_CLIP_RESET_DURATION: "Làm lại thời lượng",
  FE_50_XXJ_TL_CLIP_RESET_SPEED: "Tốc độ làm lại",
  FE_50_XXJ_TL_MISSING_ENTITY: "Người nhận được chọn thiếu thành phần {0} sự kiện này bắt buộc phải có",
  FE_50_XXJ_TL_PROP_MANAGER: "Quản lý Track Thuộc tính",
  FE_51_HJ_FIRE: "Ném lựu đạn",
  FE_51_HJ_FIRE_CRAWL: "Ném lựu đạn khi nằm",
  FE_51_HJ_FIRE_CROUCH: "Ném lựu đạn khi ngồi",
  FE_51_HJ_GRENADE_CRAWL: "Nằm (cầm lựu đạn)",
  FE_51_HJ_GRENADE_CROUCH: "Ngồi (cầm lựu đạn)",
  FE_51_HJ_GRENADE_IDLE: "Đứng (cầm lựu đạn)",
  FE_51_HZY_CUSTOMSTORE_BUNDLE: "Gói",
  FE_51_HZY_CUSTOMSTORE_CUSTOMITEM: "Vật phẩm Tùy chỉnh",
  FE_51_HZY_FILTER_CUSTOMPROP: "Bao gồm Thuộc tính Tùy chỉnh",
  FE_51_HZY_GSEARCH: "Tìm tất cả",
  FE_51_HZY_GSEARCH_SHORTCUT: "Tìm tất cả Ctrl+K",
  FE_51_HZY_KALAHARI: "Đảo Sa Mạc",
  FE_51_HZY_KALAHARI_D: "This project contains no code. Kalahari is set as the default terrain.",
  FE_51_HZY_NEXTERRA: "Đảo Thế Kỷ",
  FE_51_HZY_NEXTERRA_D: "This project contains no code. NexTerra is set as the default terrain.",
  FE_51_HZY_SEARCH_BLOCK: "Khối",
  FE_51_HZY_SEARCH_COMPONENTS: "Thành phần",
  FE_51_HZY_SEARCH_MENU: "Menu",
  FE_51_HZY_SEARCH_NULL: "Không tìm thấy trong {0}",
  FE_51_HZY_SEARCH_UICONTROL: "UI Tiện ích",
  FE_51_HZY_SHADER_APECULARINTENSITY: "Specular Intensity",
  FE_51_HZY_SHADER_CLIPPING: "Clipping",
  FE_51_HZY_SHADER_CONTRAST: "Contrast",
  FE_51_HZY_SHADER_DEST: "Đích đến",
  FE_51_HZY_SHADER_EMISSIONCOLOR: "Emission Color",
  FE_51_HZY_SHADER_EMISSIONINTENSITY: "Emission Intensity",
  FE_51_HZY_SHADER_EXPRESSIONTEX: "Expression Texture",
  FE_51_HZY_SHADER_EXPRESSIONTEXTO: "Expression Tiling/Offset",
  FE_51_HZY_SHADER_GLOSS: "Gloss",
  FE_51_HZY_SHADER_HAIR1: "Màu tóc 1",
  FE_51_HZY_SHADER_HAIR2: "Màu tóc 2",
  FE_51_HZY_SHADER_HAIR3: "Màu tóc 3",
  FE_51_HZY_SHADER_HAIR4: "Màu tóc 4",
  FE_51_HZY_SHADER_HAIRSHIFT: "Hair Shift",
  FE_51_HZY_SHADER_MAKEUPTEX: "Makeup Texture",
  FE_51_HZY_SHADER_MAKEUPTEXTO: "Facepaint Tiling/Offset",
  FE_51_HZY_SHADER_MINIAVATARHAIR: "Hair material for mini characters in Craftland. Supports adjustable parameters like hair texture, normal, lighting, rim lighting, emission, anisotropic highlighting, and more for greater hair customization such as global, highlight, and dip dye.",
  FE_51_HZY_SHADER_MINIAVATARSKIN: "Skin material for mini characters in Craftland. Supports base color gradients, layered expression and facepaint textures. Adjustable parameters include skin tone,  ambient lighting, specular, normal, rim, and more.",
  FE_51_HZY_SHADER_MINIAVATARSTANDARD: "Standard material for mini characters' outfits and props in Craftland. Supports opaque, translucent and Cutoff modes. Adjustable  parameters include custom texture overlays, basic color texture, normal/shine, specular, reflection (MatCap),  emission, and rim.",
  FE_51_HZY_SHADER_MINLIGHTINTENSITY: "Main Light Intensity",
  FE_51_HZY_SHADER_NORMALINTENSITY: "Cường độ Bình thường",
  FE_51_HZY_SHADER_PREMULTIPLAY: "Premultiplay Alpha",
  FE_51_HZY_SHADER_REFELECTION: "Reflection CubeMap",
  FE_51_HZY_SHADER_REFELECTIONTEX: "Reflection MatCap",
  FE_51_HZY_SHADER_RIMCOLOR: "Rim Color",
  FE_51_HZY_SHADER_RIMINTENSITY: "Rim Intensity",
  FE_51_HZY_SHADER_RIMPOWER: "Rim Power",
  FE_51_HZY_SHADER_SER: "R: Lớp Độ Bóng, G: Lớp Phát Sáng, B: Lớp Phản Chiếu",
  FE_51_HZY_SHADER_SHADOWINTENSITY: "Shadow Intensity",
  FE_51_HZY_SHADER_SHADOWSPECULARINTENSITY: "Shadow Specular Intensity",
  FE_51_HZY_SHADER_SHINECOLOR: "Shine Color",
  FE_51_HZY_SHADER_SHINEINTENSITY: "Shine Intensity",
  FE_51_HZY_SHADER_SHINEVALUE: "Shine Value",
  FE_51_HZY_SHADER_SHINEVALUE_D: "Pos(x): Shine's position, Range(y): Shine's range, Length(z): Shine's length",
  FE_51_HZY_SHADER_SKINCOLOR: "Skin Tone",
  FE_51_HZY_SHADER_SOURCE: "Nguồn",
  FE_51_HZY_SHADER_SPECULARCOLOR: "Specular Color",
  FE_51_HZY_SHADER_SPECULARMAP: "Specular Map",
  FE_51_HZY_SHADER_SPECULARVALUE_D: `Pos(x): Specular's Position,
Rnage(y): Specular's Range,
Length(z) Specular's Length`,
  FE_51_HZY_SHADER_TINTCOLOR: "Tint Color",
  FE_51_HZY_SHADER_TOPSPECULARCOLOR: "Specular Color",
  FE_51_HZY_SHADER_TOPSPECULARINTENSITY: "Specular Intensity",
  FE_51_HZY_SHADER_TOPSPECULARVALUE: "Specular Value",
  FE_51_HZY_SOLARA: "Đảo Bình Minh",
  FE_51_HZY_SOLARA_D: "This project contains no code. Solara is set as the default terrain.",
  FE_51_MX_IMAGE_READ_WRITE: "Đọc/Viết",
  FE_51_MX_IMAGE_READ_WRITE_TIP: 'Enable "Read/Write" only when script or runtime modification of particle meshes/textures are needed. Disable it otherwise to improve performance.',
  FE_51_MX_PERSONA_NAME: "Tên Nhân vật",
  FE_51_MX_PERSONA_OBSERVER: "Quan sát",
  FE_51_MX_PERSONA_UPDATETIME: "Thời gian Cập nhật",
  FE_51_MX_VOICE_TIP: "ID Giọng nói: {0} yêu cầu logic khối để kích hoạt",
  FE_51_MX_VOICE_VOICEID: "ID Giọng nói",
  FE_51_MX_VOICE_VOICETITLE: "Giọng nói",
  FE_51_TYC_PHYS_MAT_AVERAGE: "Trung bình",
  FE_51_TYC_PHYS_MAT_DYNAMIC_FRICTION: "Ma sát động",
  FE_51_TYC_PHYS_MAT_HINT_DYNAMIC_FRICTION: "The friction coefficient when a rigid body is sliding on a surface.",
  FE_51_TYC_PHYS_MAT_HINT_STATIC_FRICTION: "The friction coefficient when a rigid body is resting",
  FE_51_TYC_PHYS_MAT_MAX: "Tối đa",
  FE_51_TYC_PHYS_MAT_MIN: "Tối thiểu",
  FE_51_TYC_PHYS_MAT_MULTIPLY: "Nhân",
  FE_51_TYC_PHYS_MAT_STATIC_FRICTION: "Ma sát tĩnh",
  FE_51_XXJ_ANIMATIONTARGET: "Thực thể track chính thiếu thành phần {0}",
  FE_51_XXJ_ONPROPERTYCHANGE_TIPS: "When enabled, changes to this custom property will send corresponding events to block scripts or code scripts. Note: if the custom property is modified on the server, the event is sent to both server and client; if a local entity's custom property is modified on the client, the event is sent only locally.",
  FE_51_XXJ_PREVIEW_FPV1: "Khi được kích hoạt, chức năng Đổi Track Camera sẽ điều khiển khung xem trước, cũng là góc nhìn cuối cùng của người chơi",
  FE_51_XXJ_PREVIEW_FPV2: "Khóa Góc Người chơi",
  FE_51_XYL_CLASSETNOVERSION: "Hiện không thể xuất bản nhiều phiên bản tài nguyên Craftland.",
  FE_51_XYL_PREFAB_NOT_IDENTITY: "Phát hiện lệch vị trí gốc. Hãy kiểm tra và khắc phục.",
  FE_51_XYL_WRONGACCOUNT: "Lỗi Tài khoản",
  FE_OB43_TYC_HIERARCHY_HIDE_SHOW: "Ẩn/Hiện",
  FF_47A_HZY_QUICKMESSAGE_LEVEL: "Nâng cao - Tử Chiến",
  OB40A_UP_DB1: "Cập nhật tính năng Debug",
  OB40A_UP_DB2: "Thêm tính năng debug giữa dự án, thoát giữa trận, và mạng kém.",
  OB40A_UP_T1: "Nhiều tính năng cải thiện trải nghiệm người dùng và sửa lỗi.",
  OB40A_UP_W1: "Tạo vũ khí",
  OB40A_UP_W2: "Cho phép làm mới skin vũ khí trong trường cảnh khi thiết lập skin vũ khí trong Kiểm Tra.",
  OB40_UP_DB1: "Cập nhật tính năng lưu trữ dữ liệu",
  OB40_UP_DB2: `1. Trong phần "Quản lý Dữ liệu" của "Trung tâm Dữ liệu", chúng tôi đã thêm vào những tính năng mới như tìm kiếm, sắp xếp, và chỉnh sửa.
2. Tăng tần suất ghi/đọc:
- Tần suất ghi mỗi phút: 30 → 40
- Tần suất đọc mỗi phút: 50 → 60`,
  OB40_UP_O1: "Khác",
  OB40_UP_O2: `1. Hộp phạm vi va chạm tùy chỉnh có thể được sử dụng làm trigger.
2. Hỗ trợ nhập và sử dụng file âm thanh thông qua định dạng gói tài nguyên.
3. Thêm một công tắc để kết nối lại khi ngắt kết nối, một công tắt để giúp gia nhập lại trận đấu sau khi thoát, và một công tắt để phát hiện AFK.
4. Thêm một nhóm khối mới. Vui lòng tìm hiểu chi tiết tại UGC WIKI.`,
  OB40_UP_S1: "Cập nhật chỉnh sửa đa trường cảnh",
  OB40_UP_S2: `1. Hỗ trợ người chơi dịch chuyển sang trường cảnh khác trong trận đấu.
2. Khuyến nghị sử dụng:
- Đối với các dự án sử dụng tính năng đa trường cảnh, nên dùng trường cảnh trống thay vì sử dụng mẫu.
- Khuyến nghị sử dụng bản đồ nhỏ tùy chỉnh để tùy chỉnh các bản đồ nhỏ cho từng trường cảnh.
- Không nên để trùng tọa độ vật thể ở các trường cảnh khác nhau (file .scene) (Phiên bản 2.0 của Craftland Studio được thiết kế để các file trường cảnh .scene được kết hợp lại thành một bản đồ thế giới lớn ở máy chủ, trong khi mỗi máy khách chỉ tải một file .scene. Sử dụng tọa độ trùng có thể gây ra vấn đề khi xử lý ở phía máy chủ.)`,
  OB40_UP_T1: "Tính năng chỉnh sửa địa hình",
  OB40_UP_T2: `1. Giới thiệu tính năng mới "Địa hình", cho phép người dùng thực hiện các thao tác chỉnh sửa liên quan đến địa hình.
2. Thêm các kiểu cọ vẽ thực vật mới.
3. Mở rộng phạm vi địa hình có thể chỉnh sửa lên 150*150, giờ sẽ hỗ trợ khối đa địa hình.`,
  OB40_UP_UI1: "Cập nhật trình chỉnh sửa UI",
  OB40_UP_UI2: `1. Sắp xếp các thành phần Bảng điều khiển và Bố cục gốc trong "Trình chỉnh sửa UI" trong khi vẫn giữ được các thuộc tính tỉ lệ và điểm neo ban đầu. Ngoài ra, thêm vào các tính năng mới như tô màu nên hay cắt xén.
2. Các tính năng Bố cục đang tồn tại đã được di chuyển và sắp xếp lại, sẵn sàng để được sử dụng.
3. Thêm thành phần mới là Bảng cuộn với các thuộc tính tương ứng. Sử dụng nó để tạo ra hiệu ứng cuộn màn hình và hơn thế nữa.
4. Tất cả các thuộc tính thành phần giờ có thể được truy cập và gọi thông qua khối.`,
  OB41A_UP_1: "Thêm kênh phản hồi",
  OB41A_UP_1_D: "1. Nhấn vào nút chấm hỏi ở góc phải trên để gửi phản hồi của bạn.",
  OB41A_UP_2: "Tối ưu tương tác đa người dùng.",
  OB41_UP_1: "Hoạt ảnh động mới",
  OB41_UP_1_D: `1. Thêm tính năng trạng thái hoạt động cho phép thêm trạng thái hoạt động cho zombie và các thành phần ghép sẵn được nhập từ gói tài nguyên.
2. Trạng thái hoạt động là một trình điều khiển dành riêng cho hoạt ảnh. Các trạng thái có thể được thay đổi thông qua logic khối ECA.
3. Khi không còn có trạng thái để đổi hoặc đã hoàn thành tất cả các hoạt ảnh, trạng thái sẽ trở về nhàn rỗi.`,
  OB41_UP_2: "Cập nhật trình chỉnh sửa UI",
  OB41_UP_2_D: `1. Khối thiết lập nội suy giờ đã hỗ trợ điều khiển UI.
2. Thêm Vật chứa 3D, thứ có thể được dùng để chứa thành phần ghép sẵn, chẳng hạn như vật thể 3D hoặc hiệu ứng đặc biệt, vào Vật chứa và hiển thị chúng trên HUD.
3. Chọn và thay thế tài nguyên 3D thông qua tính năng quản lý tài nguyên.
4. Mở thiết lập xoay góc và thu phóng đối với những tài nguyên đơn bị cắt.
5. Nhiều tính năng tùy chỉnh Lớp phủ và hiển thị 9 phần như 9 ô, phủ đầy, phủ theo ô.
6. Phương thức phủ đầy mới cho Hình ảnh (tương tự như phần Lớp phủ).
7. Tính năng kiểm soát ảnh đại diện mới giúp lấy và hiển thị thông tin người chơi cho các tính năng như bảng xếp hạng.
8. Có 2 loại thiết kế để các nhà sáng tạo có thể chọn. Nhà sáng tạo có thể chọn thông tin người chơi để hiển thị, bao gồm biệt danh, số pin, bảng hiệu, và xếp hạng.`,
  OB41_UP_3: "Hỗ trợ chỉnh sửa qua tập lệnh",
  OB41_UP_3_D: `1. Cập nhật tính năng plug-in.
-Thông báo lỗi
-Tiêu điểm văn bản
-Thông báo chạy chữ
-Tái định nghĩa.
2.Cập nhật hỗ trợ engine.
3. Thêm tên tập lệnh Bạn có thể chỉnh sửa tên tập lệnh đối với các tính năng bên dưới bằng cách phải chuột hoặc sử dụng phím tắt
-Điều khiển tùy chỉnh
-Thuộc tính tùy chỉnh
-Enum tùy chỉnh
-Nội dung enum
-Sự kiện tùy chỉnh
-Biến khối
-Tính năng tùy chỉnh
-File ECA`,
  OB41_UP_4: "Cập nhật tính năng lưu trữ dữ liệu",
  OB41_UP_4_D: `1. Thêm bảng tính dữ liệu
2. Thêm tính năng xóa bảng xếp hạng theo chu kỳ, có thể được truy cập thông qua Quản lý dữ liệu > Quản lý lưu trữ > Xóa bảng xếp hạng theo chu kỳ.
-Thiết lập xóa sẽ được liên kết với mã bản đồ.`,
  OB41_UP_5: "Lưới mesh định vị động",
  OB41_UP_5_D: `1. Bật tính năng này bằng cách nhấn chọn Lưới Mesh Định vị động trong thiết lập quy trình.
2. Khi bật tính năng, việc cộng thêm, trừ bớt, hiển thị và đổ bóng động của vật thể không có thuộc tính Lưới Mesh định vị tĩnh và vật thể động được sinh ra sẽ ảnh hưởng đến đường tìm kiếm của NPC.
3. Bạn có thể sử dụng Debug để xuất file Navmesh từ máy chủ hiện tại để xem xét.`,
  OB42A_UP_1_D: `1. Tối ưu các tính năng cơ bản của Trình chỉnh sửa.
2. Cập nhật các tính năng hệ thống như trạng thái hoạt ảnh và hệ thống tập lệnh.`,
  OB42_UP_1: "Cửa hàng tài nguyên mới",
  OB42_UP_1_D: `1. Cấu trúc gói tham khảo: Gói tham khảo của nhà sáng tạo sẽ được mở như tài nguyên công cộng cho mọi người dùng tải về.
2. Thêm loại gói tài nguyên tham khảo vào quá trình nhập gói tài nguyên và mở chọn root log.
3. Đăng nhập để truy cập vào Cửa hàng tài nguyên và kho lưu trữ
4. Mở quá trình chín bao gồm "Tạo > Tải lên > Tải xuống > Nhập liệu".`,
  OB42_UP_2: "Hỗ trợ nhập mô hình khung xương và hoạt ảnh & các ứng dụng liên quan",
  OB42_UP_2_D: `1. Hỗ trợ nhập mô hình khung xương và file hoạt ảnh
2. Xem trước file hoạt ảnh và thêm các sự kiện tùy chỉnh vào dòng thời gian.`,
  OB42_UP_3: "Tối ưu chỉnh sửa địa hình",
  OB42_UP_3_D: `1. Cọ thảm thực vật mới: Cây cối và đá.
2. Thêm phím tắt để xóa nhanh thảm thực vật. Cọ vẽ + Shift: Xóa tất cả thảm thực vật trong phạm vi. Cọ vẽ + Ctrl: Chỉ xóa loại thực vật được chọn.
3. Thêm hiển thị phạm vi cọ vẽ.
4. Tối ưu logic làm mượt địa hình và thêm tính năng điều chỉnh kích cỡ bụi nhằm làm phẳng địa hình.`,
  OB42_UP_4: "Công cụ Debug trực quan mới",
  OB42_UP_4_D: `1. Trong khi đang debug, thuộc tính thực thể trong máy chủ có thể được xem và vị trí thực thể có thể được chỉnh sửa.
2. Xem số lượng thực thể trong máy chủ và dung lượng lưu trữ cần thiết.`,
  OB42_UP_5: "Tối ưu Vật lý",
  OB42_UP_5_D: `1. Bạn có thể tạo và chỉnh sửa các vật liệu vật lý nhằm tạo hiệu ứng nảy và ma sát cho RigidBody.
2. Bạn có thể điều chỉnh Trọng lực trên toàn bản đồ.
3. Bạn có thể đặt RigidBody ở trạng thái ngủ hoặc đánh thức nó.`,
  OB42_UP_6: "Các chỉnh sửa tối ưu khác",
  OB42_UP_6_D: `1. Các khối đang được sử dụng giờ sẽ hỗ trợ tìm kiếm toàn cục (qua các tập lệnh khác nhau).
2. Tham khảo Clip cho file ECA giờ sẽ hỗ trợ tìm kiếm toàn cục.`,
  OB43A_UP_1: "Tối ưu cơ bản",
  OB43A_UP_1_D: `1. Tối ưu các tính năng hiển thị của dự án.
2. Thêm phần mô tả vào Trường cảnh.
3. Sửa một số vấn đề liên quan đến điều chỉnh cấu trúc của Craftland Studio.
4. Sửa các lỗi khác.`,
  OB43_UP_1: "Logic Máy khách",
  OB43_UP_1_D: `1. Thêm các file ECAC và FCGC giúp tạo khối liên quan đến client và logic tập lệnh.
2. Khối tương tác sẽ được hiển thị ở cả file ECA và ECAC, trong khi các khối không tương tác và chỉ có ở một bên sẽ chỉ hiển thị ở bên tương ứng.
3. Giao tiếp giữa tập lệnh server và client giờ sẽ được hỗ trợ thông qua sự kiện tùy chỉnh.`,
  OB43_UP_2: "Tối ưu cấu trúc",
  OB43_UP_2_D: `1. Cập nhật cấu trúc của Craftland Studio.
2. Thay đổi quản lý file từ mức độ trình chỉnh sửa thành mức độ tệp tin.
3. Cập nhật và mở rộng thanh menu.
4. Thay đổi vị trí của thanh công cụ/tính năng debug/thiết lập debug.
5. Loại bỏ phần phản hồi qua khảo sát và quản lý tài khoản.
6. Tạm tắt tính năng tạo mẫu.`,
  OB43_UP_3: "Tính năng Camera mới",
  OB43_UP_3_D: '1. Thêm tính năng Góc nhìn thứ nhất Cần chọn "Sử dụng tài nguyên FPP mới nhất" để sử dụng. Hiện chỉ mở cho SCAR.',
  OB43_UP_4: "Tính năng vật lý mới",
  OB43_UP_4_D: "1. Thêm tính năng điều khiển nhân vật.",
  OB43_UP_5: "Tối ưu cập nhật & Trình chỉnh sửa",
  OB43_UP_5_D: `1. Cho phép tự cập nhật. Khi khởi động Craftland Studio, sẽ tự động kiểm tra cập nhật phiên bản và thông báo cho người dùng nếu có phiên bản mới.
2. Thêm tính năng Kiểm tra cập nhật vào thanh menu. Có thể sử dụng tính năng này để kiểm tra phiên bản mới.
3. Tang cường hiệu năng của trình thiết kế khối và giảm độ lag khi làm việc với một lượng lớn khối.
4. Tối ưu hiệu năng của Trường cảnh và logic di chuyển của các vật thể được gom chọn.
5. Thêm tính năng debug UI vào Trường cảnh.`,
  OB43_UP_6: "Nhân vật tùy chỉnh",
  OB43_UP_6_D: `1. Hỗ trợ truy cập trò chơi với nhân vật/bộ chiến thuật Free Fire được chọn (theo file).
2. Tạo một kiểu file mới để lưu trữ tất cả thông tin thiết lập cho bộ chiến thuật.
3. Bộ chiến thuật cho phép thiết lập mô hình nhân vật và đa phần các cử động của nhân vật.
4. Cung cấp file rig của Free Fire cho người dùng.`,
  OB43_UP_7: "Tối ưu bản đồ",
  OB43_UP_7_D: `1. Thêm tính năng xử lý Tĩnh, cho phép kết xuất vật thể cục bộ mà không cần xử lý logic, giúp tối ưu hiệu năng.
2. Cho phép tùy chỉnh kết xuất vật thể trường cảnh nhằm điều khiển logic tải vật thể trên máy client (yêu cầu bật xử lý Tĩnh).
3. Nâng cấp tính năng Kết hợp vật thể trước đây nhằm tối ưu hiệu năng kết xuất, cho phép các lựa chọn như gộp hoặc kết hợp mô hình. Có thể xem chi tiết tại tài liệu về Craftland Studio.
4. Giảm kích thước tải xuống của tài nguyên tùy chỉnh.`,
  OB43_UP_8: "Tính năng tập lệnh mới",
  OB43_UP_8_D: `1. Thêm tính năng đăng ký tài nguyên tập lệnh.
2. Thêm tính năng truy cập nhanh vào định nghĩa hàm trong tập lệnh plug-in.`,
  OB44_UP_1: "Logic Máy Khách",
  OB44_UP_1_D: `1. Mở thêm các logic API hỗ trợ  máy khách. 
2. Có thể bật hoặc tắt việc đồng bộ dữ liệu cho vật thể trường cảnh trong thiết lập thuộc tính vật thể.`,
  OB44_UP_2: "Tối ưu hóa hiệu năng",
  OB44_UP_2_D: `1. Thêm thiết lập phạm vi kết xuất trường cảnh nhằm giảm tải bộ nhớ.
2. Cho phép tắt tính năng tìm đường tĩnh cho các vật thể trường cảnh.
3. Thêm tính năng tự động tinh giản lưới mesh dựa trên các kích thước và khoảng cách khác nhau của mô hình.`,
  OB44_UP_3: "Các tối ưu hóa khác",
  OB44_UP_3_D: `1. Tập lệnh giờ sẽ hỗ trợ kiểm thử đơn vị, cập nhật plug-in tự động, và và định nghĩa trực tiếp các nội dung tùy chọn. 
2. Thêm camera góc nhìn thứ nhất của Free Fire cổ điển. 
3. Tăng cường hệ thống vật lý vững chắc hơn, cho phép các vật thể trong trò chơi hoạt động đúng theo vật lý. 
4. Tối ưu hóa trải nghiệm chung cho người dùng.`,
  T_0_B_BotCanRevive: "Máy hồi sinh",
  T_0_B_ReviveCDTime: "Đếm ngược hồi sinh",
  T_37_M_WS_CONTENTERROR: "Lỗi nội dung. Vui lòng thay đổi.",
  T_37_M_WS_PARANULL: "Giá trị thuộc tính không thể bỏ trống. Vui lòng nhập giá trị.",
  T_37_WT_M_PARACHANGE: "Thiết lập thất bại. Đã đạt số lượng tham số phòng tối đa.",
  T_38_M_WS_CONFIG: "Thiết lập Tham số",
  T_38_M_WS_CREATECONFIG: "Thiết lập Tham số Phòng",
  T_38_M_WS_CREATEDEL: "Loại bỏ khỏi Tham số Phòng",
  T_38_M_WS_CREATENAME: "Tên Tham số Phòng",
  T_38_M_WS_DELATT: "Xóa thuộc tính",
  T_38_M_WS_DELATTTIPS: "Thuộc tính này đã được chuyển thành kiểu Tham số phòng. Xác nhận xóa thuộc tính này?",
  T_38_M_WS_DISPLAYMODE: "Hiển thị Tham số",
  T_38_M_WS_DOWN: "Chuyển xuống",
  T_38_M_WS_EDIT: "Chỉnh sửa Tham số",
  T_38_M_WS_MODIFY: "Chuyển thành Tham số Phòng",
  T_38_M_WS_MUTIPLE: "Danh sách đa lựa chọn",
  T_38_M_WS_RANGE: "Phạm vi",
  T_38_M_WS_ROOMPAR: "Tham số phòng tùy chỉnh",
  T_38_M_WS_SINGLE: "Danh sách lựa chọn đơn",
  T_38_M_WS_UP: "Chuyển lên",
  T_46_TYC_ADD_SP_ERROR: "Lỗi thiết lập AOI: Thêm vào danh sách xem thất bại. Người được xem = {0}, người xem {0}",
  T_46_TYC_AOI_SP_PARAMS_ERROR: "Lỗi thiết lập AOI: lỗi tham số. Người được xem = {0}, người xem {0}",
  T_46_TYC_AOI_SUPO_INVALID_OBSERVER_ERROR: "Lỗi thiết lập AOI: Người được xem không phải là người chơi hoặc thực thể hợp lệ khi đổi người xem. Người được xem = {0}, người xem {0}",
  T_46_TYC_AOI_SUPO_INVALID_USER_ERROR: "Lỗi thiết lập AOI: người chơi không phải là một người dùng hợp lệ khi chuyển đổi người xem. Người được xem = {0}, người xem {0}",
  T_46_TYC_AOI_SUPO_PARAMS_ERROR: "Lỗi thiết lập AOI: Lỗi chuyển đổi tham số proxy người xem. Người được xem = {0}, người xem {0}",
  T_46_TYC_CLEAN_SP_ERROR: "Lỗi thiết lập AOI: Xóa danh sách xem thất bại. Người được xem = {0}, người xem {0}",
  T_46_TYC_REMOVE_SP_ERROR: "Lỗi thiết lập AOI: Loại bỏ khỏi danh sách xem thất bại. Người được xem = {0}, người xem {0}",
  T_46_TYC_SP_INVALID_USER_ERROR: "Lỗi thiết lập AOI: người xem không hợp lệ. Người được xem = {0}, người xem {0}",
  T_47_HL_CL_RECOMMEND_MORE: "Xem thêm",
  T_ACTIVATE_LOGIN_ACCOUNT: "Tài khoản đã đăng nhập:",
  T_ACTIVATE_TITLE: "Kích hoạt Craftland Studio.",
  T_CONFIRMBOX_ACTIVATE_SUCCESS: "Tài khoản đã được kích hoạt",
  T_CONFIRMBOX_QUIT_CONTENT: "Hành động này sẽ thoát Craftland Studio. Xác nhận tiếp tục?",
  T_CONFIRMBOX_TITLE: "Thông báo",
  T_DIALOG_CONFIRM: "Kích hoạt",
  T_ENTER_ACTIVATE_CODE: "Craftland Studio đang được thử nghiệm. Vui lòng nhập mã kích hoạt được cung cấp bởi nhà phát hành.",
  UI_DES: "Bố cục bảng thường được sử dụng để xây dựng hệ thống Balo, bởi nó sẽ giúp sắp xếp các thành tố con nhanh hơn",
  UI_DES_1: "Bố cục lấp đầy thường được sử dụng để nhanh chóng thêm đều các thành tố con dưới một thành tố mẹ",
  UI_NAME: "Mẫu bố cục bảng",
  UI_NAME_1: "Mẫu bố cục lấp đầy"
};
export {
  _ as default
};
